(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const menuDisclosures = document.querySelectorAll('[data-footer-menu-disclosure]');
    const menuSummaries = document.querySelectorAll('.site-footer__menu-summary');
    const wraps = document.querySelectorAll('[data-footer-payments-wrap]');
    if (!menuDisclosures.length && !wraps.length) {
      return;
    }

    const desktopQuery = window.matchMedia('(min-width: 960px)');
    const mobileQuery = window.matchMedia('(max-width: 959px)');

    const syncMenuDisclosures = () => {
      const isDesktop = desktopQuery.matches;

      menuDisclosures.forEach((disclosure) => {
        disclosure.open = isDesktop;
      });

      menuSummaries.forEach((summary) => {
        if (isDesktop) {
          summary.setAttribute('tabindex', '-1');
        } else {
          summary.removeAttribute('tabindex');
        }
      });
    };

    const syncWrap = (wrap) => {
      const label = wrap.querySelector('[data-footer-payments-label]');
      const list = wrap.querySelector('[data-footer-payments]');
      if (!label || !list) {
        return;
      }

      const items = Array.from(list.children);
      const rowOffsets = new Set(items.map((item) => item.offsetTop));
      const isWrapped = mobileQuery.matches && rowOffsets.size > 1;
      label.hidden = !isWrapped;
      wrap.classList.toggle('is-wrapped', isWrapped);
    };

    const scheduleSync = (wrap) => {
      window.requestAnimationFrame(() => syncWrap(wrap));
    };

    wraps.forEach((wrap) => {
      scheduleSync(wrap);

      const list = wrap.querySelector('[data-footer-payments]');
      if (list && 'ResizeObserver' in window) {
        const observer = new ResizeObserver(() => scheduleSync(wrap));
        observer.observe(list);
      }
    });

    menuSummaries.forEach((summary) => {
      summary.addEventListener('click', (event) => {
        if (desktopQuery.matches) {
          event.preventDefault();
        }
      });
    });

    const handlePaymentsViewport = () => {
      wraps.forEach((wrap) => scheduleSync(wrap));
    };

    syncMenuDisclosures();
    handlePaymentsViewport();

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', syncMenuDisclosures);
    } else if (typeof desktopQuery.addListener === 'function') {
      desktopQuery.addListener(syncMenuDisclosures);
    }

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handlePaymentsViewport);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(handlePaymentsViewport);
    }

    window.addEventListener('resize', handlePaymentsViewport, { passive: true });
    window.addEventListener('load', handlePaymentsViewport, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-home-reviews-root]');
    if (!roots.length) {
      return;
    }

    const desktopQuery = window.matchMedia('(min-width: 960px)');

    const buildDots = (track, dotsRoot, items) => {
      const visibleCount = desktopQuery.matches ? 3 : 1;
      const pageStarts = [];
      for (let index = 0; index < items.length; index += visibleCount) {
        pageStarts.push(index);
      }

      if (pageStarts.length <= 1) {
        dotsRoot.hidden = true;
        dotsRoot.innerHTML = '';
        return;
      }

      dotsRoot.hidden = false;
      dotsRoot.innerHTML = '';

      const syncActiveDot = () => {
        const scrollLeft = track.scrollLeft;
        let activePage = 0;
        let smallestDistance = Infinity;

        pageStarts.forEach((startIndex, pageIndex) => {
          const card = items[startIndex];
          if (!card) {
            return;
          }

          const distance = Math.abs(card.offsetLeft - scrollLeft);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            activePage = pageIndex;
          }
        });

        dotsRoot.querySelectorAll('[data-home-reviews-dot]').forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === activePage);
          dot.setAttribute('aria-current', dotIndex === activePage ? 'true' : 'false');
        });
      };

      pageStarts.forEach((startIndex, pageIndex) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'home-index__carousel-dot';
        button.setAttribute('data-home-reviews-dot', '');
        button.setAttribute('aria-label', `Go to review page ${pageIndex + 1}`);
        button.addEventListener('click', () => {
          items[startIndex]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsRoot.appendChild(button);
      });

      let scrollFrame = null;
      const onScroll = () => {
        if (scrollFrame) {
          return;
        }

        scrollFrame = window.requestAnimationFrame(() => {
          syncActiveDot();
          scrollFrame = null;
        });
      };

      if (track.dataset.dotScrollBound !== 'true') {
        track.dataset.dotScrollBound = 'true';
        track.addEventListener('scroll', onScroll, { passive: true });
      }

      syncActiveDot();
    };

    const prepareReviewCards = (widget, dotsRoot) => {
      const track = widget.querySelector('.jdgm-rev-widg__reviews');
      if (!track) {
        return { hasItems: false };
      }

      track.classList.add('home-index__reviews-track-ready');
      const items = Array.from(widget.querySelectorAll('.jdgm-rev, .jdgm-carousel-item'));
      if (!items.length) {
        dotsRoot.hidden = true;
        dotsRoot.innerHTML = '';
        return { hasItems: false };
      }

      items.forEach((item) => {
        item.hidden = false;
        item.classList.add('home-index__review-card');
      });

      buildDots(track, dotsRoot, items);
      return { hasItems: true };
    };

    const bindReviewRoot = (root) => {
      const widget = root.querySelector('[data-home-reviews-widget]');
      const dotsRoot = root.querySelector('[data-home-reviews-dots]');
      if (!widget || !dotsRoot) {
        return;
      }

      let isInitializing = false;
      const initialize = () => {
        if (isInitializing) {
          return;
        }

        isInitializing = true;
        prepareReviewCards(widget, dotsRoot);
        isInitializing = false;
      };

      if (widget.dataset.observerBound !== 'true') {
        widget.dataset.observerBound = 'true';
        const observer = new MutationObserver(initialize);
        observer.observe(widget, { childList: true, subtree: true });
      }

      if (root.dataset.mediaQueryBound !== 'true') {
        root.dataset.mediaQueryBound = 'true';
        const rerenderDots = () => window.setTimeout(initialize, 50);
        if (typeof desktopQuery.addEventListener === 'function') {
          desktopQuery.addEventListener('change', rerenderDots);
        } else if (typeof desktopQuery.addListener === 'function') {
          desktopQuery.addListener(rerenderDots);
        }
      }

      initialize();
      window.setTimeout(initialize, 700);
      window.setTimeout(initialize, 1500);
      window.setTimeout(initialize, 2800);
    };

    roots.forEach(bindReviewRoot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-faq"]) return;
  try {
    
  (() => {
    const wrappers = document.querySelectorAll('.faq-page');

    wrappers.forEach((wrapper) => {
      const nav = wrapper.querySelector('[data-faq-category-nav]');
      if (!nav) return;

      const buttons = Array.from(nav.querySelectorAll('[data-faq-category-button]'));
      const groups = Array.from(wrapper.querySelectorAll('[data-faq-group]'));
      if (!buttons.length || !groups.length) return;

      const setActiveCategory = (category) => {
        buttons.forEach((button) => {
          const isActive = button.getAttribute('data-faq-category-button') === category;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const updateActiveFromHash = () => {
        const hash = window.location.hash.replace('#', '');
        const matchedGroup = groups.find((group) => group.id === hash);
        const category = matchedGroup?.getAttribute('data-faq-group') || buttons[0].getAttribute('data-faq-category-button');
        if (!category) return;
        setActiveCategory(category);
      };

      updateActiveFromHash();

      const observer = new IntersectionObserver(
        (entries) => {
          const visibleEntries = entries
            .filter((entry) => entry.isIntersecting)
            .sort((entryA, entryB) => entryA.boundingClientRect.top - entryB.boundingClientRect.top);

          if (!visibleEntries.length) return;

          const category = visibleEntries[0].target.getAttribute('data-faq-group');
          if (!category) return;
          setActiveCategory(category);
        },
        {
          rootMargin: '-25% 0px -55% 0px',
          threshold: [0.1, 0.25, 0.5]
        }
      );

      groups.forEach((group) => observer.observe(group));

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const category = button.getAttribute('data-faq-category-button');
          if (!category) return;
          setActiveCategory(category);
        });
      });

      window.addEventListener('hashchange', updateActiveFromHash);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-generic"]) return;
  try {
    
  (() => {
    const slugify = (value) =>
      value
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');

    const isLikelyHeading = (title) => {
      if (!title) return false;
      if (title.startsWith('SECTION') || title === 'OVERVIEW') return true;

      const clean = title.replace(/[^A-Za-z]/g, '');
      if (!clean.length) return false;
      const upperRatio = clean.replace(/[^A-Z]/g, '').length / clean.length;
      return upperRatio > 0.75 && title.length <= 120;
    };

    document.querySelectorAll('.main-page-generic--legal').forEach((wrapper) => {
      const rte = wrapper.querySelector('[data-page-generic-legal-rte]');
      const tocWrapper = wrapper.querySelector('[data-page-generic-legal-toc-wrapper]');
      const tocList = wrapper.querySelector('[data-page-generic-legal-toc]');
      if (!rte || !tocWrapper || !tocList) return;

      const sections = [];
      const seenTitles = new Set();
      const strongNodes = rte.querySelectorAll('p > strong, p strong');

      strongNodes.forEach((strongNode, idx) => {
        const title = (strongNode.textContent || '').trim();
        if (!isLikelyHeading(title) || seenTitles.has(title)) return;

        const hostParagraph = strongNode.closest('p');
        if (!hostParagraph) return;

        const safeId = `legal-section-${idx + 1}-${slugify(title)}`;
        hostParagraph.id = safeId;
        hostParagraph.classList.add('main-page-generic__legal-title');
        sections.push({ id: safeId, title });
        seenTitles.add(title);
      });

      if (!sections.length) return;

      sections.forEach((sectionItem) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${sectionItem.id}`;
        a.textContent = sectionItem.title;
        li.appendChild(a);
        tocList.appendChild(li);
      });

      tocWrapper.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindReviewVideos = (root) => {
      const pauseOtherVideos = (activeVideo) => {
        document.querySelectorAll('[data-review-video]').forEach((video) => {
          if (video === activeVideo) return;
          video.pause();
        });
      };

      root.querySelectorAll('[data-review-video-shell]').forEach((shell) => {
        if (shell.dataset.reviewVideoBound === 'true') return;
        shell.dataset.reviewVideoBound = 'true';

        const video = shell.querySelector('[data-review-video]');
        const toggle = shell.querySelector('[data-review-video-toggle]');
        if (!video || !toggle) return;

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          shell.classList.toggle('is-playing', isPlaying);
          toggle.setAttribute('aria-label', isPlaying ? 'Pause customer review video' : 'Play customer review video');
        };

        toggle.addEventListener('click', () => {
          if (!video.paused && !video.ended) {
            video.pause();
            return;
          }

          pauseOtherVideos(video);
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });

        video.addEventListener('click', () => {
          if (!video.paused && !video.ended) {
            video.pause();
          }
        });

        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', () => {
          video.currentTime = 0;
          syncState();
        });

        syncState();
      });
    };

    const parseRatingText = (value) => {
      if (!value) {
        return null;
      }

      const match = String(value).match(/([0-5](?:[.,]\d+)?)/);
      if (!match) {
        return null;
      }

      const numeric = Number.parseFloat(match[1].replace(',', '.'));
      return Number.isNaN(numeric) ? null : numeric;
    };

    const getRating = (item) => {
      if (!item) {
        return 0;
      }

      const directRating = Number.parseFloat(item.getAttribute('data-rating') || item.dataset.rating || '');
      if (!Number.isNaN(directRating)) {
        return directRating;
      }

      const dataScoreEls = item.querySelectorAll('[data-score]');
      for (const scoreEl of dataScoreEls) {
        const value = Number.parseFloat(scoreEl.getAttribute('data-score'));
        if (!Number.isNaN(value)) {
          return value;
        }
      }

      const ariaEls = item.querySelectorAll('[aria-label]');
      for (const ariaEl of ariaEls) {
        const value = parseRatingText(ariaEl.getAttribute('aria-label'));
        if (value !== null) {
          return value;
        }
      }

      const filledStars = item.querySelectorAll('.jdgm-star.jdgm--on, .jdgm-star.jdgm-star--on, .jdgm-star.jdgm-star--full').length;
      if (filledStars > 0) {
        return filledStars;
      }

      return parseRatingText(item.textContent) || 0;
    };

    const getHighestRatingSortOption = (sortSelect) => {
      if (!sortSelect || !sortSelect.options) {
        return null;
      }

      const sortMatchers = [
        /highest/i,
        /rating.*(?:high|desc)/i,
        /(?:high|desc).*rating/i,
        /top.*rated/i
      ];

      return Array.from(sortSelect.options).find((option) => {
        const haystack = `${option.value || ''} ${option.textContent || ''}`.trim();
        return sortMatchers.some((matcher) => matcher.test(haystack));
      }) || null;
    };

    const enforceHighestRatingSort = (reviewWidget) => {
      if (reviewWidget.dataset.sortPrimed === 'true') {
        return false;
      }

      const sortSelect = reviewWidget.querySelector('.jdgm-sort-dropdown');
      if (!sortSelect) {
        return false;
      }

      const highestOption = getHighestRatingSortOption(sortSelect);
      if (!highestOption) {
        reviewWidget.dataset.sortPrimed = 'true';
        return false;
      }

      const shouldChange = sortSelect.value !== highestOption.value;
      if (shouldChange) {
        sortSelect.value = highestOption.value;
        sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      reviewWidget.dataset.sortPrimed = 'true';
      return shouldChange;
    };

    const asPdpReviewList = (reviewWidget) => {
      const reviewsTrack = reviewWidget.querySelector('.jdgm-rev-widg__reviews');
      if (reviewsTrack) {
        reviewsTrack.classList.add('reviews-page__reviews-list-ready');
      }

      const items = Array.from(reviewWidget.querySelectorAll('.jdgm-rev, .jdgm-carousel-item'));
      if (!items.length) {
        return { didReorder: false };
      }

      const fiveStarItems = items.filter((item) => getRating(item) >= 5);
      const nonFiveStarItems = items.filter((item) => !fiveStarItems.includes(item));
      const orderedItems = fiveStarItems.length ? fiveStarItems.concat(nonFiveStarItems) : items;
      const isAlreadyOrdered = orderedItems.every((item, index) => item === items[index]);

      if (reviewsTrack && !isAlreadyOrdered) {
        const fragment = document.createDocumentFragment();
        orderedItems.forEach((item) => {
          fragment.appendChild(item);
        });
        reviewsTrack.appendChild(fragment);
      }

      items.forEach((item) => {
        item.hidden = false;
        item.classList.add('reviews-page__review-item');
      });

      return { didReorder: !isAlreadyOrdered };
    };

    const bindReviewWidget = (root) => {
      const reviewWidget = root.querySelector('[data-reviews-widget]');
      if (!reviewWidget) {
        return;
      }

      let isInitializing = false;
      const initialize = () => {
        if (isInitializing) {
          return;
        }

        isInitializing = true;
        const didSortChange = enforceHighestRatingSort(reviewWidget);
        const result = asPdpReviewList(reviewWidget);
        isInitializing = false;

        if (didSortChange || result.didReorder) {
          window.setTimeout(initialize, 450);
        }
      };

      if (reviewWidget.dataset.observerBound !== 'true') {
        reviewWidget.dataset.observerBound = 'true';
        const observer = new MutationObserver(initialize);
        observer.observe(reviewWidget, { childList: true, subtree: true });
        root.__reviewsWidgetObserver = observer;
      }

      initialize();
      window.setTimeout(initialize, 700);
      window.setTimeout(initialize, 1500);
      window.setTimeout(initialize, 2800);
    };

    const initReviewsPage = (root) => {
      if (!root || root.dataset.reviewsPageReady === 'true') return;
      root.dataset.reviewsPageReady = 'true';

      root.querySelectorAll('[data-review-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const card = button.closest('[data-review-card]');
          if (!card) return;

          const expanded = button.getAttribute('aria-expanded') === 'true';
          card.classList.toggle('is-expanded', !expanded);
          button.setAttribute('aria-expanded', String(!expanded));
          button.textContent = expanded ? 'Read more' : 'Read less';
        });
      });

      bindReviewVideos(root);

      bindReviewWidget(root);
    };

    document.querySelectorAll('[data-reviews-page]').forEach(initReviewsPage);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-reviews-page]')
        ? event.target
        : event.target.querySelector('[data-reviews-page]');

      initReviewsPage(root);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches('[data-reviews-page]')
        ? event.target
        : event.target.querySelector('[data-reviews-page]');

      if (root && root.__reviewsWidgetObserver) {
        root.__reviewsWidgetObserver.disconnect();
        delete root.__reviewsWidgetObserver;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-hero-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-product-hero-section][data-product-hero-version="v2"]');
    if (!roots.length) {
      return;
    }

    const requestVideoPlay = (video) => {
      if (!video) {
        return;
      }

      if (video.preload === 'none' || video.preload === 'metadata') {
        video.preload = 'auto';
      }

      if (video.readyState < 2 && video.dataset.playRetryBound !== 'true') {
        video.dataset.playRetryBound = 'true';
        video.addEventListener(
          'canplay',
          () => {
            video.dataset.playRetryBound = 'false';
            const retryPromise = video.play();
            if (retryPromise && typeof retryPromise.catch === 'function') {
              retryPromise.catch(() => {});
            }
          },
          { once: true }
        );

        if (video.networkState === video.NETWORK_EMPTY) {
          try {
            video.load();
          } catch (error) {}
        }
      }

      video.dataset.userPaused = 'false';
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const bindCarousel = (root) => {
      const track = root.querySelector('[data-hero-track]');
      const dotsWrap = root.querySelector('[data-hero-dots]');
      const prevArrow = root.querySelector('[data-hero-prev]');
      const nextArrow = root.querySelector('[data-hero-next-arrow]');
      if (!track || !dotsWrap) {
        return;
      }

      const slides = Array.from(track.querySelectorAll('.product-hero__media-slide'));
      if (slides.length < 2) {
        return;
      }

      dotsWrap.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-hero__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => {
          scrollToSlide(index);
        });
        dotsWrap.appendChild(dot);
      });

      const dots = Array.from(dotsWrap.querySelectorAll('.product-hero__dot'));
      let activeIndex = 0;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const motionBehavior = prefersReducedMotion.matches ? 'auto' : 'smooth';

      const scrollToSlide = (index) => {
        const boundedIndex = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[boundedIndex].offsetLeft, behavior: motionBehavior });
      };

      const syncActiveMedia = () => {
        slides.forEach((slide, index) => {
          slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
          const video = slide.querySelector('[data-hero-video]');
          if (!video) {
            return;
          }

          if (index !== activeIndex) {
            video.pause();
            video.dataset.userPaused = 'false';
            return;
          }

          if (prefersReducedMotion.matches) {
            return;
          }

          if (video.dataset.userPaused === 'true') {
            return;
          }

          requestVideoPlay(video);
        });
      };

      const syncDots = () => {
        const center = track.scrollLeft + track.clientWidth * 0.45;
        let nextActiveIndex = 0;

        slides.forEach((slide, index) => {
          if (slide.offsetLeft <= center) {
            nextActiveIndex = index;
          }
        });

        activeIndex = nextActiveIndex;
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
        if (prevArrow && nextArrow) {
          prevArrow.hidden = false;
          nextArrow.hidden = false;
          prevArrow.disabled = activeIndex <= 0;
          nextArrow.disabled = activeIndex >= slides.length - 1;
        }
        syncActiveMedia();
      };

      if (prevArrow && prevArrow.dataset.bound !== 'true') {
        prevArrow.dataset.bound = 'true';
        prevArrow.addEventListener('click', () => {
          scrollToSlide(activeIndex - 1);
        });
      }

      if (nextArrow && nextArrow.dataset.bound !== 'true') {
        nextArrow.dataset.bound = 'true';
        nextArrow.addEventListener('click', () => {
          scrollToSlide(activeIndex + 1);
        });
      }

      syncDots();
      track.addEventListener('scroll', syncDots, { passive: true });
      window.addEventListener('resize', syncDots);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          slides.forEach((slide) => {
            const video = slide.querySelector('[data-hero-video]');
            if (video) {
              video.pause();
            }
          });
          return;
        }

        syncActiveMedia();
      });
    };

    const bindHeroVideos = (root) => {
      const pauseOtherVideos = (activeVideo) => {
        root.querySelectorAll('[data-hero-video]').forEach((video) => {
          if (video === activeVideo) {
            return;
          }

          video.dataset.userPaused = 'false';
          video.pause();
        });
      };

      root.querySelectorAll('[data-hero-video-shell]').forEach((shell) => {
        if (shell.dataset.videoBound === 'true') {
          return;
        }
        shell.dataset.videoBound = 'true';

        const video = shell.querySelector('[data-hero-video]');
        const toggle = shell.querySelector('[data-hero-video-toggle]');
        if (!video || !toggle) {
          return;
        }

        video.controls = false;

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          shell.classList.toggle('is-playing', isPlaying);
          toggle.setAttribute('aria-label', isPlaying ? 'Pause product video' : 'Play product video');
        };

        const togglePlayback = () => {
          if (!video.paused && !video.ended) {
            video.dataset.userPaused = 'true';
            video.pause();
            return;
          }

          pauseOtherVideos(video);
          video.dataset.userPaused = 'false';
          requestVideoPlay(video);
        };

        toggle.addEventListener('click', togglePlayback);
        video.addEventListener('click', togglePlayback);
        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', syncState);
        syncState();
      });
    };

    const bindSwipeHint = (root) => {
      const hint = root.querySelector('[data-swipe-hint]');
      if (!hint) {
        return;
      }

      const seenKey = 'glarisePdpSwipeHintSeen';
      let hasSeenHint = false;

      try {
        hasSeenHint = window.sessionStorage.getItem(seenKey) === 'true';
      } catch (error) {
        hasSeenHint = false;
      }

      if (hasSeenHint) {
        hint.classList.add('is-hidden');
        return;
      }

      window.setTimeout(() => {
        hint.classList.add('is-hidden');

        try {
          window.sessionStorage.setItem(seenKey, 'true');
        } catch (error) {}
      }, 2000);
    };

    const bindLightbox = (root) => {
      const dialog = root.querySelector('[data-hero-lightbox]');
      const content = root.querySelector('[data-hero-lightbox-content]');
      const caption = root.querySelector('[data-hero-lightbox-caption]');
      const closeButton = root.querySelector('[data-hero-lightbox-close]');
      const triggers = Array.from(root.querySelectorAll('[data-hero-lightbox-trigger]'));
      if (!dialog || !content || !closeButton || !triggers.length || typeof dialog.showModal !== 'function') {
        return;
      }

      let returnFocusTarget = null;

      const closeLightbox = () => {
        dialog.close();
      };

      const restoreFocus = () => {
        if (returnFocusTarget && typeof returnFocusTarget.focus === 'function') {
          returnFocusTarget.focus();
        }
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const src = trigger.getAttribute('data-lightbox-src');
          const alt = trigger.getAttribute('data-lightbox-alt') || '';
          if (!src) {
            return;
          }

          const image = document.createElement('img');
          image.src = src;
          image.alt = alt;
          content.replaceChildren(image);

          if (caption) {
            caption.textContent = alt;
            caption.hidden = !alt;
          }

          returnFocusTarget = trigger;
          dialog.showModal();
          closeButton.focus();
        });
      });

      closeButton.addEventListener('click', closeLightbox);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeLightbox();
        }
      });
      dialog.addEventListener('close', restoreFocus);
    };

    const bindTestimonialRail = (root) => {
      const rail = root.querySelector('.product-hero__testimonial-rail');
      const controls = root.querySelector('[data-testimonial-controls]');
      const prevButton = root.querySelector('[data-testimonial-prev]');
      const nextButton = root.querySelector('[data-testimonial-next]');
      if (!rail || !controls || !prevButton || !nextButton) {
        return;
      }

      const cards = Array.from(rail.querySelectorAll('.product-hero__testimonial'));
      if (cards.length < 2) {
        return;
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;

      const updateActiveIndex = () => {
        const center = rail.scrollLeft + rail.clientWidth * 0.5;
        let nextActiveIndex = 0;

        cards.forEach((card, index) => {
          if (card.offsetLeft <= center) {
            nextActiveIndex = index;
          }
        });

        activeIndex = nextActiveIndex;
        prevButton.disabled = activeIndex <= 0;
        nextButton.disabled = activeIndex >= cards.length - 1;
      };

      const syncControls = () => {
        controls.hidden = false;
        updateActiveIndex();
      };

      const scrollToCard = (index) => {
        const boundedIndex = Math.max(0, Math.min(cards.length - 1, index));
        rail.scrollTo({ left: cards[boundedIndex].offsetLeft, behavior: prefersReducedMotion.matches ? 'auto' : 'smooth' });
      };

      prevButton.addEventListener('click', () => {
        scrollToCard(activeIndex - 1);
      });

      nextButton.addEventListener('click', () => {
        scrollToCard(activeIndex + 1);
      });

      rail.addEventListener('scroll', updateActiveIndex, { passive: true });
      window.addEventListener('resize', syncControls);

      syncControls();
    };

    const bindBuyDisclosures = (root) => {
      const disclosures = Array.from(root.querySelectorAll('[data-buy-disclosure]'));
      if (!disclosures.length) {
        return;
      }

      const desktopQuery = window.matchMedia('(min-width: 960px)');
      const syncDisclosures = () => {
        disclosures.forEach((disclosure) => {
          disclosure.open = desktopQuery.matches;
        });
      };

      syncDisclosures();
      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', syncDisclosures);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(syncDisclosures);
      }
    };

    const bindBundles = (root) => {
      const options = Array.from(root.querySelectorAll('[data-bundle-option]'));
      if (!options.length) {
        return;
      }

      const productForm = root.querySelector('form.product-hero__mock-form');
      const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
      const qtyInput = root.querySelector('[data-selected-bundle-qty]');
      const mainAtcLabel = root.querySelector('[data-main-atc-label]');
      const mainAtcBaseLabel = mainAtcLabel ? (mainAtcLabel.getAttribute('data-base-label') || '').trim() : '';
      const mainSubmit = productForm ? productForm.querySelector('[data-direct-checkout-submit]') : null;
      const stickyButtons = Array.from(root.querySelectorAll('[data-sticky-bundle-option]'));
      const stickyLabel = root.querySelector('[data-sticky-bundle-label]');
      const stickyPrice = root.querySelector('[data-sticky-price]');
      const stickySubmit = root.querySelector('[data-sticky-submit]');
      const stickyBaseLabel = stickySubmit ? (stickySubmit.getAttribute('data-sticky-base-label') || '').trim() : '';

      const getSelectedPrice = (option) => {
        return option.getAttribute('data-bundle-selected-price') || '';
      };

      const getOptionKey = (option) => {
        return (option.getAttribute('data-bundle-pack-count') || option.getAttribute('data-bundle-variant-id') || '').trim();
      };

      const syncStickyButtons = (selectedOption) => {
        if (!stickyButtons.length) {
          return;
        }

        const selectedKey = getOptionKey(selectedOption);
        stickyButtons.forEach((button) => {
          const isActive = (button.getAttribute('data-bundle-key') || '').trim() === selectedKey;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const getSelectionDetail = (selectedOption) => {
        return {
          source: 'hero',
          variantId: selectedOption.getAttribute('data-bundle-variant-id') || '',
          qty: selectedOption.getAttribute('data-bundle-qty') || '1',
          label: selectedOption.getAttribute('data-bundle-label') || '',
          price: getSelectedPrice(selectedOption),
          packCount: selectedOption.getAttribute('data-bundle-pack-count') || ''
        };
      };

      const findOptionForDetail = (detail) => {
        if (!detail) {
          return null;
        }

        const detailVariantId = String(detail.variantId || '').trim();
        const detailPackCount = String(detail.packCount || '').trim();

        return options.find((option) => {
          const optionVariantId = (option.getAttribute('data-bundle-variant-id') || '').trim();
          const optionPackCount = (option.getAttribute('data-bundle-pack-count') || '').trim();

          if (detailVariantId && optionVariantId && detailVariantId === optionVariantId) {
            return true;
          }

          return detailPackCount && optionPackCount === detailPackCount;
        });
      };

      const announceSelection = (selectedOption) => {
        if (typeof window.CustomEvent !== 'function') {
          return;
        }

        window.dispatchEvent(
          new window.CustomEvent('glarise:pdp-bundle-change', {
            detail: getSelectionDetail(selectedOption)
          })
        );
      };

      const applySelection = (selectedOption, config = {}) => {
        options.forEach((option) => {
          const isActive = option === selectedOption;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const qty = selectedOption.getAttribute('data-bundle-qty') || '1';
        const label = selectedOption.getAttribute('data-bundle-label') || '';
        const price = getSelectedPrice(selectedOption);
        const bundleVariantId = selectedOption.getAttribute('data-bundle-variant-id') || '';

        if (variantInput && bundleVariantId) {
          variantInput.value = bundleVariantId;
        }

        if (qtyInput) {
          qtyInput.value = qty;
        }

        if (mainAtcLabel) {
          const ctaText = mainAtcBaseLabel || 'ORDER BEFORE WE CLOSE';
          mainAtcLabel.textContent = price ? `${ctaText} - ${price}` : ctaText;
        }

        if (stickyLabel) {
          stickyLabel.textContent = label;
        }

        if (stickyPrice) {
          stickyPrice.textContent = price;
        }

        if (stickySubmit) {
          const ctaText = stickyBaseLabel || 'ORDER BEFORE WE CLOSE';
          stickySubmit.textContent = price ? `${ctaText} - ${price}` : ctaText;
        }

        syncStickyButtons(selectedOption);

        if (config.announce !== false) {
          announceSelection(selectedOption);
        }
      };

      const navigateToCheckout = () => {
        const selectedQty = ((qtyInput ? qtyInput.value : '1') || '1').trim();
        const selectedVariantId = ((variantInput ? variantInput.value : '') || '').trim();

        if (!selectedVariantId) {
          return false;
        }

        const checkoutUrl = `/cart/${encodeURIComponent(selectedVariantId)}:${encodeURIComponent(selectedQty)}?checkout`;
        window.location.assign(checkoutUrl);
        return true;
      };

      options.forEach((option) => {
        option.addEventListener('click', () => applySelection(option));
      });

      if (stickyButtons.length) {
        stickyButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const buttonKey = (button.getAttribute('data-bundle-key') || '').trim();
            const selectedOption = options.find((option) => getOptionKey(option) === buttonKey);
            if (selectedOption) {
              applySelection(selectedOption);
            }
          });
        });
      }

      const activeOption = options.find((option) => option.classList.contains('is-active')) || options[0];
      if (activeOption) {
        applySelection(activeOption);
      }

      window.addEventListener('glarise:pdp-bundle-select', (event) => {
        const detail = event.detail || {};
        if (detail.source === 'hero') {
          return;
        }

        const matchedOption = findOptionForDetail(detail);
        if (matchedOption) {
          applySelection(matchedOption);
        }
      });

      if (productForm) {
        productForm.addEventListener('submit', (event) => {
          const submitter = event.submitter;
          const shouldDirectCheckout = !submitter || submitter.hasAttribute('data-direct-checkout-submit');
          if (!shouldDirectCheckout) {
            return;
          }

          event.preventDefault();

          if (!navigateToCheckout()) {
            productForm.submit();
          }
        });
      }

      if (stickySubmit) {
        stickySubmit.addEventListener('click', (event) => {
          event.preventDefault();

          if (productForm && typeof productForm.requestSubmit === 'function' && mainSubmit) {
            productForm.requestSubmit(mainSubmit);
            return;
          }

          if (!navigateToCheckout() && productForm) {
            productForm.submit();
          }
        });
      }
    };

    const bindStickyBar = (root) => {
      const stickyBar = root.querySelector('[data-sticky-bar]');
      const buyZone = root.querySelector('[data-buy-zone]');
      const bottomBundlePicker = root.ownerDocument.querySelector('[data-pdp-desktop-bundles]');
      const bottomBundleHandoffTarget = bottomBundlePicker ? bottomBundlePicker.querySelector('.pdp-desktop-bundles__header') : null;
      if (!stickyBar || !buyZone) {
        return;
      }

      const desktopQuery = window.matchMedia('(min-width: 960px)');
      let buyZoneObserver = null;
      let bottomBundleObserver = null;
      let buyZoneInView = true;
      let bottomBundleInView = false;

      const syncStickyVisibility = () => {
        stickyBar.classList.toggle('is-visible', !buyZoneInView && !bottomBundleInView);
      };

      const bindMode = () => {
        if (buyZoneObserver) {
          buyZoneObserver.disconnect();
          buyZoneObserver = null;
        }

        if (bottomBundleObserver) {
          bottomBundleObserver.disconnect();
          bottomBundleObserver = null;
        }

        if (!('IntersectionObserver' in window)) {
          buyZoneInView = false;
          bottomBundleInView = false;
          syncStickyVisibility();
          return;
        }

        buyZoneInView = true;
        bottomBundleInView = false;
        syncStickyVisibility();

        buyZoneObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            buyZoneInView = entry.isIntersecting;
            syncStickyVisibility();
          },
          { threshold: 0.2 }
        );

        buyZoneObserver.observe(buyZone);

        if (bottomBundleHandoffTarget) {
          bottomBundleObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              bottomBundleInView = entry.isIntersecting;
              syncStickyVisibility();
            },
            { threshold: 0.15 }
          );

          bottomBundleObserver.observe(bottomBundleHandoffTarget);
        }
      };

      bindMode();
      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', bindMode);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(bindMode);
      }
    };

    roots.forEach((root) => {
      bindHeroVideos(root);
      bindCarousel(root);
      bindSwipeHint(root);
      bindLightbox(root);
      bindTestimonialRail(root);
      bindBuyDisclosures(root);
      bindBundles(root);
      bindStickyBar(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-hero-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-product-hero-section][data-product-hero-version="v3"]');
    if (!roots.length) {
      return;
    }

    const requestVideoPlay = (video) => {
      if (!video) {
        return;
      }

      if (video.preload === 'none' || video.preload === 'metadata') {
        video.preload = 'auto';
      }

      if (video.readyState < 2 && video.dataset.playRetryBound !== 'true') {
        video.dataset.playRetryBound = 'true';
        video.addEventListener(
          'canplay',
          () => {
            video.dataset.playRetryBound = 'false';
            const retryPromise = video.play();
            if (retryPromise && typeof retryPromise.catch === 'function') {
              retryPromise.catch(() => {});
            }
          },
          { once: true }
        );

        if (video.networkState === video.NETWORK_EMPTY) {
          try {
            video.load();
          } catch (error) {}
        }
      }

      video.dataset.userPaused = 'false';
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const bindCarousel = (root) => {
      const track = root.querySelector('[data-hero-track]');
      const dotsWrap = root.querySelector('[data-hero-dots]');
      const prevArrow = root.querySelector('[data-hero-prev]');
      const nextArrow = root.querySelector('[data-hero-next-arrow]');
      if (!track || !dotsWrap) {
        return;
      }

      const slides = Array.from(track.querySelectorAll('.product-hero__media-slide'));
      if (slides.length < 2) {
        return;
      }

      dotsWrap.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-hero__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => {
          scrollToSlide(index);
        });
        dotsWrap.appendChild(dot);
      });

      const dots = Array.from(dotsWrap.querySelectorAll('.product-hero__dot'));
      let activeIndex = 0;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const motionBehavior = prefersReducedMotion.matches ? 'auto' : 'smooth';

      const scrollToSlide = (index) => {
        const boundedIndex = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[boundedIndex].offsetLeft, behavior: motionBehavior });
      };

      const syncActiveMedia = () => {
        slides.forEach((slide, index) => {
          slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
          const video = slide.querySelector('[data-hero-video]');
          if (!video) {
            return;
          }

          if (index !== activeIndex) {
            video.pause();
            video.dataset.userPaused = 'false';
            return;
          }

          if (prefersReducedMotion.matches) {
            return;
          }

          if (video.dataset.userPaused === 'true') {
            return;
          }

          requestVideoPlay(video);
        });
      };

      const syncDots = () => {
        const center = track.scrollLeft + track.clientWidth * 0.45;
        let nextActiveIndex = 0;

        slides.forEach((slide, index) => {
          if (slide.offsetLeft <= center) {
            nextActiveIndex = index;
          }
        });

        activeIndex = nextActiveIndex;
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
        if (prevArrow && nextArrow) {
          prevArrow.hidden = false;
          nextArrow.hidden = false;
          prevArrow.disabled = activeIndex <= 0;
          nextArrow.disabled = activeIndex >= slides.length - 1;
        }
        syncActiveMedia();
      };

      if (prevArrow && prevArrow.dataset.bound !== 'true') {
        prevArrow.dataset.bound = 'true';
        prevArrow.addEventListener('click', () => {
          scrollToSlide(activeIndex - 1);
        });
      }

      if (nextArrow && nextArrow.dataset.bound !== 'true') {
        nextArrow.dataset.bound = 'true';
        nextArrow.addEventListener('click', () => {
          scrollToSlide(activeIndex + 1);
        });
      }

      syncDots();
      track.addEventListener('scroll', syncDots, { passive: true });
      window.addEventListener('resize', syncDots);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          slides.forEach((slide) => {
            const video = slide.querySelector('[data-hero-video]');
            if (video) {
              video.pause();
            }
          });
          return;
        }

        syncActiveMedia();
      });
    };

    const bindHeroVideos = (root) => {
      const pauseOtherVideos = (activeVideo) => {
        root.querySelectorAll('[data-hero-video]').forEach((video) => {
          if (video === activeVideo) {
            return;
          }

          video.dataset.userPaused = 'false';
          video.pause();
        });
      };

      root.querySelectorAll('[data-hero-video-shell]').forEach((shell) => {
        if (shell.dataset.videoBound === 'true') {
          return;
        }
        shell.dataset.videoBound = 'true';

        const video = shell.querySelector('[data-hero-video]');
        const toggle = shell.querySelector('[data-hero-video-toggle]');
        if (!video || !toggle) {
          return;
        }

        video.controls = false;

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          shell.classList.toggle('is-playing', isPlaying);
          toggle.setAttribute('aria-label', isPlaying ? 'Pause product video' : 'Play product video');
        };

        const togglePlayback = () => {
          if (!video.paused && !video.ended) {
            video.dataset.userPaused = 'true';
            video.pause();
            return;
          }

          pauseOtherVideos(video);
          video.dataset.userPaused = 'false';
          requestVideoPlay(video);
        };

        toggle.addEventListener('click', togglePlayback);
        video.addEventListener('click', togglePlayback);
        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', syncState);
        syncState();
      });
    };

    const bindSwipeHint = (root) => {
      const hint = root.querySelector('[data-swipe-hint]');
      if (!hint) {
        return;
      }

      const seenKey = 'glarisePdpSwipeHintSeen';
      let hasSeenHint = false;

      try {
        hasSeenHint = window.sessionStorage.getItem(seenKey) === 'true';
      } catch (error) {
        hasSeenHint = false;
      }

      if (hasSeenHint) {
        hint.classList.add('is-hidden');
        return;
      }

      window.setTimeout(() => {
        hint.classList.add('is-hidden');

        try {
          window.sessionStorage.setItem(seenKey, 'true');
        } catch (error) {}
      }, 2000);
    };

    const bindLightbox = (root) => {
      const dialog = root.querySelector('[data-hero-lightbox]');
      const content = root.querySelector('[data-hero-lightbox-content]');
      const caption = root.querySelector('[data-hero-lightbox-caption]');
      const closeButton = root.querySelector('[data-hero-lightbox-close]');
      const triggers = Array.from(root.querySelectorAll('[data-hero-lightbox-trigger]'));
      if (!dialog || !content || !closeButton || !triggers.length || typeof dialog.showModal !== 'function') {
        return;
      }

      let returnFocusTarget = null;

      const closeLightbox = () => {
        dialog.close();
      };

      const restoreFocus = () => {
        if (returnFocusTarget && typeof returnFocusTarget.focus === 'function') {
          returnFocusTarget.focus();
        }
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const src = trigger.getAttribute('data-lightbox-src');
          const alt = trigger.getAttribute('data-lightbox-alt') || '';
          if (!src) {
            return;
          }

          const image = document.createElement('img');
          image.src = src;
          image.alt = alt;
          content.replaceChildren(image);

          if (caption) {
            caption.textContent = alt;
            caption.hidden = !alt;
          }

          returnFocusTarget = trigger;
          dialog.showModal();
          closeButton.focus();
        });
      });

      closeButton.addEventListener('click', closeLightbox);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeLightbox();
        }
      });
      dialog.addEventListener('close', restoreFocus);
    };

    const bindTestimonialRail = (root) => {
      const rail = root.querySelector('.product-hero__testimonial-rail');
      const controls = root.querySelector('[data-testimonial-controls]');
      const prevButton = root.querySelector('[data-testimonial-prev]');
      const nextButton = root.querySelector('[data-testimonial-next]');
      if (!rail || !controls || !prevButton || !nextButton) {
        return;
      }

      const cards = Array.from(rail.querySelectorAll('.product-hero__testimonial'));
      if (cards.length < 2) {
        return;
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;

      const updateActiveIndex = () => {
        const center = rail.scrollLeft + rail.clientWidth * 0.5;
        let nextActiveIndex = 0;

        cards.forEach((card, index) => {
          if (card.offsetLeft <= center) {
            nextActiveIndex = index;
          }
        });

        activeIndex = nextActiveIndex;
        prevButton.disabled = activeIndex <= 0;
        nextButton.disabled = activeIndex >= cards.length - 1;
      };

      const syncControls = () => {
        controls.hidden = false;
        updateActiveIndex();
      };

      const scrollToCard = (index) => {
        const boundedIndex = Math.max(0, Math.min(cards.length - 1, index));
        rail.scrollTo({ left: cards[boundedIndex].offsetLeft, behavior: prefersReducedMotion.matches ? 'auto' : 'smooth' });
      };

      prevButton.addEventListener('click', () => {
        scrollToCard(activeIndex - 1);
      });

      nextButton.addEventListener('click', () => {
        scrollToCard(activeIndex + 1);
      });

      rail.addEventListener('scroll', updateActiveIndex, { passive: true });
      window.addEventListener('resize', syncControls);

      syncControls();
    };

    const bindBuyDisclosures = (root) => {
      const disclosures = Array.from(root.querySelectorAll('[data-buy-disclosure]'));
      if (!disclosures.length) {
        return;
      }

      const desktopQuery = window.matchMedia('(min-width: 960px)');
      const syncDisclosures = () => {
        disclosures.forEach((disclosure) => {
          disclosure.open = desktopQuery.matches;
        });
      };

      syncDisclosures();
      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', syncDisclosures);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(syncDisclosures);
      }
    };

    const bindBundles = (root) => {
      const options = Array.from(root.querySelectorAll('[data-bundle-option]'));
      if (!options.length) {
        return;
      }

      const productForm = root.querySelector('form.product-hero__mock-form');
      const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
      const qtyInput = root.querySelector('[data-selected-bundle-qty]');
      const mainAtcLabel = root.querySelector('[data-main-atc-label]');
      const mainSubmit = productForm ? productForm.querySelector('[data-direct-checkout-submit]') : null;
      const stickyButtons = Array.from(root.querySelectorAll('[data-sticky-bundle-option]'));
      const stickyLabel = root.querySelector('[data-sticky-bundle-label]');
      const stickyPrice = root.querySelector('[data-sticky-price]');
      const stickySubmit = root.querySelector('[data-sticky-submit]');
      const stickyBaseLabel = stickySubmit ? (stickySubmit.getAttribute('data-sticky-base-label') || '').trim() : '';

      const getSelectedPrice = (option) => {
        return option.getAttribute('data-bundle-selected-price') || '';
      };

      const getOptionKey = (option) => {
        return (option.getAttribute('data-bundle-pack-count') || option.getAttribute('data-bundle-variant-id') || '').trim();
      };

      const syncStickyButtons = (selectedOption) => {
        if (!stickyButtons.length) {
          return;
        }

        const selectedKey = getOptionKey(selectedOption);
        stickyButtons.forEach((button) => {
          const isActive = (button.getAttribute('data-bundle-key') || '').trim() === selectedKey;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const getSelectionDetail = (selectedOption) => {
        return {
          source: 'hero',
          variantId: selectedOption.getAttribute('data-bundle-variant-id') || '',
          qty: selectedOption.getAttribute('data-bundle-qty') || '1',
          label: selectedOption.getAttribute('data-bundle-label') || '',
          price: getSelectedPrice(selectedOption),
          packCount: selectedOption.getAttribute('data-bundle-pack-count') || ''
        };
      };

      const findOptionForDetail = (detail) => {
        if (!detail) {
          return null;
        }

        const detailVariantId = String(detail.variantId || '').trim();
        const detailPackCount = String(detail.packCount || '').trim();

        return options.find((option) => {
          const optionVariantId = (option.getAttribute('data-bundle-variant-id') || '').trim();
          const optionPackCount = (option.getAttribute('data-bundle-pack-count') || '').trim();

          if (detailVariantId && optionVariantId && detailVariantId === optionVariantId) {
            return true;
          }

          return detailPackCount && optionPackCount === detailPackCount;
        });
      };

      const announceSelection = (selectedOption) => {
        if (typeof window.CustomEvent !== 'function') {
          return;
        }

        window.dispatchEvent(
          new window.CustomEvent('glarise:v3-bundle-change', {
            detail: getSelectionDetail(selectedOption)
          })
        );
      };

      const applySelection = (selectedOption, config = {}) => {
        options.forEach((option) => {
          const isActive = option === selectedOption;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const qty = selectedOption.getAttribute('data-bundle-qty') || '1';
        const label = selectedOption.getAttribute('data-bundle-label') || '';
        const price = getSelectedPrice(selectedOption);
        const bundleVariantId = selectedOption.getAttribute('data-bundle-variant-id') || '';

        if (variantInput && bundleVariantId) {
          variantInput.value = bundleVariantId;
        }

        if (qtyInput) {
          qtyInput.value = qty;
        }

        if (mainAtcLabel) {
          mainAtcLabel.textContent = `ADD TO CART - ${price}`;
        }

        if (stickyLabel) {
          stickyLabel.textContent = label;
        }

        if (stickyPrice) {
          stickyPrice.textContent = price;
        }

        if (stickySubmit) {
          const ctaText = stickyBaseLabel || 'ADD TO CART';
          stickySubmit.textContent = price ? `${ctaText} - ${price}` : ctaText;
        }

        syncStickyButtons(selectedOption);

        if (config.announce !== false) {
          announceSelection(selectedOption);
        }
      };

      const navigateToCheckout = () => {
        const selectedQty = ((qtyInput ? qtyInput.value : '1') || '1').trim();
        const selectedVariantId = ((variantInput ? variantInput.value : '') || '').trim();

        if (!selectedVariantId) {
          return false;
        }

        const checkoutUrl = `/cart/${encodeURIComponent(selectedVariantId)}:${encodeURIComponent(selectedQty)}?checkout`;
        window.location.assign(checkoutUrl);
        return true;
      };

      options.forEach((option) => {
        option.addEventListener('click', () => applySelection(option));
      });

      if (stickyButtons.length) {
        stickyButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const buttonKey = (button.getAttribute('data-bundle-key') || '').trim();
            const selectedOption = options.find((option) => getOptionKey(option) === buttonKey);
            if (selectedOption) {
              applySelection(selectedOption);
            }
          });
        });
      }

      const activeOption = options.find((option) => option.classList.contains('is-active')) || options[0];
      if (activeOption) {
        applySelection(activeOption);
      }

      window.addEventListener('glarise:v3-bundle-select', (event) => {
        const detail = event.detail || {};
        if (detail.source === 'hero') {
          return;
        }

        const matchedOption = findOptionForDetail(detail);
        if (matchedOption) {
          applySelection(matchedOption);
        }
      });

      if (productForm) {
        productForm.addEventListener('submit', (event) => {
          const submitter = event.submitter;
          const shouldDirectCheckout = !submitter || submitter.hasAttribute('data-direct-checkout-submit');
          if (!shouldDirectCheckout) {
            return;
          }

          event.preventDefault();

          if (!navigateToCheckout()) {
            productForm.submit();
          }
        });
      }

      if (stickySubmit) {
        stickySubmit.addEventListener('click', (event) => {
          event.preventDefault();

          if (productForm && typeof productForm.requestSubmit === 'function' && mainSubmit) {
            productForm.requestSubmit(mainSubmit);
            return;
          }

          if (!navigateToCheckout() && productForm) {
            productForm.submit();
          }
        });
      }
    };

    const bindStickyBar = (root) => {
      const stickyBar = root.querySelector('[data-sticky-bar]');
      const buyZone = root.querySelector('[data-buy-zone]');
      const bottomBundlePicker = root.ownerDocument.querySelector('[data-pdp-desktop-bundles-v3]');
      const bottomBundleHandoffTarget = bottomBundlePicker ? bottomBundlePicker.querySelector('.pdp-desktop-bundles__header') : null;
      if (!stickyBar || !buyZone) {
        return;
      }

      const desktopQuery = window.matchMedia('(min-width: 960px)');
      let buyZoneObserver = null;
      let bottomBundleObserver = null;
      let buyZoneInView = true;
      let bottomBundleInView = false;

      const syncStickyVisibility = () => {
        stickyBar.classList.toggle('is-visible', !buyZoneInView && !bottomBundleInView);
      };

      const bindMode = () => {
        if (buyZoneObserver) {
          buyZoneObserver.disconnect();
          buyZoneObserver = null;
        }

        if (bottomBundleObserver) {
          bottomBundleObserver.disconnect();
          bottomBundleObserver = null;
        }

        if (!('IntersectionObserver' in window)) {
          buyZoneInView = false;
          bottomBundleInView = false;
          syncStickyVisibility();
          return;
        }

        buyZoneInView = true;
        bottomBundleInView = false;
        syncStickyVisibility();

        buyZoneObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            buyZoneInView = entry.isIntersecting;
            syncStickyVisibility();
          },
          { threshold: 0.2 }
        );

        buyZoneObserver.observe(buyZone);

        if (bottomBundleHandoffTarget) {
          bottomBundleObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              bottomBundleInView = entry.isIntersecting;
              syncStickyVisibility();
            },
            { threshold: 0.15 }
          );

          bottomBundleObserver.observe(bottomBundleHandoffTarget);
        }
      };

      bindMode();
      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', bindMode);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(bindMode);
      }
    };

    roots.forEach((root) => {
      bindHeroVideos(root);
      bindCarousel(root);
      bindSwipeHint(root);
      bindLightbox(root);
      bindTestimonialRail(root);
      bindBuyDisclosures(root);
      bindBundles(root);
      bindStickyBar(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-hero-v4-sub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-product-hero-section][data-product-hero-version="v4-sub"]');
    if (!roots.length) {
      return;
    }

    const requestVideoPlay = (video) => {
      if (!video) {
        return;
      }

      if (video.preload === 'none' || video.preload === 'metadata') {
        video.preload = 'auto';
      }

      if (video.readyState < 2 && video.dataset.playRetryBound !== 'true') {
        video.dataset.playRetryBound = 'true';
        video.addEventListener(
          'canplay',
          () => {
            video.dataset.playRetryBound = 'false';
            const retryPromise = video.play();
            if (retryPromise && typeof retryPromise.catch === 'function') {
              retryPromise.catch(() => {});
            }
          },
          { once: true }
        );

        if (video.networkState === video.NETWORK_EMPTY) {
          try {
            video.load();
          } catch (error) {}
        }
      }

      video.dataset.userPaused = 'false';
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const bindCarousel = (root) => {
      const track = root.querySelector('[data-hero-track]');
      const dotsWrap = root.querySelector('[data-hero-dots]');
      const prevArrow = root.querySelector('[data-hero-prev]');
      const nextArrow = root.querySelector('[data-hero-next-arrow]');
      if (!track || !dotsWrap) {
        return;
      }

      const slides = Array.from(track.querySelectorAll('.product-hero__media-slide'));
      if (slides.length < 2) {
        return;
      }

      dotsWrap.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-hero__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => {
          scrollToSlide(index);
        });
        dotsWrap.appendChild(dot);
      });

      const dots = Array.from(dotsWrap.querySelectorAll('.product-hero__dot'));
      let activeIndex = 0;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const motionBehavior = prefersReducedMotion.matches ? 'auto' : 'smooth';

      const scrollToSlide = (index) => {
        const boundedIndex = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[boundedIndex].offsetLeft, behavior: motionBehavior });
      };

      const syncActiveMedia = () => {
        slides.forEach((slide, index) => {
          slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
          const video = slide.querySelector('[data-hero-video]');
          if (!video) {
            return;
          }

          if (index !== activeIndex) {
            video.pause();
            video.dataset.userPaused = 'false';
            return;
          }

          if (prefersReducedMotion.matches) {
            return;
          }

          if (video.dataset.userPaused === 'true') {
            return;
          }

          requestVideoPlay(video);
        });
      };

      const syncDots = () => {
        const center = track.scrollLeft + track.clientWidth * 0.45;
        let nextActiveIndex = 0;

        slides.forEach((slide, index) => {
          if (slide.offsetLeft <= center) {
            nextActiveIndex = index;
          }
        });

        activeIndex = nextActiveIndex;
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
        if (prevArrow && nextArrow) {
          prevArrow.hidden = false;
          nextArrow.hidden = false;
          prevArrow.disabled = activeIndex <= 0;
          nextArrow.disabled = activeIndex >= slides.length - 1;
        }
        syncActiveMedia();
      };

      if (prevArrow && prevArrow.dataset.bound !== 'true') {
        prevArrow.dataset.bound = 'true';
        prevArrow.addEventListener('click', () => {
          scrollToSlide(activeIndex - 1);
        });
      }

      if (nextArrow && nextArrow.dataset.bound !== 'true') {
        nextArrow.dataset.bound = 'true';
        nextArrow.addEventListener('click', () => {
          scrollToSlide(activeIndex + 1);
        });
      }

      syncDots();
      track.addEventListener('scroll', syncDots, { passive: true });
      window.addEventListener('resize', syncDots);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          slides.forEach((slide) => {
            const video = slide.querySelector('[data-hero-video]');
            if (video) {
              video.pause();
            }
          });
          return;
        }

        syncActiveMedia();
      });
    };

    const bindHeroVideos = (root) => {
      const pauseOtherVideos = (activeVideo) => {
        root.querySelectorAll('[data-hero-video]').forEach((video) => {
          if (video === activeVideo) {
            return;
          }

          video.dataset.userPaused = 'false';
          video.pause();
        });
      };

      root.querySelectorAll('[data-hero-video-shell]').forEach((shell) => {
        if (shell.dataset.videoBound === 'true') {
          return;
        }
        shell.dataset.videoBound = 'true';

        const video = shell.querySelector('[data-hero-video]');
        const toggle = shell.querySelector('[data-hero-video-toggle]');
        if (!video || !toggle) {
          return;
        }

        video.controls = false;

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          shell.classList.toggle('is-playing', isPlaying);
          toggle.setAttribute('aria-label', isPlaying ? 'Pause product video' : 'Play product video');
        };

        const togglePlayback = () => {
          if (!video.paused && !video.ended) {
            video.dataset.userPaused = 'true';
            video.pause();
            return;
          }

          pauseOtherVideos(video);
          video.dataset.userPaused = 'false';
          requestVideoPlay(video);
        };

        toggle.addEventListener('click', togglePlayback);
        video.addEventListener('click', togglePlayback);
        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', syncState);
        syncState();
      });
    };

    const bindSwipeHint = (root) => {
      const hint = root.querySelector('[data-swipe-hint]');
      if (!hint) {
        return;
      }

      const seenKey = 'glarisePdpSwipeHintSeen';
      let hasSeenHint = false;

      try {
        hasSeenHint = window.sessionStorage.getItem(seenKey) === 'true';
      } catch (error) {
        hasSeenHint = false;
      }

      if (hasSeenHint) {
        hint.classList.add('is-hidden');
        return;
      }

      window.setTimeout(() => {
        hint.classList.add('is-hidden');

        try {
          window.sessionStorage.setItem(seenKey, 'true');
        } catch (error) {}
      }, 2000);
    };

    const bindLightbox = (root) => {
      const dialog = root.querySelector('[data-hero-lightbox]');
      const content = root.querySelector('[data-hero-lightbox-content]');
      const caption = root.querySelector('[data-hero-lightbox-caption]');
      const closeButton = root.querySelector('[data-hero-lightbox-close]');
      const triggers = Array.from(root.querySelectorAll('[data-hero-lightbox-trigger]'));
      if (!dialog || !content || !closeButton || !triggers.length || typeof dialog.showModal !== 'function') {
        return;
      }

      let returnFocusTarget = null;

      const closeLightbox = () => {
        dialog.close();
      };

      const restoreFocus = () => {
        if (returnFocusTarget && typeof returnFocusTarget.focus === 'function') {
          returnFocusTarget.focus();
        }
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const src = trigger.getAttribute('data-lightbox-src');
          const alt = trigger.getAttribute('data-lightbox-alt') || '';
          if (!src) {
            return;
          }

          const image = document.createElement('img');
          image.src = src;
          image.alt = alt;
          content.replaceChildren(image);

          if (caption) {
            caption.textContent = alt;
            caption.hidden = !alt;
          }

          returnFocusTarget = trigger;
          dialog.showModal();
          closeButton.focus();
        });
      });

      closeButton.addEventListener('click', closeLightbox);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeLightbox();
        }
      });
      dialog.addEventListener('close', restoreFocus);
    };

    const bindTestimonialRail = (root) => {
      const rail = root.querySelector('.product-hero__testimonial-rail');
      const controls = root.querySelector('[data-testimonial-controls]');
      const prevButton = root.querySelector('[data-testimonial-prev]');
      const nextButton = root.querySelector('[data-testimonial-next]');
      if (!rail || !controls || !prevButton || !nextButton) {
        return;
      }

      const cards = Array.from(rail.querySelectorAll('.product-hero__testimonial'));
      if (cards.length < 2) {
        return;
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;

      const updateActiveIndex = () => {
        const center = rail.scrollLeft + rail.clientWidth * 0.5;
        let nextActiveIndex = 0;

        cards.forEach((card, index) => {
          if (card.offsetLeft <= center) {
            nextActiveIndex = index;
          }
        });

        activeIndex = nextActiveIndex;
        prevButton.disabled = activeIndex <= 0;
        nextButton.disabled = activeIndex >= cards.length - 1;
      };

      const syncControls = () => {
        controls.hidden = false;
        updateActiveIndex();
      };

      const scrollToCard = (index) => {
        const boundedIndex = Math.max(0, Math.min(cards.length - 1, index));
        rail.scrollTo({ left: cards[boundedIndex].offsetLeft, behavior: prefersReducedMotion.matches ? 'auto' : 'smooth' });
      };

      prevButton.addEventListener('click', () => {
        scrollToCard(activeIndex - 1);
      });

      nextButton.addEventListener('click', () => {
        scrollToCard(activeIndex + 1);
      });

      rail.addEventListener('scroll', updateActiveIndex, { passive: true });
      window.addEventListener('resize', syncControls);

      syncControls();
    };

    const bindBuyDisclosures = (root) => {
      const disclosures = Array.from(root.querySelectorAll('[data-buy-disclosure]'));
      if (!disclosures.length) {
        return;
      }

      const desktopQuery = window.matchMedia('(min-width: 960px)');
      const syncDisclosures = () => {
        disclosures.forEach((disclosure) => {
          disclosure.open = desktopQuery.matches;
        });
      };

      syncDisclosures();
      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', syncDisclosures);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(syncDisclosures);
      }
    };

    const bindDirectCheckout = (root) => {
      const form = root.querySelector('.product-hero__purchase-form');
      const submitButton = form?.querySelector('[name="add"]');
      if (!form || !submitButton || form.dataset.directCheckoutBound === 'true') {
        return;
      }

      form.dataset.directCheckoutBound = 'true';

      const shopifyRoot = window.Shopify?.routes?.root || '/';
      const addToCartUrl = new URL('cart/add.js', window.location.origin + shopifyRoot).toString();
      const checkoutUrl = new URL('checkout', window.location.origin + shopifyRoot).toString();

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (submitButton.disabled || form.dataset.directCheckoutPending === 'true') {
          return;
        }

        form.dataset.directCheckoutPending = 'true';
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(addToCartUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: new FormData(form),
          });

          const data = await response.json().catch(() => null);
          if (!response.ok || data?.status) {
            throw new Error(data?.description || data?.message || 'Unable to add product to cart.');
          }

          window.location.href = checkoutUrl;
        } catch (error) {
          form.dataset.directCheckoutPending = 'false';
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
          console.error('v4-sub direct checkout failed', error);
        }
      });
    };

    const bindStickyFooter = (root) => {
      const stickyFooter = root.querySelector('[data-subscribe-sticky]');
      const buyZone = root.querySelector('[data-buy-zone]');
      const subscribeBox = root.querySelector('.product-hero__purchase-apps') || root.querySelector('.product-hero__purchase-form');
      if (!stickyFooter || !buyZone || !subscribeBox || stickyFooter.dataset.bound === 'true') {
        return;
      }

      stickyFooter.dataset.bound = 'true';
      const stickyLink = stickyFooter.querySelector('a[href="#pdp-buy-zone"]');
      let subscribeBoxInView = true;
      let subscribeBoxHasBeenSeen = false;

      const syncVisibility = () => {
        const subscribeBoxPastTop = subscribeBox.getBoundingClientRect().top < 0;
        const isVisible = subscribeBoxHasBeenSeen && !subscribeBoxInView && subscribeBoxPastTop;
        stickyFooter.classList.toggle('is-visible', isVisible);
        stickyFooter.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      };

      if (stickyLink) {
        stickyLink.addEventListener('click', (event) => {
          event.preventDefault();
          buyZone.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start',
          });
        });
      }

      if ('IntersectionObserver' in window) {
        const subscribeBoxObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            subscribeBoxInView = Boolean(entry?.isIntersecting);
            if (subscribeBoxInView) {
              subscribeBoxHasBeenSeen = true;
            }
            syncVisibility();
          },
          {
            threshold: 0.1,
          }
        );

        subscribeBoxObserver.observe(subscribeBox);
      } else {
        const syncFromScroll = () => {
          const subscribeBoxRect = subscribeBox.getBoundingClientRect();
          subscribeBoxInView = subscribeBoxRect.bottom > 0 && subscribeBoxRect.top < window.innerHeight;
          if (subscribeBoxInView) {
            subscribeBoxHasBeenSeen = true;
          }

          syncVisibility();
        };

        syncFromScroll();
        window.addEventListener('scroll', syncFromScroll, { passive: true });
        window.addEventListener('resize', syncFromScroll);
      }

      syncVisibility();
    };

    roots.forEach((root) => {
      bindHeroVideos(root);
      bindCarousel(root);
      bindSwipeHint(root);
      bindLightbox(root);
      bindTestimonialRail(root);
      bindBuyDisclosures(root);
      bindDirectCheckout(root);
      bindStickyFooter(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-hero-v5-price-test"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-product-hero-section][data-product-hero-version="v5-price-test"]');
    if (!roots.length) {
      return;
    }

    const requestVideoPlay = (video) => {
      if (!video) {
        return;
      }

      if (video.preload === 'none' || video.preload === 'metadata') {
        video.preload = 'auto';
      }

      if (video.readyState < 2 && video.dataset.playRetryBound !== 'true') {
        video.dataset.playRetryBound = 'true';
        video.addEventListener(
          'canplay',
          () => {
            video.dataset.playRetryBound = 'false';
            const retryPromise = video.play();
            if (retryPromise && typeof retryPromise.catch === 'function') {
              retryPromise.catch(() => {});
            }
          },
          { once: true }
        );

        if (video.networkState === video.NETWORK_EMPTY) {
          try {
            video.load();
          } catch (error) {}
        }
      }

      video.dataset.userPaused = 'false';
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const bindCarousel = (root) => {
      const track = root.querySelector('[data-hero-track]');
      const dotsWrap = root.querySelector('[data-hero-dots]');
      const prevArrow = root.querySelector('[data-hero-prev]');
      const nextArrow = root.querySelector('[data-hero-next-arrow]');
      if (!track || !dotsWrap) {
        return;
      }

      const slides = Array.from(track.querySelectorAll('.product-hero__media-slide'));
      if (slides.length < 2) {
        return;
      }

      dotsWrap.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-hero__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => {
          scrollToSlide(index);
        });
        dotsWrap.appendChild(dot);
      });

      const dots = Array.from(dotsWrap.querySelectorAll('.product-hero__dot'));
      let activeIndex = 0;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const motionBehavior = prefersReducedMotion.matches ? 'auto' : 'smooth';

      const scrollToSlide = (index) => {
        const boundedIndex = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[boundedIndex].offsetLeft, behavior: motionBehavior });
      };

      const syncActiveMedia = () => {
        slides.forEach((slide, index) => {
          slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
          const video = slide.querySelector('[data-hero-video]');
          if (!video) {
            return;
          }

          if (index !== activeIndex) {
            video.pause();
            video.dataset.userPaused = 'false';
            return;
          }

          if (prefersReducedMotion.matches) {
            return;
          }

          if (video.dataset.userPaused === 'true') {
            return;
          }

          requestVideoPlay(video);
        });
      };

      const syncDots = () => {
        const center = track.scrollLeft + track.clientWidth * 0.45;
        let nextActiveIndex = 0;

        slides.forEach((slide, index) => {
          if (slide.offsetLeft <= center) {
            nextActiveIndex = index;
          }
        });

        activeIndex = nextActiveIndex;
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
        if (prevArrow && nextArrow) {
          prevArrow.hidden = false;
          nextArrow.hidden = false;
          prevArrow.disabled = activeIndex <= 0;
          nextArrow.disabled = activeIndex >= slides.length - 1;
        }
        syncActiveMedia();
      };

      if (prevArrow && prevArrow.dataset.bound !== 'true') {
        prevArrow.dataset.bound = 'true';
        prevArrow.addEventListener('click', () => {
          scrollToSlide(activeIndex - 1);
        });
      }

      if (nextArrow && nextArrow.dataset.bound !== 'true') {
        nextArrow.dataset.bound = 'true';
        nextArrow.addEventListener('click', () => {
          scrollToSlide(activeIndex + 1);
        });
      }

      syncDots();
      track.addEventListener('scroll', syncDots, { passive: true });
      window.addEventListener('resize', syncDots);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          slides.forEach((slide) => {
            const video = slide.querySelector('[data-hero-video]');
            if (video) {
              video.pause();
            }
          });
          return;
        }

        syncActiveMedia();
      });
    };

    const bindHeroVideos = (root) => {
      const pauseOtherVideos = (activeVideo) => {
        root.querySelectorAll('[data-hero-video]').forEach((video) => {
          if (video === activeVideo) {
            return;
          }

          video.dataset.userPaused = 'false';
          video.pause();
        });
      };

      root.querySelectorAll('[data-hero-video-shell]').forEach((shell) => {
        if (shell.dataset.videoBound === 'true') {
          return;
        }
        shell.dataset.videoBound = 'true';

        const video = shell.querySelector('[data-hero-video]');
        const toggle = shell.querySelector('[data-hero-video-toggle]');
        if (!video || !toggle) {
          return;
        }

        video.controls = false;

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          shell.classList.toggle('is-playing', isPlaying);
          toggle.setAttribute('aria-label', isPlaying ? 'Pause product video' : 'Play product video');
        };

        const togglePlayback = () => {
          if (!video.paused && !video.ended) {
            video.dataset.userPaused = 'true';
            video.pause();
            return;
          }

          pauseOtherVideos(video);
          video.dataset.userPaused = 'false';
          requestVideoPlay(video);
        };

        toggle.addEventListener('click', togglePlayback);
        video.addEventListener('click', togglePlayback);
        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', syncState);
        syncState();
      });
    };

    const bindSwipeHint = (root) => {
      const hint = root.querySelector('[data-swipe-hint]');
      if (!hint) {
        return;
      }

      const seenKey = 'glarisePdpSwipeHintSeen';
      let hasSeenHint = false;

      try {
        hasSeenHint = window.sessionStorage.getItem(seenKey) === 'true';
      } catch (error) {
        hasSeenHint = false;
      }

      if (hasSeenHint) {
        hint.classList.add('is-hidden');
        return;
      }

      window.setTimeout(() => {
        hint.classList.add('is-hidden');

        try {
          window.sessionStorage.setItem(seenKey, 'true');
        } catch (error) {}
      }, 2000);
    };

    const bindLightbox = (root) => {
      const dialog = root.querySelector('[data-hero-lightbox]');
      const content = root.querySelector('[data-hero-lightbox-content]');
      const caption = root.querySelector('[data-hero-lightbox-caption]');
      const closeButton = root.querySelector('[data-hero-lightbox-close]');
      const triggers = Array.from(root.querySelectorAll('[data-hero-lightbox-trigger]'));
      if (!dialog || !content || !closeButton || !triggers.length || typeof dialog.showModal !== 'function') {
        return;
      }

      let returnFocusTarget = null;

      const closeLightbox = () => {
        dialog.close();
      };

      const restoreFocus = () => {
        if (returnFocusTarget && typeof returnFocusTarget.focus === 'function') {
          returnFocusTarget.focus();
        }
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const src = trigger.getAttribute('data-lightbox-src');
          const alt = trigger.getAttribute('data-lightbox-alt') || '';
          if (!src) {
            return;
          }

          const image = document.createElement('img');
          image.src = src;
          image.alt = alt;
          content.replaceChildren(image);

          if (caption) {
            caption.textContent = alt;
            caption.hidden = !alt;
          }

          returnFocusTarget = trigger;
          dialog.showModal();
          closeButton.focus();
        });
      });

      closeButton.addEventListener('click', closeLightbox);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeLightbox();
        }
      });
      dialog.addEventListener('close', restoreFocus);
    };

    const bindTestimonialRail = (root) => {
      const rail = root.querySelector('.product-hero__testimonial-rail');
      const controls = root.querySelector('[data-testimonial-controls]');
      const prevButton = root.querySelector('[data-testimonial-prev]');
      const nextButton = root.querySelector('[data-testimonial-next]');
      if (!rail || !controls || !prevButton || !nextButton) {
        return;
      }

      const cards = Array.from(rail.querySelectorAll('.product-hero__testimonial'));
      if (cards.length < 2) {
        return;
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;

      const updateActiveIndex = () => {
        const center = rail.scrollLeft + rail.clientWidth * 0.5;
        let nextActiveIndex = 0;

        cards.forEach((card, index) => {
          if (card.offsetLeft <= center) {
            nextActiveIndex = index;
          }
        });

        activeIndex = nextActiveIndex;
        prevButton.disabled = activeIndex <= 0;
        nextButton.disabled = activeIndex >= cards.length - 1;
      };

      const syncControls = () => {
        controls.hidden = false;
        updateActiveIndex();
      };

      const scrollToCard = (index) => {
        const boundedIndex = Math.max(0, Math.min(cards.length - 1, index));
        rail.scrollTo({ left: cards[boundedIndex].offsetLeft, behavior: prefersReducedMotion.matches ? 'auto' : 'smooth' });
      };

      prevButton.addEventListener('click', () => {
        scrollToCard(activeIndex - 1);
      });

      nextButton.addEventListener('click', () => {
        scrollToCard(activeIndex + 1);
      });

      rail.addEventListener('scroll', updateActiveIndex, { passive: true });
      window.addEventListener('resize', syncControls);

      syncControls();
    };

    const bindBuyDisclosures = (root) => {
      const disclosures = Array.from(root.querySelectorAll('[data-buy-disclosure]'));
      if (!disclosures.length) {
        return;
      }

      const desktopQuery = window.matchMedia('(min-width: 960px)');
      const syncDisclosures = () => {
        disclosures.forEach((disclosure) => {
          disclosure.open = desktopQuery.matches;
        });
      };

      syncDisclosures();
      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', syncDisclosures);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(syncDisclosures);
      }
    };

    const bindBundles = (root) => {
      const options = Array.from(root.querySelectorAll('[data-bundle-option]'));
      if (!options.length) {
        return;
      }

      const productForm = root.querySelector('form.product-hero__mock-form');
      const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
      const qtyInput = root.querySelector('[data-selected-bundle-qty]');
      const mainAtcLabel = root.querySelector('[data-main-atc-label]');
      const mainSubmit = productForm ? productForm.querySelector('[data-direct-checkout-submit]') : null;
      const stickyButtons = Array.from(root.querySelectorAll('[data-sticky-bundle-option]'));
      const stickyLabel = root.querySelector('[data-sticky-bundle-label]');
      const stickyPrice = root.querySelector('[data-sticky-price]');
      const stickySubmit = root.querySelector('[data-sticky-submit]');
      const stickyBaseLabel = stickySubmit ? (stickySubmit.getAttribute('data-sticky-base-label') || '').trim() : '';
      const bestValuePerDayLine = root.querySelector('[data-best-value-per-day-line]');
      const supplyDays = Number(root.getAttribute('data-bundle-supply-days') || 45) || 45;

      const parseMoneyToCents = (value) => {
        if (!value) {
          return null;
        }

        const match = String(value).replace(/,/g, '').match(/-?\d+(?:\.\d{1,2})?/);
        if (!match) {
          return null;
        }

        const amount = Number(match[0]);
        if (!Number.isFinite(amount)) {
          return null;
        }

        return Math.round(amount * 100);
      };

      const formatMoney = (cents) => {
        const amount = Number(cents || 0) / 100;
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(amount);
      };

      const formatShippingLabel = (cents, config = {}) => {
        const shippingText = Number(cents || 0) > 0 ? `${formatMoney(cents)} shipping` : 'FREE shipping';
        return config.includeGift ? `${shippingText} + FREE gift` : shippingText;
      };

      const formatPerDayText = (priceCents, packCount, shippingCents = 0) => {
        const normalizedPackCount = Math.max(1, Number(packCount || 1));
        const effectiveCents = Number(priceCents || 0) + (normalizedPackCount === 1 ? Number(shippingCents || 0) : 0);
        const totalDays = Math.max(1, supplyDays * normalizedPackCount);
        return `${formatMoney(Math.round(effectiveCents / totalDays))}/day`;
      };

      const formatSaveText = (cents) => `Save ${formatMoney(Math.max(0, Number(cents || 0)))}`;

      const getDefaultBundlePriceCents = (option) => {
        return Number(option ? option.getAttribute('data-bundle-default-price-cents') || option.getAttribute('data-bundle-price-cents') || 0 : 0) || 0;
      };

      const getIntelligemsPriceCentsByVariantId = (variantId) => {
        const normalizedVariantId = String(variantId || '').trim();
        const priceApi = window.igData && window.igData.price;
        if (!normalizedVariantId || !priceApi || typeof priceApi.getPriceByVariantId !== 'function') {
          return null;
        }

        try {
          const lookupKey = /^\d+$/.test(normalizedVariantId) ? Number(normalizedVariantId) : normalizedVariantId;
          const priceValue = priceApi.getPriceByVariantId(lookupKey);
          return parseMoneyToCents(priceValue);
        } catch (_error) {
          return null;
        }
      };

      const getResolvedBundlePriceCents = (option, index) => {
        const variantId = option ? option.getAttribute('data-bundle-variant-id') || option.getAttribute('data-variant-id') || '' : '';
        const intelligemsPriceCents = getIntelligemsPriceCentsByVariantId(variantId);
        if (intelligemsPriceCents && intelligemsPriceCents > 0) {
          return intelligemsPriceCents;
        }

        const defaultPriceCents = getDefaultBundlePriceCents(option);
        if (defaultPriceCents > 0) {
          return defaultPriceCents;
        }

        const displayedPrice = getDisplayedPrice(option);
        return parseMoneyToCents(displayedPrice) || Number(options[index]?.getAttribute('data-bundle-price-cents') || 0) || 0;
      };

      const getResolvedBundlePricesCents = () => {
        return options.map((option, index) => getResolvedBundlePriceCents(option, index));
      };

      const getDisplayedPrice = (option) => {
        const priceNode = option ? option.querySelector('[data-bundle-price-display]') : null;
        if (priceNode && priceNode.textContent.trim()) {
          return priceNode.textContent.trim();
        }

        return option ? option.getAttribute('data-bundle-selected-price') || '' : '';
      };

      const getArmBundlePrices = (prefix) => {
        return [
          parseMoneyToCents(root.getAttribute(`data-${prefix}-bundle-1-price`)),
          parseMoneyToCents(root.getAttribute(`data-${prefix}-bundle-2-price`)),
          parseMoneyToCents(root.getAttribute(`data-${prefix}-bundle-3-price`))
        ];
      };

      const armConfigurations = [
        {
          name: 'control',
          bundlePricesCents: getArmBundlePrices('control'),
          singlePackShippingCents: parseMoneyToCents(root.getAttribute('data-control-single-pack-shipping')) || 0
        },
        {
          name: 'test',
          bundlePricesCents: getArmBundlePrices('test'),
          singlePackShippingCents: parseMoneyToCents(root.getAttribute('data-test-single-pack-shipping')) || 0
        }
      ];

      const detectPricingArm = (currentBundlePricesCents) => {
        let closestArm = armConfigurations.find((arm) => arm.bundlePricesCents.some((price) => price)) || armConfigurations[0];
        let closestDistance = Number.POSITIVE_INFINITY;

        armConfigurations.forEach((arm) => {
          let comparisonCount = 0;
          let distance = 0;

          arm.bundlePricesCents.forEach((configuredPriceCents, index) => {
            const currentPriceCents = Number(currentBundlePricesCents[index] || 0);
            if (!(configuredPriceCents > 0) || !(currentPriceCents > 0)) {
              return;
            }

            comparisonCount += 1;
            distance += Math.abs(currentPriceCents - configuredPriceCents);
          });

          if (!comparisonCount) {
            return;
          }

          if (distance < closestDistance) {
            closestDistance = distance;
            closestArm = arm;
          }
        });

        return closestArm;
      };

      const getSelectedPrice = (option) => {
        return option.getAttribute('data-bundle-selected-price') || '';
      };

      const getOptionKey = (option) => {
        return (option.getAttribute('data-bundle-pack-count') || option.getAttribute('data-bundle-variant-id') || '').trim();
      };

      const syncStickyButtons = (selectedOption) => {
        if (!stickyButtons.length) {
          return;
        }

        const selectedKey = getOptionKey(selectedOption);
        stickyButtons.forEach((button) => {
          const isActive = (button.getAttribute('data-bundle-key') || '').trim() === selectedKey;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const getSelectionDetail = (selectedOption) => {
        return {
          source: 'hero',
          variantId: selectedOption.getAttribute('data-bundle-variant-id') || '',
          qty: selectedOption.getAttribute('data-bundle-qty') || '1',
          label: selectedOption.getAttribute('data-bundle-label') || '',
          price: getSelectedPrice(selectedOption),
          packCount: selectedOption.getAttribute('data-bundle-pack-count') || ''
        };
      };

      const findOptionForDetail = (detail) => {
        if (!detail) {
          return null;
        }

        const detailVariantId = String(detail.variantId || '').trim();
        const detailPackCount = String(detail.packCount || '').trim();

        return options.find((option) => {
          const optionVariantId = (option.getAttribute('data-bundle-variant-id') || '').trim();
          const optionPackCount = (option.getAttribute('data-bundle-pack-count') || '').trim();

          if (detailVariantId && optionVariantId && detailVariantId === optionVariantId) {
            return true;
          }

          return detailPackCount && optionPackCount === detailPackCount;
        });
      };

      const announceSelection = (selectedOption) => {
        if (typeof window.CustomEvent !== 'function') {
          return;
        }

        window.dispatchEvent(
          new window.CustomEvent('glarise:pdp-bundle-change', {
            detail: getSelectionDetail(selectedOption)
          })
        );
      };

      const applySelection = (selectedOption, config = {}) => {
        options.forEach((option) => {
          const isActive = option === selectedOption;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const qty = selectedOption.getAttribute('data-bundle-qty') || '1';
        const label = selectedOption.getAttribute('data-bundle-label') || '';
        const price = getSelectedPrice(selectedOption);
        const bundleVariantId = selectedOption.getAttribute('data-bundle-variant-id') || '';

        if (variantInput && bundleVariantId) {
          variantInput.value = bundleVariantId;
        }

        if (qtyInput) {
          qtyInput.value = qty;
        }

        if (mainAtcLabel) {
          mainAtcLabel.textContent = `ADD TO CART - ${price}`;
        }

        if (stickyLabel) {
          stickyLabel.textContent = label;
        }

        if (stickyPrice) {
          stickyPrice.textContent = price;
        }

        if (stickySubmit) {
          const ctaText = stickyBaseLabel || 'ADD TO CART';
          stickySubmit.textContent = price ? `${ctaText} - ${price}` : ctaText;
        }

        syncStickyButtons(selectedOption);

        if (config.announce !== false) {
          announceSelection(selectedOption);
        }
      };

      let refreshFrame = null;
      let lastResolvedPricingSignature = '';

      const refreshBundlePricing = (resolvedBundlePricesCents = getResolvedBundlePricesCents()) => {
        const activeArm = detectPricingArm(resolvedBundlePricesCents);
        const bundle1BasePriceCents = Number(activeArm.bundlePricesCents[0] || resolvedBundlePricesCents[0] || 0);
        const referenceBundlePriceCents = bundle1BasePriceCents;
        const singlePackShippingCents = Number(activeArm.singlePackShippingCents || 0);
        let bestPerDayCents = null;

        options.forEach((option, index) => {
          const packCount = Number(option.getAttribute('data-bundle-pack-count') || index + 1 || 1);
          const currentPriceCents = packCount === 1 ? bundle1BasePriceCents : Number(resolvedBundlePricesCents[index] || 0);
          const priceNode = option.querySelector('[data-bundle-price-display]');
          const sublineNode = option.querySelector('[data-bundle-subline]');
          const metaNode = option.querySelector('[data-bundle-meta]');
          const compareNode = option.querySelector('[data-bundle-compare-display]');
          const priceCaptionNode = option.querySelector('[data-bundle-price-caption]');
          const displayedBasePrice = currentPriceCents > 0 ? formatMoney(currentPriceCents) : getDisplayedPrice(option);
          const displayedTotalPrice =
            packCount === 1 && singlePackShippingCents > 0
              ? formatMoney(currentPriceCents + singlePackShippingCents)
              : displayedBasePrice;
          const perDayText = formatPerDayText(currentPriceCents, packCount, singlePackShippingCents);
          const perDayCents = parseMoneyToCents(perDayText) || 0;

          option.setAttribute('data-bundle-selected-price', displayedTotalPrice);
          if (currentPriceCents > 0) {
            option.setAttribute('data-bundle-price-cents', String(currentPriceCents));
          }

          if (priceNode && displayedTotalPrice) {
            priceNode.textContent = displayedTotalPrice;
          }

          if (packCount === 1) {
            if (sublineNode) {
              sublineNode.textContent =
                singlePackShippingCents > 0
                  ? `${displayedBasePrice} + ${formatMoney(singlePackShippingCents)} shipping`
                  : 'FREE shipping';
            }

            if (metaNode) {
              metaNode.textContent = perDayText;
            }

            if (priceCaptionNode) {
              priceCaptionNode.textContent = singlePackShippingCents > 0 ? 'TOTAL' : 'FREE shipping';
            }
          } else {
            const compareCents = (referenceBundlePriceCents + singlePackShippingCents) * packCount;
            const savingsCents = Math.max(compareCents - currentPriceCents, 0);

            if (sublineNode) {
              sublineNode.textContent = formatShippingLabel(0, { includeGift: packCount >= 3 });
            }

            if (metaNode) {
              metaNode.textContent = `${perDayText} - ${formatSaveText(savingsCents)}`;
            }

            if (compareNode) {
              if (compareCents > currentPriceCents) {
                compareNode.textContent = formatMoney(compareCents);
                compareNode.hidden = false;
              } else {
                compareNode.textContent = '';
                compareNode.hidden = true;
              }
            }
          }

          if (bestPerDayCents === null || (perDayCents > 0 && perDayCents < bestPerDayCents)) {
            bestPerDayCents = perDayCents;
          }
        });

        root.setAttribute('data-active-pricing-arm', activeArm.name);
        root.setAttribute('data-active-bundle-1-price-cents', String(bundle1BasePriceCents));
        root.setAttribute('data-active-bundle-2-price-cents', String(Number(resolvedBundlePricesCents[1] || 0)));
        root.setAttribute('data-active-bundle-3-price-cents', String(Number(resolvedBundlePricesCents[2] || 0)));
        root.setAttribute('data-active-single-pack-shipping-cents', String(singlePackShippingCents));
        root.setAttribute('data-active-best-per-day-cents', String(Number(bestPerDayCents || 0)));

        if (bestValuePerDayLine && bestPerDayCents > 0) {
          bestValuePerDayLine.textContent = `As low as ${formatMoney(bestPerDayCents)}/day`;
        }

        const selectedOption = options.find((option) => option.classList.contains('is-active')) || options[0];
        if (selectedOption) {
          applySelection(selectedOption, { announce: false });
        }

        if (typeof window.CustomEvent === 'function') {
          window.dispatchEvent(
            new window.CustomEvent('glarise:v5-pricing-change', {
              detail: {
                source: 'hero',
                arm: activeArm.name,
                bundlePricesCents: resolvedBundlePricesCents,
                singlePackShippingCents,
                bestPerDayCents: Number(bestPerDayCents || 0)
              }
            })
          );
        }
      };

      const scheduleBundleRefresh = () => {
        if (refreshFrame) {
          return;
        }

        refreshFrame = window.requestAnimationFrame(() => {
          refreshFrame = null;
          const resolvedBundlePricesCents = getResolvedBundlePricesCents();
          const pricingSignature = resolvedBundlePricesCents.join('|');
          if (pricingSignature === lastResolvedPricingSignature && root.hasAttribute('data-active-pricing-arm')) {
            return;
          }

          lastResolvedPricingSignature = pricingSignature;
          refreshBundlePricing(resolvedBundlePricesCents);
        });
      };

      const startIntelligemsPricingMonitor = () => {
        scheduleBundleRefresh();
        window.setInterval(scheduleBundleRefresh, 400);
      };

      const navigateToCheckout = () => {
        const selectedQty = ((qtyInput ? qtyInput.value : '1') || '1').trim();
        const selectedVariantId = ((variantInput ? variantInput.value : '') || '').trim();

        if (!selectedVariantId) {
          return false;
        }

        const checkoutUrl = new URL(`/cart/${encodeURIComponent(selectedVariantId)}:${encodeURIComponent(selectedQty)}`, window.location.origin);
        const igId = window.igData && window.igData.user ? window.igData.user.igId : '';

        if (igId) {
          checkoutUrl.searchParams.set('attributes[igId]', igId);
        }

        window.location.assign(checkoutUrl.toString());
        return true;
      };

      options.forEach((option) => {
        option.addEventListener('click', () => applySelection(option));
      });

      if (stickyButtons.length) {
        stickyButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const buttonKey = (button.getAttribute('data-bundle-key') || '').trim();
            const selectedOption = options.find((option) => getOptionKey(option) === buttonKey);
            if (selectedOption) {
              applySelection(selectedOption);
            }
          });
        });
      }

      const activeOption = options.find((option) => option.classList.contains('is-active')) || options[0];
      startIntelligemsPricingMonitor();
      if (activeOption) {
        applySelection(activeOption);
      }

      window.addEventListener('glarise:pdp-bundle-select', (event) => {
        const detail = event.detail || {};
        if (detail.source === 'hero') {
          return;
        }

        const matchedOption = findOptionForDetail(detail);
        if (matchedOption) {
          applySelection(matchedOption);
        }
      });

      if (productForm) {
        productForm.addEventListener('submit', (event) => {
          const submitter = event.submitter;
          const shouldDirectCheckout = !submitter || submitter.hasAttribute('data-direct-checkout-submit');
          if (!shouldDirectCheckout) {
            return;
          }

          event.preventDefault();

          if (!navigateToCheckout()) {
            productForm.submit();
          }
        });
      }

      if (stickySubmit) {
        stickySubmit.addEventListener('click', (event) => {
          event.preventDefault();

          if (productForm && typeof productForm.requestSubmit === 'function' && mainSubmit) {
            productForm.requestSubmit(mainSubmit);
            return;
          }

          if (!navigateToCheckout() && productForm) {
            productForm.submit();
          }
        });
      }
    };

    const bindStickyBar = (root) => {
      const stickyBar = root.querySelector('[data-sticky-bar]');
      const buyZone = root.querySelector('[data-buy-zone]');
      const bottomBundlePicker = root.ownerDocument.querySelector('[data-pdp-desktop-bundles]');
      const bottomBundleHandoffTarget = bottomBundlePicker ? bottomBundlePicker.querySelector('.pdp-desktop-bundles__header') : null;
      if (!stickyBar || !buyZone) {
        return;
      }

      const desktopQuery = window.matchMedia('(min-width: 960px)');
      let buyZoneObserver = null;
      let bottomBundleObserver = null;
      let buyZoneInView = true;
      let bottomBundleInView = false;

      const syncStickyVisibility = () => {
        stickyBar.classList.toggle('is-visible', !buyZoneInView && !bottomBundleInView);
      };

      const bindMode = () => {
        if (buyZoneObserver) {
          buyZoneObserver.disconnect();
          buyZoneObserver = null;
        }

        if (bottomBundleObserver) {
          bottomBundleObserver.disconnect();
          bottomBundleObserver = null;
        }

        if (!('IntersectionObserver' in window)) {
          buyZoneInView = false;
          bottomBundleInView = false;
          syncStickyVisibility();
          return;
        }

        buyZoneInView = true;
        bottomBundleInView = false;
        syncStickyVisibility();

        buyZoneObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            buyZoneInView = entry.isIntersecting;
            syncStickyVisibility();
          },
          { threshold: 0.2 }
        );

        buyZoneObserver.observe(buyZone);

        if (bottomBundleHandoffTarget) {
          bottomBundleObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              bottomBundleInView = entry.isIntersecting;
              syncStickyVisibility();
            },
            { threshold: 0.15 }
          );

          bottomBundleObserver.observe(bottomBundleHandoffTarget);
        }
      };

      bindMode();
      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', bindMode);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(bindMode);
      }
    };

    roots.forEach((root) => {
      bindHeroVideos(root);
      bindCarousel(root);
      bindSwipeHint(root);
      bindLightbox(root);
      bindTestimonialRail(root);
      bindBuyDisclosures(root);
      bindBundles(root);
      bindStickyBar(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-hero-v6-benefit-framing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-product-hero-section][data-product-hero-version="v6-benefit-framing"]');
    if (!roots.length) {
      return;
    }

    const requestVideoPlay = (video) => {
      if (!video) {
        return;
      }

      if (video.preload === 'none' || video.preload === 'metadata') {
        video.preload = 'auto';
      }

      if (video.readyState < 2 && video.dataset.playRetryBound !== 'true') {
        video.dataset.playRetryBound = 'true';
        video.addEventListener(
          'canplay',
          () => {
            video.dataset.playRetryBound = 'false';
            const retryPromise = video.play();
            if (retryPromise && typeof retryPromise.catch === 'function') {
              retryPromise.catch(() => {});
            }
          },
          { once: true }
        );

        if (video.networkState === video.NETWORK_EMPTY) {
          try {
            video.load();
          } catch (error) {}
        }
      }

      video.dataset.userPaused = 'false';
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const bindCarousel = (root) => {
      const track = root.querySelector('[data-hero-track]');
      const dotsWrap = root.querySelector('[data-hero-dots]');
      const prevArrow = root.querySelector('[data-hero-prev]');
      const nextArrow = root.querySelector('[data-hero-next-arrow]');
      if (!track || !dotsWrap) {
        return;
      }

      const slides = Array.from(track.querySelectorAll('.product-hero__media-slide'));
      if (slides.length < 2) {
        return;
      }

      dotsWrap.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-hero__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => {
          scrollToSlide(index);
        });
        dotsWrap.appendChild(dot);
      });

      const dots = Array.from(dotsWrap.querySelectorAll('.product-hero__dot'));
      let activeIndex = 0;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const motionBehavior = prefersReducedMotion.matches ? 'auto' : 'smooth';

      const scrollToSlide = (index) => {
        const boundedIndex = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[boundedIndex].offsetLeft, behavior: motionBehavior });
      };

      const syncActiveMedia = () => {
        slides.forEach((slide, index) => {
          slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
          const video = slide.querySelector('[data-hero-video]');
          if (!video) {
            return;
          }

          if (index !== activeIndex) {
            video.pause();
            video.dataset.userPaused = 'false';
            return;
          }

          if (prefersReducedMotion.matches) {
            return;
          }

          if (video.dataset.userPaused === 'true') {
            return;
          }

          requestVideoPlay(video);
        });
      };

      const syncDots = () => {
        const center = track.scrollLeft + track.clientWidth * 0.45;
        let nextActiveIndex = 0;

        slides.forEach((slide, index) => {
          if (slide.offsetLeft <= center) {
            nextActiveIndex = index;
          }
        });

        activeIndex = nextActiveIndex;
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
        if (prevArrow && nextArrow) {
          prevArrow.hidden = false;
          nextArrow.hidden = false;
          prevArrow.disabled = activeIndex <= 0;
          nextArrow.disabled = activeIndex >= slides.length - 1;
        }
        syncActiveMedia();
      };

      if (prevArrow && prevArrow.dataset.bound !== 'true') {
        prevArrow.dataset.bound = 'true';
        prevArrow.addEventListener('click', () => {
          scrollToSlide(activeIndex - 1);
        });
      }

      if (nextArrow && nextArrow.dataset.bound !== 'true') {
        nextArrow.dataset.bound = 'true';
        nextArrow.addEventListener('click', () => {
          scrollToSlide(activeIndex + 1);
        });
      }

      syncDots();
      track.addEventListener('scroll', syncDots, { passive: true });
      window.addEventListener('resize', syncDots);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          slides.forEach((slide) => {
            const video = slide.querySelector('[data-hero-video]');
            if (video) {
              video.pause();
            }
          });
          return;
        }

        syncActiveMedia();
      });
    };

    const bindHeroVideos = (root) => {
      const pauseOtherVideos = (activeVideo) => {
        root.querySelectorAll('[data-hero-video]').forEach((video) => {
          if (video === activeVideo) {
            return;
          }

          video.dataset.userPaused = 'false';
          video.pause();
        });
      };

      root.querySelectorAll('[data-hero-video-shell]').forEach((shell) => {
        if (shell.dataset.videoBound === 'true') {
          return;
        }
        shell.dataset.videoBound = 'true';

        const video = shell.querySelector('[data-hero-video]');
        const toggle = shell.querySelector('[data-hero-video-toggle]');
        if (!video || !toggle) {
          return;
        }

        video.controls = false;

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          shell.classList.toggle('is-playing', isPlaying);
          toggle.setAttribute('aria-label', isPlaying ? 'Pause product video' : 'Play product video');
        };

        const togglePlayback = () => {
          if (!video.paused && !video.ended) {
            video.dataset.userPaused = 'true';
            video.pause();
            return;
          }

          pauseOtherVideos(video);
          video.dataset.userPaused = 'false';
          requestVideoPlay(video);
        };

        toggle.addEventListener('click', togglePlayback);
        video.addEventListener('click', togglePlayback);
        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', syncState);
        syncState();
      });
    };

    const bindSwipeHint = (root) => {
      const hint = root.querySelector('[data-swipe-hint]');
      if (!hint) {
        return;
      }

      const seenKey = 'glarisePdpSwipeHintSeen';
      let hasSeenHint = false;

      try {
        hasSeenHint = window.sessionStorage.getItem(seenKey) === 'true';
      } catch (error) {
        hasSeenHint = false;
      }

      if (hasSeenHint) {
        hint.classList.add('is-hidden');
        return;
      }

      window.setTimeout(() => {
        hint.classList.add('is-hidden');

        try {
          window.sessionStorage.setItem(seenKey, 'true');
        } catch (error) {}
      }, 2000);
    };

    const bindLightbox = (root) => {
      const dialog = root.querySelector('[data-hero-lightbox]');
      const content = root.querySelector('[data-hero-lightbox-content]');
      const caption = root.querySelector('[data-hero-lightbox-caption]');
      const closeButton = root.querySelector('[data-hero-lightbox-close]');
      const triggers = Array.from(root.querySelectorAll('[data-hero-lightbox-trigger]'));
      if (!dialog || !content || !closeButton || !triggers.length || typeof dialog.showModal !== 'function') {
        return;
      }

      let returnFocusTarget = null;

      const closeLightbox = () => {
        dialog.close();
      };

      const restoreFocus = () => {
        if (returnFocusTarget && typeof returnFocusTarget.focus === 'function') {
          returnFocusTarget.focus();
        }
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const src = trigger.getAttribute('data-lightbox-src');
          const alt = trigger.getAttribute('data-lightbox-alt') || '';
          if (!src) {
            return;
          }

          const image = document.createElement('img');
          image.src = src;
          image.alt = alt;
          content.replaceChildren(image);

          if (caption) {
            caption.textContent = alt;
            caption.hidden = !alt;
          }

          returnFocusTarget = trigger;
          dialog.showModal();
          closeButton.focus();
        });
      });

      closeButton.addEventListener('click', closeLightbox);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeLightbox();
        }
      });
      dialog.addEventListener('close', restoreFocus);
    };

    const bindTestimonialRail = (root) => {
      const rail = root.querySelector('.product-hero__testimonial-rail');
      const controls = root.querySelector('[data-testimonial-controls]');
      const prevButton = root.querySelector('[data-testimonial-prev]');
      const nextButton = root.querySelector('[data-testimonial-next]');
      if (!rail || !controls || !prevButton || !nextButton) {
        return;
      }

      const cards = Array.from(rail.querySelectorAll('.product-hero__testimonial'));
      if (cards.length < 2) {
        return;
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;

      const updateActiveIndex = () => {
        const center = rail.scrollLeft + rail.clientWidth * 0.5;
        let nextActiveIndex = 0;

        cards.forEach((card, index) => {
          if (card.offsetLeft <= center) {
            nextActiveIndex = index;
          }
        });

        activeIndex = nextActiveIndex;
        prevButton.disabled = activeIndex <= 0;
        nextButton.disabled = activeIndex >= cards.length - 1;
      };

      const syncControls = () => {
        controls.hidden = false;
        updateActiveIndex();
      };

      const scrollToCard = (index) => {
        const boundedIndex = Math.max(0, Math.min(cards.length - 1, index));
        rail.scrollTo({ left: cards[boundedIndex].offsetLeft, behavior: prefersReducedMotion.matches ? 'auto' : 'smooth' });
      };

      prevButton.addEventListener('click', () => {
        scrollToCard(activeIndex - 1);
      });

      nextButton.addEventListener('click', () => {
        scrollToCard(activeIndex + 1);
      });

      rail.addEventListener('scroll', updateActiveIndex, { passive: true });
      window.addEventListener('resize', syncControls);

      syncControls();
    };

    const bindBuyDisclosures = (root) => {
      const disclosures = Array.from(root.querySelectorAll('[data-buy-disclosure]'));
      if (!disclosures.length) {
        return;
      }

      const desktopQuery = window.matchMedia('(min-width: 960px)');
      const syncDisclosures = () => {
        disclosures.forEach((disclosure) => {
          disclosure.open = desktopQuery.matches;
        });
      };

      syncDisclosures();
      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', syncDisclosures);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(syncDisclosures);
      }
    };

    const bindBundles = (root) => {
      const options = Array.from(root.querySelectorAll('[data-bundle-option]'));
      if (!options.length) {
        return;
      }

      const productForm = root.querySelector('form.product-hero__mock-form');
      const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
      const qtyInput = root.querySelector('[data-selected-bundle-qty]');
      const mainAtcLabel = root.querySelector('[data-main-atc-label]');
      const mainSubmit = productForm ? productForm.querySelector('[data-direct-checkout-submit]') : null;
      const stickyButtons = Array.from(root.querySelectorAll('[data-sticky-bundle-option]'));
      const stickyLabel = root.querySelector('[data-sticky-bundle-label]');
      const stickyPrice = root.querySelector('[data-sticky-price]');
      const stickySubmit = root.querySelector('[data-sticky-submit]');
      const stickyBaseLabel = stickySubmit ? (stickySubmit.getAttribute('data-sticky-base-label') || '').trim() : '';

      const getSelectedPrice = (option) => {
        return option.getAttribute('data-bundle-selected-price') || '';
      };

      const getOptionKey = (option) => {
        return (option.getAttribute('data-bundle-pack-count') || option.getAttribute('data-bundle-variant-id') || '').trim();
      };

      const syncStickyButtons = (selectedOption) => {
        if (!stickyButtons.length) {
          return;
        }

        const selectedKey = getOptionKey(selectedOption);
        stickyButtons.forEach((button) => {
          const isActive = (button.getAttribute('data-bundle-key') || '').trim() === selectedKey;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const getSelectionDetail = (selectedOption) => {
        return {
          source: 'hero',
          variantId: selectedOption.getAttribute('data-bundle-variant-id') || '',
          qty: selectedOption.getAttribute('data-bundle-qty') || '1',
          label: selectedOption.getAttribute('data-bundle-label') || '',
          price: getSelectedPrice(selectedOption),
          packCount: selectedOption.getAttribute('data-bundle-pack-count') || ''
        };
      };

      const findOptionForDetail = (detail) => {
        if (!detail) {
          return null;
        }

        const detailVariantId = String(detail.variantId || '').trim();
        const detailPackCount = String(detail.packCount || '').trim();

        return options.find((option) => {
          const optionVariantId = (option.getAttribute('data-bundle-variant-id') || '').trim();
          const optionPackCount = (option.getAttribute('data-bundle-pack-count') || '').trim();

          if (detailVariantId && optionVariantId && detailVariantId === optionVariantId) {
            return true;
          }

          return detailPackCount && optionPackCount === detailPackCount;
        });
      };

      const announceSelection = (selectedOption) => {
        if (typeof window.CustomEvent !== 'function') {
          return;
        }

        window.dispatchEvent(
          new window.CustomEvent('glarise:pdp-bundle-change', {
            detail: getSelectionDetail(selectedOption)
          })
        );
      };

      const applySelection = (selectedOption, config = {}) => {
        options.forEach((option) => {
          const isActive = option === selectedOption;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const qty = selectedOption.getAttribute('data-bundle-qty') || '1';
        const label = selectedOption.getAttribute('data-bundle-label') || '';
        const price = getSelectedPrice(selectedOption);
        const bundleVariantId = selectedOption.getAttribute('data-bundle-variant-id') || '';

        if (variantInput && bundleVariantId) {
          variantInput.value = bundleVariantId;
        }

        if (qtyInput) {
          qtyInput.value = qty;
        }

        if (mainAtcLabel) {
          mainAtcLabel.textContent = `ADD TO CART - ${price}`;
        }

        if (stickyLabel) {
          stickyLabel.textContent = label;
        }

        if (stickyPrice) {
          stickyPrice.textContent = price;
        }

        if (stickySubmit) {
          const ctaText = stickyBaseLabel || 'ADD TO CART';
          stickySubmit.textContent = price ? `${ctaText} - ${price}` : ctaText;
        }

        syncStickyButtons(selectedOption);

        if (config.announce !== false) {
          announceSelection(selectedOption);
        }
      };

      const navigateToCheckout = () => {
        const selectedQty = ((qtyInput ? qtyInput.value : '1') || '1').trim();
        const selectedVariantId = ((variantInput ? variantInput.value : '') || '').trim();

        if (!selectedVariantId) {
          return false;
        }

        const checkoutUrl = `/cart/${encodeURIComponent(selectedVariantId)}:${encodeURIComponent(selectedQty)}?checkout`;
        window.location.assign(checkoutUrl);
        return true;
      };

      options.forEach((option) => {
        option.addEventListener('click', () => applySelection(option));
      });

      if (stickyButtons.length) {
        stickyButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const buttonKey = (button.getAttribute('data-bundle-key') || '').trim();
            const selectedOption = options.find((option) => getOptionKey(option) === buttonKey);
            if (selectedOption) {
              applySelection(selectedOption);
            }
          });
        });
      }

      const activeOption = options.find((option) => option.classList.contains('is-active')) || options[0];
      if (activeOption) {
        applySelection(activeOption);
      }

      window.addEventListener('glarise:pdp-bundle-select', (event) => {
        const detail = event.detail || {};
        if (detail.source === 'hero') {
          return;
        }

        const matchedOption = findOptionForDetail(detail);
        if (matchedOption) {
          applySelection(matchedOption);
        }
      });

      if (productForm) {
        productForm.addEventListener('submit', (event) => {
          const submitter = event.submitter;
          const shouldDirectCheckout = !submitter || submitter.hasAttribute('data-direct-checkout-submit');
          if (!shouldDirectCheckout) {
            return;
          }

          event.preventDefault();

          if (!navigateToCheckout()) {
            productForm.submit();
          }
        });
      }

      if (stickySubmit) {
        stickySubmit.addEventListener('click', (event) => {
          event.preventDefault();

          if (productForm && typeof productForm.requestSubmit === 'function' && mainSubmit) {
            productForm.requestSubmit(mainSubmit);
            return;
          }

          if (!navigateToCheckout() && productForm) {
            productForm.submit();
          }
        });
      }
    };

    const bindStickyBar = (root) => {
      const stickyBar = root.querySelector('[data-sticky-bar]');
      const heroCta = root.querySelector('[data-hero-cta-trigger]');
      if (!stickyBar || !heroCta) {
        return;
      }

      const desktopQuery = window.matchMedia('(min-width: 960px)');
      let heroObserver = null;
      let heroCtaInView = true;

      const syncStickyVisibility = () => {
        stickyBar.classList.toggle('is-visible', !desktopQuery.matches && !heroCtaInView);
      };

      const bindMode = () => {
        if (heroObserver) {
          heroObserver.disconnect();
          heroObserver = null;
        }

        heroCtaInView = true;
        syncStickyVisibility();

        if (desktopQuery.matches || !('IntersectionObserver' in window)) {
          syncStickyVisibility();
          return;
        }

        heroObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            heroCtaInView = entry.isIntersecting;
            syncStickyVisibility();
          },
          { threshold: 0.4 }
        );

        heroObserver.observe(heroCta);
      };

      bindMode();
      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', bindMode);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(bindMode);
      }
    };

    const bindScrollButtons = (root) => {
      const buttons = Array.from(root.querySelectorAll('[data-scroll-to-bundles]'));
      if (!buttons.length) {
        return;
      }

      const target = root.ownerDocument.querySelector('[data-pdp-desktop-bundles-v6]');
      if (!target) {
        return;
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          target.scrollIntoView({ behavior: prefersReducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
        });
      });
    };

    roots.forEach((root) => {
      bindHeroVideos(root);
      bindCarousel(root);
      bindSwipeHint(root);
      bindLightbox(root);
      bindTestimonialRail(root);
      bindBuyDisclosures(root);
      bindBundles(root);
      bindStickyBar(root);
      bindScrollButtons(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-product-hero-section][data-product-hero-version="original"], [data-product-hero-section]:not([data-product-hero-version]):not(.product-hero--v2)');
    if (!roots.length) {
      return;
    }

    const bindCarousel = (root) => {
      const track = root.querySelector('[data-hero-track]');
      const dotsWrap = root.querySelector('[data-hero-dots]');
      const nextButton = root.querySelector('[data-hero-next]');
      if (!track || !dotsWrap) {
        return;
      }

      const slides = Array.from(track.querySelectorAll('.product-hero__media-slide'));
      if (slides.length < 2) {
        return;
      }

      if (nextButton) {
        nextButton.hidden = false;
      }

      dotsWrap.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-hero__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => {
          const x = slides[index].offsetLeft;
          track.scrollTo({ left: x, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });

      const dots = Array.from(dotsWrap.querySelectorAll('.product-hero__dot'));
      let activeIndex = 0;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const playVideo = (video) => {
        if (!video) {
          return;
        }

        video.dataset.userPaused = 'false';
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      const syncActiveMedia = () => {
        slides.forEach((slide, index) => {
          const video = slide.querySelector('[data-hero-video]');
          if (!video) {
            return;
          }

          if (index !== activeIndex) {
            video.pause();
            video.dataset.userPaused = 'false';
            return;
          }

          if (prefersReducedMotion.matches) {
            return;
          }

          if (video.dataset.userPaused === 'true') {
            return;
          }

          playVideo(video);
        });
      };

      const syncDots = () => {
        const center = track.scrollLeft + track.clientWidth * 0.45;
        let nextActiveIndex = 0;

        slides.forEach((slide, index) => {
          if (slide.offsetLeft <= center) {
            nextActiveIndex = index;
          }
        });

        activeIndex = nextActiveIndex;
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
        syncActiveMedia();
      };

      if (nextButton && nextButton.dataset.bound !== 'true') {
        nextButton.dataset.bound = 'true';
        nextButton.addEventListener('click', () => {
          const nextIndex = (activeIndex + 1) % slides.length;
          track.scrollTo({ left: slides[nextIndex].offsetLeft, behavior: 'smooth' });
        });
      }

      syncDots();
      track.addEventListener('scroll', syncDots, { passive: true });
      window.addEventListener('resize', syncDots);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          slides.forEach((slide) => {
            const video = slide.querySelector('[data-hero-video]');
            if (video) {
              video.pause();
            }
          });
          return;
        }

        syncActiveMedia();
      });
    };

    const bindHeroVideos = (root) => {
      const pauseOtherVideos = (activeVideo) => {
        root.querySelectorAll('[data-hero-video]').forEach((video) => {
          if (video === activeVideo) {
            return;
          }

          video.dataset.userPaused = 'false';
          video.pause();
        });
      };

      root.querySelectorAll('[data-hero-video-shell]').forEach((shell) => {
        if (shell.dataset.videoBound === 'true') {
          return;
        }
        shell.dataset.videoBound = 'true';

        const video = shell.querySelector('[data-hero-video]');
        const toggle = shell.querySelector('[data-hero-video-toggle]');
        if (!video || !toggle) {
          return;
        }

        video.controls = false;

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          shell.classList.toggle('is-playing', isPlaying);
          toggle.setAttribute('aria-label', isPlaying ? 'Pause product video' : 'Play product video');
        };

        const togglePlayback = () => {
          if (!video.paused && !video.ended) {
            video.dataset.userPaused = 'true';
            video.pause();
            return;
          }

          pauseOtherVideos(video);
          video.dataset.userPaused = 'false';
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        };

        toggle.addEventListener('click', togglePlayback);
        video.addEventListener('click', togglePlayback);
        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', syncState);
        syncState();
      });
    };

    const bindSwipeHint = (root) => {
      const hint = root.querySelector('[data-swipe-hint]');
      if (!hint) {
        return;
      }

      const seenKey = 'glarisePdpSwipeHintSeen';
      let hasSeenHint = false;

      try {
        hasSeenHint = window.sessionStorage.getItem(seenKey) === 'true';
      } catch (error) {
        hasSeenHint = false;
      }

      if (hasSeenHint) {
        hint.classList.add('is-hidden');
        return;
      }

      window.setTimeout(() => {
        hint.classList.add('is-hidden');

        try {
          window.sessionStorage.setItem(seenKey, 'true');
        } catch (error) {}
      }, 2000);
    };

    const bindBundles = (root) => {
      const options = Array.from(root.querySelectorAll('[data-bundle-option]'));
      if (!options.length) {
        return;
      }

      const productForm = root.querySelector('form.product-hero__mock-form');
      const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
      const qtyInput = root.querySelector('[data-selected-bundle-qty]');
      const mainAtcLabel = root.querySelector('[data-main-atc-label]');
      const mainSubmit = productForm ? productForm.querySelector('[data-direct-checkout-submit]') : null;
      const stickyLabel = root.querySelector('[data-sticky-bundle-label]');
      const stickyPrice = root.querySelector('[data-sticky-price]');
      const stickySubmit = root.querySelector('[data-sticky-submit]');
      const stickyBaseLabel = stickySubmit ? (stickySubmit.getAttribute('data-sticky-base-label') || '').trim() : '';
      let refreshFrame = null;

      const formatMoney = (cents) => {
        const moneyFormat = window.glariseTheme && window.glariseTheme.moneyFormat ? window.glariseTheme.moneyFormat : null;

        if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        return `$${(Number(cents || 0) / 100).toFixed(2)}`;
      };

      const parseMoneyToCents = (value) => {
        const raw = String(value || '').replace(/[^0-9.,-]/g, '').trim();
        if (!raw) {
          return null;
        }

        const normalized = raw.replace(/,/g, '');
        const amount = Number(normalized);
        if (!Number.isFinite(amount)) {
          return null;
        }

        return Math.round(amount * 100);
      };

      const getDisplayedPrice = (option) => {
        const priceNode = option.querySelector('[data-bundle-price-display]');
        if (priceNode && priceNode.textContent.trim()) {
          return priceNode.textContent.trim();
        }
        return option.getAttribute('data-bundle-price') || '';
      };

      const refreshBundlePricing = () => {
        const referencePriceCents = parseMoneyToCents(getDisplayedPrice(options[0])) || Number(options[0].getAttribute('data-bundle-price-cents') || 0);

        options.forEach((option) => {
          const priceNode = option.querySelector('[data-bundle-price-display]');
          const compareNode = option.querySelector('[data-bundle-compare-display]');
          const saveNode = option.querySelector('[data-bundle-save-display]');
          const badgeNode = option.querySelector('[data-bundle-best-value-badge]');
          const currentPriceCents = parseMoneyToCents(getDisplayedPrice(option)) || Number(option.getAttribute('data-bundle-price-cents') || 0);
          const packCount = Number(option.getAttribute('data-bundle-pack-count') || 1);
          const unitLabel = option.getAttribute('data-bundle-unit-label') || 'Pack';

          if (!currentPriceCents) {
            return;
          }

          option.setAttribute('data-bundle-price-cents', String(currentPriceCents));
          option.setAttribute('data-bundle-price', formatMoney(currentPriceCents));

          if (priceNode && !priceNode.textContent.trim()) {
            priceNode.textContent = formatMoney(currentPriceCents);
          }

          if (packCount > 1) {
            const compareCents = referencePriceCents * packCount;
            if (!(compareCents > currentPriceCents)) {
              if (saveNode) {
                saveNode.textContent = '';
                saveNode.hidden = true;
              }

              if (compareNode) {
                compareNode.textContent = '';
                compareNode.hidden = true;
              }

              if (badgeNode) {
                badgeNode.hidden = true;
              }

              return;
            }

            const savingsCents = Math.max(compareCents - currentPriceCents, 0);
            const unitPriceCents = Math.floor(currentPriceCents / packCount);
            const discountPercent = compareCents > 0 ? (savingsCents / compareCents) * 100 : 0;

            if (compareNode) {
              compareNode.textContent = formatMoney(compareCents);
              compareNode.hidden = false;
            }

            if (saveNode) {
              saveNode.textContent = `Save ${formatMoney(savingsCents)} - ${formatMoney(unitPriceCents)}/${unitLabel}`;
              saveNode.hidden = false;
            }

            if (badgeNode) {
              const threshold = Number(option.getAttribute('data-bundle-badge-threshold') || 30);
              badgeNode.hidden = !(discountPercent >= threshold);
            }
          } else {
            if (saveNode) {
              saveNode.textContent = '';
              saveNode.hidden = true;
            }

            if (compareNode) {
              compareNode.textContent = '';
              compareNode.hidden = true;
            }

            if (badgeNode) {
              badgeNode.hidden = true;
            }
          }
        });

        const activeOption = options.find((option) => option.classList.contains('is-active')) || options[0];
        if (activeOption) {
          applySelection(activeOption);
        }
      };

      const scheduleBundleRefresh = () => {
        if (refreshFrame) {
          return;
        }

        refreshFrame = window.requestAnimationFrame(() => {
          refreshFrame = null;
          refreshBundlePricing();
        });
      };

      const applySelection = (selectedOption) => {
        options.forEach((option) => {
          const isActive = option === selectedOption;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const qty = selectedOption.getAttribute('data-bundle-qty') || '1';
        const label = selectedOption.getAttribute('data-bundle-label') || '';
        const price = getDisplayedPrice(selectedOption);
        const bundleVariantId = selectedOption.getAttribute('data-bundle-variant-id') || '';

        if (variantInput && bundleVariantId) {
          variantInput.value = bundleVariantId;
        }

        if (qtyInput) {
          qtyInput.value = qty;
        }

        if (mainAtcLabel) {
          mainAtcLabel.textContent = `ADD TO CART - ${price}`;
        }

        if (stickyLabel) {
          stickyLabel.textContent = label;
        }

        if (stickyPrice) {
          stickyPrice.textContent = price;
        }

        if (stickySubmit) {
          const ctaText = stickyBaseLabel || 'ADD TO CART';
          stickySubmit.textContent = price ? `${ctaText} - ${price}` : ctaText;
        }
      };

      options.forEach((option) => {
        option.addEventListener('click', () => applySelection(option));

        const priceNode = option.querySelector('[data-bundle-price-display]');
        if (priceNode && 'MutationObserver' in window) {
          const observer = new MutationObserver(scheduleBundleRefresh);
          observer.observe(priceNode, { childList: true, subtree: true, characterData: true });
        }
      });

      refreshBundlePricing();

      const activeOption = options.find((option) => option.classList.contains('is-active')) || options[0];
      if (activeOption) {
        applySelection(activeOption);
      }

      const navigateToCheckout = () => {
        const selectedQty = ((qtyInput ? qtyInput.value : '1') || '1').trim();
        const selectedVariantId = ((variantInput ? variantInput.value : '') || '').trim();

        if (!selectedVariantId) {
          return false;
        }

        const checkoutUrl = `/cart/${encodeURIComponent(selectedVariantId)}:${encodeURIComponent(selectedQty)}?checkout`;
        window.location.assign(checkoutUrl);
        return true;
      };

      if (productForm) {
        productForm.addEventListener('submit', (event) => {
          const submitter = event.submitter;
          const shouldDirectCheckout = !submitter || submitter.hasAttribute('data-direct-checkout-submit');
          if (!shouldDirectCheckout) {
            return;
          }

          event.preventDefault();

          if (!navigateToCheckout()) {
            productForm.submit();
          }
        });
      }

      if (stickySubmit) {
        stickySubmit.addEventListener('click', (event) => {
          event.preventDefault();

          if (productForm && typeof productForm.requestSubmit === 'function' && mainSubmit) {
            productForm.requestSubmit(mainSubmit);
            return;
          }

          if (!navigateToCheckout() && productForm) {
            productForm.submit();
          }
        });
      }
    };

    const bindStickyBar = (root) => {
      const stickyBar = root.querySelector('[data-sticky-bar]');
      const buyZone = root.querySelector('[data-buy-zone]');
      const bundleList = root.querySelector('[data-bundle-list]');
      const formWrap = root.querySelector('.product-hero__form-wrap');
      if (!stickyBar || !buyZone) {
        return;
      }

      stickyBar.hidden = false;

      if (!('IntersectionObserver' in window)) {
        stickyBar.classList.add('is-visible');
        return;
      }

      const stickyTargets = [bundleList, formWrap].filter(Boolean);
      const visibilityTargets = stickyTargets.length ? stickyTargets : [buyZone];
      const targetStates = visibilityTargets.map(() => true);

      const syncStickyVisibility = () => {
        const hasVisibleTarget = targetStates.some(Boolean);
        stickyBar.classList.toggle('is-visible', !hasVisibleTarget);
      };

      visibilityTargets.forEach((target, index) => {
        const observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            targetStates[index] = entry.isIntersecting;
            syncStickyVisibility();
          },
          { threshold: 0.05 }
        );

        observer.observe(target);
      });
    };

    roots.forEach((root) => {
      bindHeroVideos(root);
      bindCarousel(root);
      bindSwipeHint(root);
      bindBundles(root);
      bindStickyBar(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-desktop-bundle-picker-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pdp-desktop-bundles-v3]');
    if (!roots.length) {
      return;
    }

    roots.forEach((root) => {
      let refreshFrame = null;

      const formatMoney = (cents) => {
        const moneyFormat = window.glariseTheme && window.glariseTheme.moneyFormat ? window.glariseTheme.moneyFormat : null;

        if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        return `$${(Number(cents || 0) / 100).toFixed(2)}`;
      };

      const parseMoneyToCents = (value) => {
        const raw = String(value || '').replace(/[^0-9.,-]/g, '').trim();
        if (!raw) {
          return null;
        }

        const normalized = raw.replace(/,/g, '');
        const amount = Number(normalized);
        if (!Number.isFinite(amount)) {
          return null;
        }

        return Math.round(amount * 100);
      };

      const cards = Array.from(root.querySelectorAll('[data-desktop-bundle-card]'));
      const sourceOptions = Array.from(document.querySelectorAll('[data-product-hero-section][data-product-hero-version="v3"] [data-bundle-option]'));
      const stickyLabel = root.querySelector('[data-desktop-sticky-label]');
      const stickyPrice = root.querySelector('[data-desktop-sticky-price]');
      const stickySubmit = root.querySelector('[data-desktop-sticky-submit]');
      const stickyBaseLabel = stickySubmit ? (stickySubmit.getAttribute('data-sticky-base-label') || '').trim() : '';

      const getDisplayedPrice = (node) => {
        const priceNode = node ? node.querySelector('[data-bundle-price-display]') : null;
        if (priceNode && priceNode.textContent.trim()) {
          return priceNode.textContent.trim();
        }

        return node ? node.getAttribute('data-bundle-price') || '' : '';
      };

      const getCardLabel = (card) => {
        const titleNode = card ? card.querySelector('h3') : null;
        return titleNode ? titleNode.textContent.trim() : '';
      };

      const getCardVariantId = (card) => {
        return card ? (card.querySelector('input[name="id"]')?.value || '').trim() : '';
      };

      const getCardQuantity = (card) => {
        return card ? (card.querySelector('input[name="quantity"]')?.value || '1').trim() : '1';
      };

      const getCardPackCount = (card) => {
        return card ? (card.getAttribute('data-bundle-pack-count') || '').trim() : '';
      };

      const getSelectedCard = () => {
        return cards.find((card) => card.classList.contains('is-active')) || null;
      };

      const updateStickyBar = (card) => {
        if (!card) {
          return;
        }

        const label = getCardLabel(card);
        const price = getDisplayedPrice(card);
        const submitButton = card.querySelector('[name="add"]');

        if (stickyLabel) {
          stickyLabel.textContent = label;
        }

        if (stickyPrice) {
          stickyPrice.textContent = price;
        }

        if (stickySubmit) {
          const ctaText = stickyBaseLabel || 'ADD TO CART';
          stickySubmit.textContent = price ? `${ctaText} - ${price}` : ctaText;
          stickySubmit.disabled = !submitButton || submitButton.hasAttribute('disabled');
        }
      };

      const findCardForDetail = (detail) => {
        if (!detail) {
          return null;
        }

        const detailVariantId = String(detail.variantId || '').trim();
        const detailPackCount = String(detail.packCount || '').trim();

        return cards.find((card) => {
          const cardVariantId = getCardVariantId(card);
          const cardPackCount = getCardPackCount(card);

          if (detailVariantId && cardVariantId && detailVariantId === cardVariantId) {
            return true;
          }

          return detailPackCount && cardPackCount === detailPackCount;
        });
      };

      const applyActiveCard = (card, config = {}) => {
        if (!card) {
          return;
        }

        cards.forEach((item) => {
          item.classList.toggle('is-active', item === card);
        });

        updateStickyBar(card);

        if (config.requestHeroSync === false || typeof window.CustomEvent !== 'function') {
          return;
        }

        window.dispatchEvent(
          new window.CustomEvent('glarise:v3-bundle-select', {
            detail: {
              source: 'desktop',
              variantId: getCardVariantId(card),
              qty: getCardQuantity(card),
              label: getCardLabel(card),
              price: getDisplayedPrice(card),
              packCount: getCardPackCount(card)
            }
          })
        );
      };

      const navigateToCheckout = (card) => {
        const variantId = getCardVariantId(card);
        const quantity = getCardQuantity(card);

        if (!variantId) {
          return false;
        }

        const checkoutUrl = `${window.routes.cart_url}/${encodeURIComponent(variantId)}:${encodeURIComponent(quantity)}?checkout`;
        window.location.assign(checkoutUrl);
        return true;
      };

      const getSourceOptionForCard = (card) => {
        if (!sourceOptions.length) {
          return null;
        }

        const cardVariantId = card.querySelector('input[name="id"]')?.value || '';
        const cardPackCount = card.getAttribute('data-bundle-pack-count') || '';

        return sourceOptions.find((option) => {
          const optionVariantId = option.getAttribute('data-bundle-variant-id') || '';
          const optionPackCount = option.getAttribute('data-bundle-pack-count') || '';

          if (cardVariantId && optionVariantId && optionVariantId === cardVariantId) {
            return true;
          }

          return cardPackCount != '' && optionPackCount === cardPackCount;
        });
      };

      const syncCardPriceFromSource = (card) => {
        const sourceOption = getSourceOptionForCard(card);
        if (!sourceOption) {
          return;
        }

        const sourcePrice = getDisplayedPrice(sourceOption);
        if (!sourcePrice) {
          return;
        }

        const priceNode = card.querySelector('[data-bundle-price-display]');
        if (priceNode) {
          priceNode.textContent = sourcePrice;
        }

        const sourcePriceCents =
          parseMoneyToCents(sourcePrice) || Number(sourceOption.getAttribute('data-bundle-price-cents') || 0);
        if (sourcePriceCents) {
          card.setAttribute('data-bundle-price-cents', String(sourcePriceCents));
        }
      };

      const refreshBundlePricing = () => {
        if (!cards.length) {
          return;
        }

        cards.forEach((card) => {
          syncCardPriceFromSource(card);
        });

        const firstCardPrice = cards[0].querySelector('[data-bundle-price-display]');
        const referencePriceCents = parseMoneyToCents(firstCardPrice ? firstCardPrice.textContent : '') || Number(cards[0].getAttribute('data-bundle-price-cents') || 0);

        cards.forEach((card) => {
          const packCount = Number(card.getAttribute('data-bundle-pack-count') || 1);
          const unitLabel = card.getAttribute('data-bundle-unit-label') || 'Pack';
          const priceNode = card.querySelector('[data-bundle-price-display]');
          const compareNode = card.querySelector('[data-bundle-compare-display]');
          const saveNode = card.querySelector('[data-bundle-save-display]');
          const badgeNode = card.querySelector('[data-bundle-best-value-badge]');
          const currentPriceCents = parseMoneyToCents(priceNode ? priceNode.textContent : '') || Number(card.getAttribute('data-bundle-price-cents') || 0);

          if (!currentPriceCents) {
            return;
          }

          card.setAttribute('data-bundle-price-cents', String(currentPriceCents));

          if (packCount > 1) {
            const compareCents = referencePriceCents * packCount;
            if (!(compareCents > currentPriceCents)) {
              if (saveNode) {
                saveNode.textContent = '';
                saveNode.hidden = true;
              }

              if (compareNode) {
                compareNode.textContent = '';
                compareNode.hidden = true;
              }

              if (badgeNode) {
                badgeNode.hidden = true;
              }

              return;
            }

            const savingsCents = Math.max(compareCents - currentPriceCents, 0);
            const unitPriceCents = Math.floor(currentPriceCents / packCount);
            const discountPercent = compareCents > 0 ? (savingsCents / compareCents) * 100 : 0;

            if (compareNode) {
              compareNode.textContent = formatMoney(compareCents);
              compareNode.hidden = false;
            }

            if (saveNode) {
              saveNode.textContent = `Save ${formatMoney(savingsCents)} - ${formatMoney(unitPriceCents)}/${unitLabel}`;
              saveNode.hidden = false;
            }

            if (badgeNode) {
              const threshold = Number(card.getAttribute('data-bundle-badge-threshold') || 30);
              badgeNode.hidden = !(discountPercent >= threshold);
            }
          } else {
            if (saveNode) {
              saveNode.textContent = '';
              saveNode.hidden = true;
            }

            if (compareNode) {
              compareNode.textContent = '';
              compareNode.hidden = true;
            }

            if (badgeNode) {
              badgeNode.hidden = true;
            }
          }
        });

        updateStickyBar(getSelectedCard());
      };

      const scheduleBundleRefresh = () => {
        if (refreshFrame) {
          return;
        }

        refreshFrame = window.requestAnimationFrame(() => {
          refreshFrame = null;
          refreshBundlePricing();
        });
      };

      cards.forEach((card) => {
        const priceNode = card.querySelector('[data-bundle-price-display]');
        if (priceNode && 'MutationObserver' in window) {
          const observer = new MutationObserver(scheduleBundleRefresh);
          observer.observe(priceNode, { childList: true, subtree: true, characterData: true });
        }
      });

      sourceOptions.forEach((option) => {
        const priceNode = option.querySelector('[data-bundle-price-display]');
        if (priceNode && 'MutationObserver' in window) {
          const observer = new MutationObserver(scheduleBundleRefresh);
          observer.observe(priceNode, { childList: true, subtree: true, characterData: true });
        }
      });

      refreshBundlePricing();

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          applyActiveCard(card);
        });
      });

      const activeSourceOption = sourceOptions.find((option) => option.classList.contains('is-active'));
      const initialCard =
        findCardForDetail({
          variantId: activeSourceOption ? activeSourceOption.getAttribute('data-bundle-variant-id') || '' : '',
          packCount: activeSourceOption ? activeSourceOption.getAttribute('data-bundle-pack-count') || '' : ''
        }) ||
        cards.find((card) => card.classList.contains('pdp-desktop-bundles__card--featured')) ||
        cards[0];

      applyActiveCard(initialCard, { requestHeroSync: false });

      window.addEventListener('glarise:v3-bundle-change', (event) => {
        const matchedCard = findCardForDetail(event.detail || {});
        if (matchedCard) {
          applyActiveCard(matchedCard, { requestHeroSync: false });
        }
      });

      if (stickySubmit) {
        stickySubmit.addEventListener('click', (event) => {
          event.preventDefault();

          const activeCard = getSelectedCard() || cards[0];
          if (!navigateToCheckout(activeCard)) {
            applyActiveCard(activeCard);
          }
        });
      }

      root.querySelectorAll('[data-desktop-bundle-form]').forEach((form) => {
        if (form.dataset.bound === 'true') {
          return;
        }

        form.dataset.bound = 'true';
        const submitButton = form.querySelector('[name="add"]');
        const errorMessage = form.querySelector('[data-desktop-bundle-error]');

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const card = form.closest('[data-desktop-bundle-card]');

          if (card) {
            applyActiveCard(card);
          }

          if (!submitButton || submitButton.hasAttribute('disabled')) {
            return;
          }

          if (errorMessage) {
            errorMessage.hidden = true;
            errorMessage.textContent = '';
          }

          const formData = new FormData(form);
          const variantId = Number(formData.get('id'));
          const quantity = Number(formData.get('quantity') || 1);

          if (!variantId) {
            if (errorMessage) {
              errorMessage.hidden = false;
              errorMessage.textContent = 'This bundle is not available right now.';
            }
            return;
          }

          submitButton.setAttribute('disabled', 'disabled');
          submitButton.classList.add('is-loading');
          navigateToCheckout(card);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-desktop-bundle-picker-v5-price-test"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pdp-desktop-bundles]');
    if (!roots.length) {
      return;
    }

    roots.forEach((root) => {
      let refreshFrame = null;

      const formatMoney = (cents) => {
        const moneyFormat = window.glariseTheme && window.glariseTheme.moneyFormat ? window.glariseTheme.moneyFormat : null;

        if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        return `$${(Number(cents || 0) / 100).toFixed(2)}`;
      };

      const parseMoneyToCents = (value) => {
        const raw = String(value || '').replace(/[^0-9.,-]/g, '').trim();
        if (!raw) {
          return null;
        }

        const normalized = raw.replace(/,/g, '');
        const amount = Number(normalized);
        if (!Number.isFinite(amount)) {
          return null;
        }

        return Math.round(amount * 100);
      };

      const cards = Array.from(root.querySelectorAll('[data-desktop-bundle-card]'));
      const heroRoot = document.querySelector('[data-product-hero-section][data-product-hero-version="v5-price-test"]');
      const sourceOptions = Array.from(document.querySelectorAll('[data-product-hero-section][data-product-hero-version="v5-price-test"] [data-bundle-option]'));
      const stickyLabel = root.querySelector('[data-desktop-sticky-label]');
      const stickyPrice = root.querySelector('[data-desktop-sticky-price]');
      const stickySubmit = root.querySelector('[data-desktop-sticky-submit]');
      const stickyBaseLabel = stickySubmit ? (stickySubmit.getAttribute('data-sticky-base-label') || '').trim() : '';

      const formatShippingDisplayLabel = (cents) => {
        return Number(cents || 0) > 0 ? `${formatMoney(cents)} SHIPPING` : 'FREE SHIPPING';
      };

      const formatShippingLineLabel = (cents) => {
        return Number(cents || 0) > 0 ? `${formatMoney(cents)} Shipping` : 'FREE Shipping';
      };

      const getHeroPricingState = () => {
        const firstCardPrice = cards[0] ? getDisplayedPrice(cards[0]) : '';
        return {
          singlePackShippingCents:
            Number(heroRoot ? heroRoot.getAttribute('data-active-single-pack-shipping-cents') || 0 : 0) || 0,
          bundle1PriceCents:
            Number(heroRoot ? heroRoot.getAttribute('data-active-bundle-1-price-cents') || 0 : 0) ||
            parseMoneyToCents(firstCardPrice) ||
            Number(cards[0]?.getAttribute('data-bundle-price-cents') || 0),
          bundle2PriceCents: Number(heroRoot ? heroRoot.getAttribute('data-active-bundle-2-price-cents') || 0 : 0) || 0,
          bundle3PriceCents: Number(heroRoot ? heroRoot.getAttribute('data-active-bundle-3-price-cents') || 0 : 0) || 0
        };
      };

      const getDisplayedPrice = (node) => {
        const priceNode = node ? node.querySelector('[data-bundle-price-display]') : null;
        if (priceNode && priceNode.textContent.trim()) {
          return priceNode.textContent.trim();
        }

        return node ? node.getAttribute('data-bundle-selected-price') || node.getAttribute('data-bundle-price') || '' : '';
      };

      const getCardLabel = (card) => {
        const titleNode = card ? card.querySelector('h3') : null;
        return titleNode ? titleNode.textContent.trim() : '';
      };

      const getCardVariantId = (card) => {
        return card ? (card.querySelector('input[name="id"]')?.value || '').trim() : '';
      };

      const getCardQuantity = (card) => {
        return card ? (card.querySelector('input[name="quantity"]')?.value || '1').trim() : '1';
      };

      const getCardPackCount = (card) => {
        return card ? (card.getAttribute('data-bundle-pack-count') || '').trim() : '';
      };

      const getSelectedCard = () => {
        return cards.find((card) => card.classList.contains('is-active')) || null;
      };

      const updateFirstCardShipping = (shippingCents) => {
        const firstCard = cards[0];
        if (!firstCard) {
          return;
        }

        const shippingDisplayNode = firstCard.querySelector('[data-bundle-shipping-display]');
        const shippingLineNode = firstCard.querySelector('[data-bundle-shipping-line]');
        const isFreeShipping = !(Number(shippingCents || 0) > 0);

        if (shippingDisplayNode) {
          shippingDisplayNode.textContent = formatShippingDisplayLabel(shippingCents);
          shippingDisplayNode.classList.toggle('pdp-desktop-bundles__shipping--free', isFreeShipping);
        }

        if (shippingLineNode) {
          shippingLineNode.textContent = formatShippingLineLabel(shippingCents);
          shippingLineNode.classList.toggle('pdp-desktop-bundles__shipping-line--free', isFreeShipping);
        }
      };

      const updateStickyBar = (card) => {
        if (!card) {
          return;
        }

        const label = getCardLabel(card);
        const price = getDisplayedPrice(card);
        const submitButton = card.querySelector('[name="add"]');

        if (stickyLabel) {
          stickyLabel.textContent = label;
        }

        if (stickyPrice) {
          stickyPrice.textContent = price;
        }

        if (stickySubmit) {
          const ctaText = stickyBaseLabel || 'ADD TO CART';
          stickySubmit.textContent = price ? `${ctaText} - ${price}` : ctaText;
          stickySubmit.disabled = !submitButton || submitButton.hasAttribute('disabled');
        }
      };

      const findCardForDetail = (detail) => {
        if (!detail) {
          return null;
        }

        const detailVariantId = String(detail.variantId || '').trim();
        const detailPackCount = String(detail.packCount || '').trim();

        return cards.find((card) => {
          const cardVariantId = getCardVariantId(card);
          const cardPackCount = getCardPackCount(card);

          if (detailVariantId && cardVariantId && detailVariantId === cardVariantId) {
            return true;
          }

          return detailPackCount && cardPackCount === detailPackCount;
        });
      };

      const applyActiveCard = (card, config = {}) => {
        if (!card) {
          return;
        }

        cards.forEach((item) => {
          item.classList.toggle('is-active', item === card);
        });

        updateStickyBar(card);

        if (config.requestHeroSync === false || typeof window.CustomEvent !== 'function') {
          return;
        }

        window.dispatchEvent(
          new window.CustomEvent('glarise:pdp-bundle-select', {
            detail: {
              source: 'desktop',
              variantId: getCardVariantId(card),
              qty: getCardQuantity(card),
              label: getCardLabel(card),
              price: getDisplayedPrice(card),
              packCount: getCardPackCount(card)
            }
          })
        );
      };

      const navigateToCheckout = (card) => {
        const variantId = getCardVariantId(card);
        const quantity = getCardQuantity(card);

        if (!variantId) {
          return false;
        }

        const checkoutUrl = new URL(`${window.routes.cart_url}/${encodeURIComponent(variantId)}:${encodeURIComponent(quantity)}`, window.location.origin);
        const igId = window.igData && window.igData.user ? window.igData.user.igId : '';

        if (igId) {
          checkoutUrl.searchParams.set('attributes[igId]', igId);
        }

        window.location.assign(checkoutUrl.toString());
        return true;
      };

      const getDisplayedPriceCentsForCard = (card, pricingState) => {
        const packCount = Number(card ? card.getAttribute('data-bundle-pack-count') || 1 : 1);
        if (packCount === 1) {
          return Number(pricingState.bundle1PriceCents || 0) + Number(pricingState.singlePackShippingCents || 0);
        }

        if (packCount === 2) {
          return Number(pricingState.bundle2PriceCents || 0);
        }

        if (packCount === 3) {
          return Number(pricingState.bundle3PriceCents || 0);
        }

        return 0;
      };

      const refreshBundlePricing = () => {
        if (!cards.length) {
          return;
        }

        const pricingState = getHeroPricingState();
        const referencePriceCents = Number(pricingState.bundle1PriceCents || 0) + Number(pricingState.singlePackShippingCents || 0);
        updateFirstCardShipping(pricingState.singlePackShippingCents);

        cards.forEach((card) => {
          const packCount = Number(card.getAttribute('data-bundle-pack-count') || 1);
          const unitLabel = card.getAttribute('data-bundle-unit-label') || 'Pack';
          const priceNode = card.querySelector('[data-bundle-price-display]');
          const compareNode = card.querySelector('[data-bundle-compare-display]');
          const saveNode = card.querySelector('[data-bundle-save-display]');
          const badgeNode = card.querySelector('[data-bundle-best-value-badge]');
          const currentPriceCents = getDisplayedPriceCentsForCard(card, pricingState) || parseMoneyToCents(priceNode ? priceNode.textContent : '') || Number(card.getAttribute('data-bundle-price-cents') || 0);

          if (!currentPriceCents) {
            return;
          }

          if (priceNode) {
            priceNode.textContent = formatMoney(currentPriceCents);
          }

          card.setAttribute('data-bundle-price-cents', String(currentPriceCents));

          if (packCount > 1) {
            const compareCents = referencePriceCents * packCount;
            if (!(compareCents > currentPriceCents)) {
              if (saveNode) {
                saveNode.textContent = '';
                saveNode.hidden = true;
              }

              if (compareNode) {
                compareNode.textContent = '';
                compareNode.hidden = true;
              }

              if (badgeNode) {
                badgeNode.hidden = true;
              }

              return;
            }

            const savingsCents = Math.max(compareCents - currentPriceCents, 0);
            const unitPriceCents = Math.round(currentPriceCents / packCount);
            const discountPercent = compareCents > 0 ? (savingsCents / compareCents) * 100 : 0;

            if (compareNode) {
              compareNode.textContent = formatMoney(compareCents);
              compareNode.hidden = false;
            }

            if (saveNode) {
              saveNode.textContent = `Save ${formatMoney(savingsCents)} - ${formatMoney(unitPriceCents)}/${unitLabel}`;
              saveNode.hidden = false;
            }

            if (badgeNode) {
              const threshold = Number(card.getAttribute('data-bundle-badge-threshold') || 30);
              badgeNode.hidden = !(discountPercent >= threshold);
            }
          } else {
            if (saveNode) {
              saveNode.textContent = '';
              saveNode.hidden = true;
            }

            if (compareNode) {
              compareNode.textContent = '';
              compareNode.hidden = true;
            }

            if (badgeNode) {
              badgeNode.hidden = true;
            }
          }
        });

        updateStickyBar(getSelectedCard());
      };

      const scheduleBundleRefresh = () => {
        if (refreshFrame) {
          return;
        }

        refreshFrame = window.requestAnimationFrame(() => {
          refreshFrame = null;
          refreshBundlePricing();
        });
      };

      const startBundlePricingMonitor = () => {
        scheduleBundleRefresh();
        window.setInterval(scheduleBundleRefresh, 400);
      };

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          applyActiveCard(card);
        });
      });

      if (heroRoot && 'MutationObserver' in window) {
        const observer = new MutationObserver(scheduleBundleRefresh);
        observer.observe(heroRoot, { attributes: true });
      }

      window.addEventListener('glarise:v5-pricing-change', scheduleBundleRefresh);

      startBundlePricingMonitor();

      const activeSourceOption = sourceOptions.find((option) => option.classList.contains('is-active'));
      const initialCard =
        findCardForDetail({
          variantId: activeSourceOption ? activeSourceOption.getAttribute('data-bundle-variant-id') || '' : '',
          packCount: activeSourceOption ? activeSourceOption.getAttribute('data-bundle-pack-count') || '' : ''
        }) ||
        cards.find((card) => card.classList.contains('pdp-desktop-bundles__card--featured')) ||
        cards[0];

      applyActiveCard(initialCard, { requestHeroSync: false });

      window.addEventListener('glarise:pdp-bundle-change', (event) => {
        const matchedCard = findCardForDetail(event.detail || {});
        if (matchedCard) {
          applyActiveCard(matchedCard, { requestHeroSync: false });
        }
      });

      if (stickySubmit) {
        stickySubmit.addEventListener('click', (event) => {
          event.preventDefault();

          const activeCard = getSelectedCard() || cards[0];
          if (!navigateToCheckout(activeCard)) {
            applyActiveCard(activeCard);
          }
        });
      }

      root.querySelectorAll('[data-desktop-bundle-form]').forEach((form) => {
        if (form.dataset.bound === 'true') {
          return;
        }

        form.dataset.bound = 'true';
        const submitButton = form.querySelector('[name="add"]');
        const errorMessage = form.querySelector('[data-desktop-bundle-error]');

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const card = form.closest('[data-desktop-bundle-card]');

          if (card) {
            applyActiveCard(card);
          }

          if (!submitButton || submitButton.hasAttribute('disabled')) {
            return;
          }

          if (errorMessage) {
            errorMessage.hidden = true;
            errorMessage.textContent = '';
          }

          const formData = new FormData(form);
          const variantId = Number(formData.get('id'));
          const quantity = Number(formData.get('quantity') || 1);

          if (!variantId) {
            if (errorMessage) {
              errorMessage.hidden = false;
              errorMessage.textContent = 'This bundle is not available right now.';
            }
            return;
          }

          submitButton.setAttribute('disabled', 'disabled');
          submitButton.classList.add('is-loading');
          navigateToCheckout(card);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-desktop-bundle-picker-v6-benefit-framing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pdp-desktop-bundles]');
    if (!roots.length) {
      return;
    }

    roots.forEach((root) => {
      let refreshFrame = null;

      const formatMoney = (cents) => {
        const moneyFormat = window.glariseTheme && window.glariseTheme.moneyFormat ? window.glariseTheme.moneyFormat : null;

        if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        return `$${(Number(cents || 0) / 100).toFixed(2)}`;
      };

      const parseMoneyToCents = (value) => {
        const raw = String(value || '').replace(/[^0-9.,-]/g, '').trim();
        if (!raw) {
          return null;
        }

        const normalized = raw.replace(/,/g, '');
        const amount = Number(normalized);
        if (!Number.isFinite(amount)) {
          return null;
        }

        return Math.round(amount * 100);
      };

      const cards = Array.from(root.querySelectorAll('[data-desktop-bundle-card]'));
      const sourceOptions = Array.from(document.querySelectorAll('[data-product-hero-section] [data-bundle-option]'));
      const stickyLabel = root.querySelector('[data-desktop-sticky-label]');
      const stickyPrice = root.querySelector('[data-desktop-sticky-price]');
      const stickySubmit = root.querySelector('[data-desktop-sticky-submit]');
      const stickyBaseLabel = stickySubmit ? (stickySubmit.getAttribute('data-sticky-base-label') || '').trim() : '';

      const getDisplayedPrice = (node) => {
        const priceNode = node ? node.querySelector('[data-bundle-price-display]') : null;
        if (priceNode && priceNode.textContent.trim()) {
          return priceNode.textContent.trim();
        }

        return node ? node.getAttribute('data-bundle-price') || '' : '';
      };

      const getCardLabel = (card) => {
        const titleNode = card ? card.querySelector('h3') : null;
        return titleNode ? titleNode.textContent.trim() : '';
      };

      const getCardVariantId = (card) => {
        return card ? (card.querySelector('input[name="id"]')?.value || '').trim() : '';
      };

      const getCardQuantity = (card) => {
        return card ? (card.querySelector('input[name="quantity"]')?.value || '1').trim() : '1';
      };

      const getCardPackCount = (card) => {
        return card ? (card.getAttribute('data-bundle-pack-count') || '').trim() : '';
      };

      const getSelectedCard = () => {
        return cards.find((card) => card.classList.contains('is-active')) || null;
      };

      const updateStickyBar = (card) => {
        if (!card) {
          return;
        }

        const label = getCardLabel(card);
        const price = getDisplayedPrice(card);
        const submitButton = card.querySelector('[name="add"]');

        if (stickyLabel) {
          stickyLabel.textContent = label;
        }

        if (stickyPrice) {
          stickyPrice.textContent = price;
        }

        if (stickySubmit) {
          const ctaText = stickyBaseLabel || 'ADD TO CART';
          stickySubmit.textContent = price ? `${ctaText} - ${price}` : ctaText;
          stickySubmit.disabled = !submitButton || submitButton.hasAttribute('disabled');
        }
      };

      const findCardForDetail = (detail) => {
        if (!detail) {
          return null;
        }

        const detailVariantId = String(detail.variantId || '').trim();
        const detailPackCount = String(detail.packCount || '').trim();

        return cards.find((card) => {
          const cardVariantId = getCardVariantId(card);
          const cardPackCount = getCardPackCount(card);

          if (detailVariantId && cardVariantId && detailVariantId === cardVariantId) {
            return true;
          }

          return detailPackCount && cardPackCount === detailPackCount;
        });
      };

      const applyActiveCard = (card, config = {}) => {
        if (!card) {
          return;
        }

        cards.forEach((item) => {
          item.classList.toggle('is-active', item === card);
        });

        updateStickyBar(card);

        if (config.requestHeroSync === false || typeof window.CustomEvent !== 'function') {
          return;
        }

        window.dispatchEvent(
          new window.CustomEvent('glarise:pdp-bundle-select', {
            detail: {
              source: 'desktop',
              variantId: getCardVariantId(card),
              qty: getCardQuantity(card),
              label: getCardLabel(card),
              price: getDisplayedPrice(card),
              packCount: getCardPackCount(card)
            }
          })
        );
      };

      const navigateToCheckout = (card) => {
        const variantId = getCardVariantId(card);
        const quantity = getCardQuantity(card);

        if (!variantId) {
          return false;
        }

        const checkoutUrl = `${window.routes.cart_url}/${encodeURIComponent(variantId)}:${encodeURIComponent(quantity)}?checkout`;
        window.location.assign(checkoutUrl);
        return true;
      };

      const getSourceOptionForCard = (card) => {
        if (!sourceOptions.length) {
          return null;
        }

        const cardVariantId = card.querySelector('input[name="id"]')?.value || '';
        const cardPackCount = card.getAttribute('data-bundle-pack-count') || '';

        return sourceOptions.find((option) => {
          const optionVariantId = option.getAttribute('data-bundle-variant-id') || '';
          const optionPackCount = option.getAttribute('data-bundle-pack-count') || '';

          if (cardVariantId && optionVariantId && optionVariantId === cardVariantId) {
            return true;
          }

          return cardPackCount != '' && optionPackCount === cardPackCount;
        });
      };

      const syncCardPriceFromSource = (card) => {
        const sourceOption = getSourceOptionForCard(card);
        if (!sourceOption) {
          return;
        }

        const sourcePrice = getDisplayedPrice(sourceOption);
        if (!sourcePrice) {
          return;
        }

        const priceNode = card.querySelector('[data-bundle-price-display]');
        if (priceNode) {
          priceNode.textContent = sourcePrice;
        }

        const sourcePriceCents =
          parseMoneyToCents(sourcePrice) || Number(sourceOption.getAttribute('data-bundle-price-cents') || 0);
        if (sourcePriceCents) {
          card.setAttribute('data-bundle-price-cents', String(sourcePriceCents));
        }
      };

      const refreshBundlePricing = () => {
        if (!cards.length) {
          return;
        }

        cards.forEach((card) => {
          syncCardPriceFromSource(card);
        });

        const firstCardPrice = cards[0].querySelector('[data-bundle-price-display]');
        const referencePriceCents = parseMoneyToCents(firstCardPrice ? firstCardPrice.textContent : '') || Number(cards[0].getAttribute('data-bundle-price-cents') || 0);

        cards.forEach((card) => {
          const packCount = Number(card.getAttribute('data-bundle-pack-count') || 1);
          const unitLabel = card.getAttribute('data-bundle-unit-label') || 'Pack';
          const priceNode = card.querySelector('[data-bundle-price-display]');
          const compareNode = card.querySelector('[data-bundle-compare-display]');
          const saveNode = card.querySelector('[data-bundle-save-display]');
          const badgeNode = card.querySelector('[data-bundle-best-value-badge]');
          const currentPriceCents = parseMoneyToCents(priceNode ? priceNode.textContent : '') || Number(card.getAttribute('data-bundle-price-cents') || 0);

          if (!currentPriceCents) {
            return;
          }

          card.setAttribute('data-bundle-price-cents', String(currentPriceCents));

          if (packCount > 1) {
            const compareCents = referencePriceCents * packCount;
            if (!(compareCents > currentPriceCents)) {
              if (saveNode) {
                saveNode.textContent = '';
                saveNode.hidden = true;
              }

              if (compareNode) {
                compareNode.textContent = '';
                compareNode.hidden = true;
              }

              if (badgeNode) {
                badgeNode.hidden = true;
              }

              return;
            }

            const savingsCents = Math.max(compareCents - currentPriceCents, 0);
            const unitPriceCents = Math.floor(currentPriceCents / packCount);
            const discountPercent = compareCents > 0 ? (savingsCents / compareCents) * 100 : 0;

            if (compareNode) {
              compareNode.textContent = formatMoney(compareCents);
              compareNode.hidden = false;
            }

            if (saveNode) {
              saveNode.textContent = `Save ${formatMoney(savingsCents)} - ${formatMoney(unitPriceCents)}/${unitLabel}`;
              saveNode.hidden = false;
            }

            if (badgeNode) {
              const threshold = Number(card.getAttribute('data-bundle-badge-threshold') || 30);
              badgeNode.hidden = !(discountPercent >= threshold);
            }
          } else {
            if (saveNode) {
              saveNode.textContent = '';
              saveNode.hidden = true;
            }

            if (compareNode) {
              compareNode.textContent = '';
              compareNode.hidden = true;
            }

            if (badgeNode) {
              badgeNode.hidden = true;
            }
          }
        });

        updateStickyBar(getSelectedCard());
      };

      const scheduleBundleRefresh = () => {
        if (refreshFrame) {
          return;
        }

        refreshFrame = window.requestAnimationFrame(() => {
          refreshFrame = null;
          refreshBundlePricing();
        });
      };

      cards.forEach((card) => {
        const priceNode = card.querySelector('[data-bundle-price-display]');
        if (priceNode && 'MutationObserver' in window) {
          const observer = new MutationObserver(scheduleBundleRefresh);
          observer.observe(priceNode, { childList: true, subtree: true, characterData: true });
        }
      });

      sourceOptions.forEach((option) => {
        const priceNode = option.querySelector('[data-bundle-price-display]');
        if (priceNode && 'MutationObserver' in window) {
          const observer = new MutationObserver(scheduleBundleRefresh);
          observer.observe(priceNode, { childList: true, subtree: true, characterData: true });
        }
      });

      refreshBundlePricing();

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          applyActiveCard(card);
        });
      });

      const activeSourceOption = sourceOptions.find((option) => option.classList.contains('is-active'));
      const initialCard =
        findCardForDetail({
          variantId: activeSourceOption ? activeSourceOption.getAttribute('data-bundle-variant-id') || '' : '',
          packCount: activeSourceOption ? activeSourceOption.getAttribute('data-bundle-pack-count') || '' : ''
        }) ||
        cards.find((card) => card.classList.contains('pdp-desktop-bundles__card--featured')) ||
        cards[0];

      applyActiveCard(initialCard, { requestHeroSync: false });

      window.addEventListener('glarise:pdp-bundle-change', (event) => {
        const matchedCard = findCardForDetail(event.detail || {});
        if (matchedCard) {
          applyActiveCard(matchedCard, { requestHeroSync: false });
        }
      });

      if (stickySubmit) {
        stickySubmit.addEventListener('click', (event) => {
          event.preventDefault();

          const activeCard = getSelectedCard() || cards[0];
          if (!navigateToCheckout(activeCard)) {
            applyActiveCard(activeCard);
          }
        });
      }

      root.querySelectorAll('[data-desktop-bundle-form]').forEach((form) => {
        if (form.dataset.bound === 'true') {
          return;
        }

        form.dataset.bound = 'true';
        const submitButton = form.querySelector('[name="add"]');
        const errorMessage = form.querySelector('[data-desktop-bundle-error]');

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const card = form.closest('[data-desktop-bundle-card]');

          if (card) {
            applyActiveCard(card);
          }

          if (!submitButton || submitButton.hasAttribute('disabled')) {
            return;
          }

          if (errorMessage) {
            errorMessage.hidden = true;
            errorMessage.textContent = '';
          }

          const formData = new FormData(form);
          const variantId = Number(formData.get('id'));
          const quantity = Number(formData.get('quantity') || 1);

          if (!variantId) {
            if (errorMessage) {
              errorMessage.hidden = false;
              errorMessage.textContent = 'This bundle is not available right now.';
            }
            return;
          }

          submitButton.setAttribute('disabled', 'disabled');
          submitButton.classList.add('is-loading');
          navigateToCheckout(card);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-desktop-bundle-picker"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pdp-desktop-bundles]');
    if (!roots.length) {
      return;
    }

    roots.forEach((root) => {
      let refreshFrame = null;

      const formatMoney = (cents) => {
        const moneyFormat = window.glariseTheme && window.glariseTheme.moneyFormat ? window.glariseTheme.moneyFormat : null;

        if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        return `$${(Number(cents || 0) / 100).toFixed(2)}`;
      };

      const parseMoneyToCents = (value) => {
        const raw = String(value || '').replace(/[^0-9.,-]/g, '').trim();
        if (!raw) {
          return null;
        }

        const normalized = raw.replace(/,/g, '');
        const amount = Number(normalized);
        if (!Number.isFinite(amount)) {
          return null;
        }

        return Math.round(amount * 100);
      };

      const cards = Array.from(root.querySelectorAll('[data-desktop-bundle-card]'));
      const sourceOptions = Array.from(document.querySelectorAll('[data-product-hero-section] [data-bundle-option]'));
      const stickyLabel = root.querySelector('[data-desktop-sticky-label]');
      const stickyPrice = root.querySelector('[data-desktop-sticky-price]');
      const stickySubmit = root.querySelector('[data-desktop-sticky-submit]');
      const stickyBaseLabel = stickySubmit ? (stickySubmit.getAttribute('data-sticky-base-label') || '').trim() : '';

      const getDisplayedPrice = (node) => {
        const priceNode = node ? node.querySelector('[data-bundle-price-display]') : null;
        if (priceNode && priceNode.textContent.trim()) {
          return priceNode.textContent.trim();
        }

        return node ? node.getAttribute('data-bundle-price') || '' : '';
      };

      const getCardLabel = (card) => {
        const titleNode = card ? card.querySelector('h3') : null;
        return titleNode ? titleNode.textContent.trim() : '';
      };

      const getCardVariantId = (card) => {
        return card ? (card.querySelector('input[name="id"]')?.value || '').trim() : '';
      };

      const getCardQuantity = (card) => {
        return card ? (card.querySelector('input[name="quantity"]')?.value || '1').trim() : '1';
      };

      const getCardPackCount = (card) => {
        return card ? (card.getAttribute('data-bundle-pack-count') || '').trim() : '';
      };

      const getSelectedCard = () => {
        return cards.find((card) => card.classList.contains('is-active')) || null;
      };

      const updateStickyBar = (card) => {
        if (!card) {
          return;
        }

        const label = getCardLabel(card);
        const price = getDisplayedPrice(card);
        const submitButton = card.querySelector('[name="add"]');

        if (stickyLabel) {
          stickyLabel.textContent = label;
        }

        if (stickyPrice) {
          stickyPrice.textContent = price;
        }

        if (stickySubmit) {
          const ctaText = stickyBaseLabel || 'ORDER BEFORE WE CLOSE';
          stickySubmit.textContent = price ? `${ctaText} - ${price}` : ctaText;
          stickySubmit.disabled = !submitButton || submitButton.hasAttribute('disabled');
        }
      };

      const findCardForDetail = (detail) => {
        if (!detail) {
          return null;
        }

        const detailVariantId = String(detail.variantId || '').trim();
        const detailPackCount = String(detail.packCount || '').trim();

        return cards.find((card) => {
          const cardVariantId = getCardVariantId(card);
          const cardPackCount = getCardPackCount(card);

          if (detailVariantId && cardVariantId && detailVariantId === cardVariantId) {
            return true;
          }

          return detailPackCount && cardPackCount === detailPackCount;
        });
      };

      const applyActiveCard = (card, config = {}) => {
        if (!card) {
          return;
        }

        cards.forEach((item) => {
          item.classList.toggle('is-active', item === card);
        });

        updateStickyBar(card);

        if (config.requestHeroSync === false || typeof window.CustomEvent !== 'function') {
          return;
        }

        window.dispatchEvent(
          new window.CustomEvent('glarise:pdp-bundle-select', {
            detail: {
              source: 'desktop',
              variantId: getCardVariantId(card),
              qty: getCardQuantity(card),
              label: getCardLabel(card),
              price: getDisplayedPrice(card),
              packCount: getCardPackCount(card)
            }
          })
        );
      };

      const navigateToCheckout = (card) => {
        const variantId = getCardVariantId(card);
        const quantity = getCardQuantity(card);

        if (!variantId) {
          return false;
        }

        const checkoutUrl = `${window.routes.cart_url}/${encodeURIComponent(variantId)}:${encodeURIComponent(quantity)}?checkout`;
        window.location.assign(checkoutUrl);
        return true;
      };

      const getSourceOptionForCard = (card) => {
        if (!sourceOptions.length) {
          return null;
        }

        const cardVariantId = card.querySelector('input[name="id"]')?.value || '';
        const cardPackCount = card.getAttribute('data-bundle-pack-count') || '';

        return sourceOptions.find((option) => {
          const optionVariantId = option.getAttribute('data-bundle-variant-id') || '';
          const optionPackCount = option.getAttribute('data-bundle-pack-count') || '';

          if (cardVariantId && optionVariantId && optionVariantId === cardVariantId) {
            return true;
          }

          return cardPackCount != '' && optionPackCount === cardPackCount;
        });
      };

      const syncCardPriceFromSource = (card) => {
        const sourceOption = getSourceOptionForCard(card);
        if (!sourceOption) {
          return;
        }

        const sourcePrice = getDisplayedPrice(sourceOption);
        if (!sourcePrice) {
          return;
        }

        const priceNode = card.querySelector('[data-bundle-price-display]');
        if (priceNode) {
          priceNode.textContent = sourcePrice;
        }

        const sourcePriceCents =
          parseMoneyToCents(sourcePrice) || Number(sourceOption.getAttribute('data-bundle-price-cents') || 0);
        if (sourcePriceCents) {
          card.setAttribute('data-bundle-price-cents', String(sourcePriceCents));
        }
      };

      const refreshBundlePricing = () => {
        if (!cards.length) {
          return;
        }

        cards.forEach((card) => {
          syncCardPriceFromSource(card);
        });

        const firstCardPrice = cards[0].querySelector('[data-bundle-price-display]');
        const referencePriceCents =
          Number(cards[0].getAttribute('data-bundle-reference-cents') || 0) ||
          parseMoneyToCents(firstCardPrice ? firstCardPrice.textContent : '') ||
          Number(cards[0].getAttribute('data-bundle-price-cents') || 0);

        cards.forEach((card) => {
          const packCount = Number(card.getAttribute('data-bundle-pack-count') || 1);
          const unitLabel = card.getAttribute('data-bundle-unit-label') || 'Pack';
          const priceNode = card.querySelector('[data-bundle-price-display]');
          const compareNode = card.querySelector('[data-bundle-compare-display]');
          const saveNode = card.querySelector('[data-bundle-save-display]');
          const badgeNode = card.querySelector('[data-bundle-best-value-badge]');
          const currentPriceCents = parseMoneyToCents(priceNode ? priceNode.textContent : '') || Number(card.getAttribute('data-bundle-price-cents') || 0);

          if (!currentPriceCents) {
            return;
          }

          card.setAttribute('data-bundle-price-cents', String(currentPriceCents));

          if (packCount > 1) {
            const compareCents = referencePriceCents * packCount;
            if (!(compareCents > currentPriceCents)) {
              if (saveNode) {
                saveNode.textContent = '';
                saveNode.hidden = true;
              }

              if (compareNode) {
                compareNode.textContent = '';
                compareNode.hidden = true;
              }

              if (badgeNode) {
                badgeNode.hidden = true;
              }

              return;
            }

            const savingsCents = Math.max(compareCents - currentPriceCents, 0);
            const unitPriceCents = Math.floor(currentPriceCents / packCount);
            const discountPercent = compareCents > 0 ? (savingsCents / compareCents) * 100 : 0;

            if (compareNode) {
              compareNode.textContent = formatMoney(compareCents);
              compareNode.hidden = false;
            }

            if (saveNode) {
              saveNode.textContent = `Save ${formatMoney(savingsCents)} - ${formatMoney(unitPriceCents)}/${unitLabel}`;
              saveNode.hidden = false;
            }

            if (badgeNode) {
              const threshold = Number(card.getAttribute('data-bundle-badge-threshold') || 30);
              badgeNode.hidden = !(discountPercent >= threshold);
            }
          } else {
            if (saveNode) {
              saveNode.textContent = '';
              saveNode.hidden = true;
            }

            if (compareNode) {
              compareNode.textContent = '';
              compareNode.hidden = true;
            }

            if (badgeNode) {
              badgeNode.hidden = true;
            }
          }
        });

        updateStickyBar(getSelectedCard());
      };

      const scheduleBundleRefresh = () => {
        if (refreshFrame) {
          return;
        }

        refreshFrame = window.requestAnimationFrame(() => {
          refreshFrame = null;
          refreshBundlePricing();
        });
      };

      cards.forEach((card) => {
        const priceNode = card.querySelector('[data-bundle-price-display]');
        if (priceNode && 'MutationObserver' in window) {
          const observer = new MutationObserver(scheduleBundleRefresh);
          observer.observe(priceNode, { childList: true, subtree: true, characterData: true });
        }
      });

      sourceOptions.forEach((option) => {
        const priceNode = option.querySelector('[data-bundle-price-display]');
        if (priceNode && 'MutationObserver' in window) {
          const observer = new MutationObserver(scheduleBundleRefresh);
          observer.observe(priceNode, { childList: true, subtree: true, characterData: true });
        }
      });

      refreshBundlePricing();

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          applyActiveCard(card);
        });
      });

      const activeSourceOption = sourceOptions.find((option) => option.classList.contains('is-active'));
      const initialCard =
        findCardForDetail({
          variantId: activeSourceOption ? activeSourceOption.getAttribute('data-bundle-variant-id') || '' : '',
          packCount: activeSourceOption ? activeSourceOption.getAttribute('data-bundle-pack-count') || '' : ''
        }) ||
        cards.find((card) => card.classList.contains('pdp-desktop-bundles__card--featured')) ||
        cards[0];

      applyActiveCard(initialCard, { requestHeroSync: false });

      window.addEventListener('glarise:pdp-bundle-change', (event) => {
        const matchedCard = findCardForDetail(event.detail || {});
        if (matchedCard) {
          applyActiveCard(matchedCard, { requestHeroSync: false });
        }
      });

      if (stickySubmit) {
        stickySubmit.addEventListener('click', (event) => {
          event.preventDefault();

          const activeCard = getSelectedCard() || cards[0];
          if (!navigateToCheckout(activeCard)) {
            applyActiveCard(activeCard);
          }
        });
      }

      root.querySelectorAll('[data-desktop-bundle-form]').forEach((form) => {
        if (form.dataset.bound === 'true') {
          return;
        }

        form.dataset.bound = 'true';
        const submitButton = form.querySelector('[name="add"]');
        const errorMessage = form.querySelector('[data-desktop-bundle-error]');

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const card = form.closest('[data-desktop-bundle-card]');

          if (card) {
            applyActiveCard(card);
          }

          if (!submitButton || submitButton.hasAttribute('disabled')) {
            return;
          }

          if (errorMessage) {
            errorMessage.hidden = true;
            errorMessage.textContent = '';
          }

          const formData = new FormData(form);
          const variantId = Number(formData.get('id'));
          const quantity = Number(formData.get('quantity') || 1);

          if (!variantId) {
            if (errorMessage) {
              errorMessage.hidden = false;
              errorMessage.textContent = 'This bundle is not available right now.';
            }
            return;
          }

          submitButton.setAttribute('disabled', 'disabled');
          submitButton.classList.add('is-loading');
          navigateToCheckout(card);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-proof-stack-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pdp-proof]');
    if (!roots.length) {
      return;
    }

    const parseRatingText = (text) => {
      if (!text) {
        return null;
      }

      const normalized = text.replace(',', '.');
      const patterns = [/([0-5](?:\.\d+)?)\s*(?:\/|out of)\s*5/i, /rated\s*([0-5](?:\.\d+)?)/i];

      for (const pattern of patterns) {
        const match = normalized.match(pattern);
        if (!match) {
          continue;
        }

        const value = Number.parseFloat(match[1]);
        if (!Number.isNaN(value)) {
          return value;
        }
      }

      return null;
    };

    const getRating = (item) => {
      const dataRating = Number.parseFloat(item.getAttribute('data-rating'));
      if (!Number.isNaN(dataRating)) {
        return dataRating;
      }

      const scoreEls = item.querySelectorAll('[data-score]');
      for (const scoreEl of scoreEls) {
        const value = Number.parseFloat(scoreEl.getAttribute('data-score'));
        if (!Number.isNaN(value)) {
          return value;
        }
      }

      const ariaEls = item.querySelectorAll('[aria-label]');
      for (const ariaEl of ariaEls) {
        const value = parseRatingText(ariaEl.getAttribute('aria-label'));
        if (value !== null) {
          return value;
        }
      }

      const filledStars = item.querySelectorAll('.jdgm-star.jdgm--on, .jdgm-star.jdgm-star--on, .jdgm-star.jdgm-star--full').length;
      if (filledStars > 0) {
        return filledStars;
      }

      return parseRatingText(item.textContent);
    };

    const getHighestRatingSortOption = (sortSelect) => {
      if (!sortSelect || !sortSelect.options) {
        return null;
      }

      const options = Array.from(sortSelect.options);
      if (!options.length) {
        return null;
      }

      const sortMatchers = [
        /highest/i,
        /rating.*(?:high|desc)/i,
        /(?:high|desc).*rating/i,
        /top.*rated/i
      ];

      for (const option of options) {
        const haystack = `${option.value || ''} ${option.textContent || ''}`.trim();
        if (sortMatchers.some((matcher) => matcher.test(haystack))) {
          return option;
        }
      }

      return null;
    };

    const enforceHighestRatingSort = (reviewWidget) => {
      if (reviewWidget.dataset.sortPrimed === 'true') {
        return false;
      }

      const sortSelect = reviewWidget.querySelector('.jdgm-sort-dropdown');
      if (!sortSelect) {
        reviewWidget.dataset.sortPrimed = 'true';
        return false;
      }

      const highestOption = getHighestRatingSortOption(sortSelect);
      if (!highestOption) {
        reviewWidget.dataset.sortPrimed = 'true';
        return false;
      }

      const shouldChange = sortSelect.value !== highestOption.value;
      if (shouldChange) {
        sortSelect.value = highestOption.value;
        sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      reviewWidget.dataset.sortPrimed = 'true';
      return shouldChange;
    };

    const asFiveStarList = (reviewWidget, pager) => {
      const reviewsTrack = reviewWidget.querySelector('.jdgm-rev-widg__reviews');
      if (reviewsTrack) {
        reviewsTrack.classList.add('pdp-proof__reviews-list-ready');
      }

      const items = Array.from(reviewWidget.querySelectorAll('.jdgm-rev, .jdgm-carousel-item'));
      if (!items.length) {
        return { hasItems: false, didReorder: false };
      }

      const fiveStarItems = items.filter((item) => getRating(item) >= 5);
      const nonFiveStarItems = items.filter((item) => !fiveStarItems.includes(item));
      const orderedItems = fiveStarItems.length ? fiveStarItems.concat(nonFiveStarItems) : items;
      let didReorder = false;

      if (reviewsTrack) {
        const isAlreadyOrdered = orderedItems.every((item, index) => item === items[index]);
        if (!isAlreadyOrdered) {
          const fragment = document.createDocumentFragment();
          orderedItems.forEach((item) => {
            fragment.appendChild(item);
          });
          reviewsTrack.appendChild(fragment);
          didReorder = true;
        }
      }

      items.forEach((item) => {
        item.hidden = false;
        item.classList.add('pdp-proof__review-card');
      });

      if (pager) {
        pager.hidden = true;
        pager.innerHTML = '';
      }

      return { hasItems: items.length > 0, didReorder };
    };

    const bindReviewWidget = (root) => {
      const reviewWidget = root.querySelector('[data-pdp-proof-reviews]');
      if (!reviewWidget) {
        return;
      }
      const pager = root.querySelector('[data-pdp-proof-pagination]');
      let isInitializing = false;

      const initialize = () => {
        if (isInitializing) {
          return;
        }

        isInitializing = true;
        const didSortChange = enforceHighestRatingSort(reviewWidget);
        const result = asFiveStarList(reviewWidget, pager);
        isInitializing = false;

        if (didSortChange || result.didReorder) {
          window.setTimeout(initialize, 450);
        }
      };

      if (reviewWidget.dataset.observerBound !== 'true') {
        reviewWidget.dataset.observerBound = 'true';
        const observer = new MutationObserver(initialize);
        observer.observe(reviewWidget, { childList: true, subtree: true });
      }

      initialize();
      window.setTimeout(initialize, 700);
      window.setTimeout(initialize, 1500);
      window.setTimeout(initialize, 2800);
    };

    const bindSnapRows = (root) => {
      const desktopQuery = window.matchMedia('(min-width: 960px)');
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      root.querySelectorAll('[data-proof-slider]').forEach((slider) => {
        if (slider.dataset.sliderBound === 'true') {
          return;
        }
        slider.dataset.sliderBound = 'true';

        const track = slider.querySelector('[data-proof-track]');
        const controls = slider.querySelector('[data-proof-controls]');
        const prevButton = slider.querySelector('[data-proof-prev]');
        const nextButton = slider.querySelector('[data-proof-next]');
        if (!track || !controls || !prevButton || !nextButton) {
          return;
        }

        const cards = Array.from(track.querySelectorAll('[role="listitem"]'));
        if (cards.length < 2) {
          controls.hidden = true;
          return;
        }

        let activeIndex = 0;
        const scrollBehavior = prefersReducedMotion.matches ? 'auto' : 'smooth';

        const scrollToCard = (index) => {
          const boundedIndex = Math.max(0, Math.min(cards.length - 1, index));
          track.scrollTo({ left: cards[boundedIndex].offsetLeft, behavior: scrollBehavior });
        };

        const syncControls = () => {
          const center = track.scrollLeft + track.clientWidth * 0.5;
          let nextActiveIndex = 0;

          cards.forEach((card, index) => {
            if (card.offsetLeft <= center) {
              nextActiveIndex = index;
            }
          });

          activeIndex = nextActiveIndex;
          controls.hidden = desktopQuery.matches;
          prevButton.disabled = activeIndex <= 0;
          nextButton.disabled = activeIndex >= cards.length - 1;
        };

        prevButton.addEventListener('click', () => {
          scrollToCard(activeIndex - 1);
        });

        nextButton.addEventListener('click', () => {
          scrollToCard(activeIndex + 1);
        });

        track.addEventListener('scroll', syncControls, { passive: true });
        window.addEventListener('resize', syncControls);
        if (typeof desktopQuery.addEventListener === 'function') {
          desktopQuery.addEventListener('change', syncControls);
        } else if (typeof desktopQuery.addListener === 'function') {
          desktopQuery.addListener(syncControls);
        }

        syncControls();
      });
    };

    const bindRoutineVideos = (root) => {
      const pauseOtherVideos = (activeVideo) => {
        root.querySelectorAll('[data-proof-video]').forEach((video) => {
          if (video === activeVideo) {
            return;
          }

          video.pause();
        });
      };

      root.querySelectorAll('[data-proof-video-shell]').forEach((shell) => {
        if (shell.dataset.videoBound === 'true') {
          return;
        }
        shell.dataset.videoBound = 'true';

        const video = shell.querySelector('[data-proof-video]');
        const toggle = shell.querySelector('[data-proof-video-toggle]');
        if (!video || !toggle) {
          return;
        }

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          shell.classList.toggle('is-playing', isPlaying);
          toggle.setAttribute('aria-label', isPlaying ? 'Pause customer routine video' : 'Play customer routine video');
        };

        toggle.addEventListener('click', () => {
          if (!video.paused && !video.ended) {
            video.pause();
            return;
          }

          pauseOtherVideos(video);
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });

        video.addEventListener('click', () => {
          if (!video.paused && !video.ended) {
            video.pause();
          }
        });

        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', () => {
          video.currentTime = 0;
          syncState();
        });

        syncState();
      });
    };

    const bindFaq = (root) => {
      const faqRoot = root.querySelector('[data-faq-root]');
      if (!faqRoot) {
        return;
      }

      const items = Array.from(faqRoot.querySelectorAll('.pdp-proof__faq-item'));
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) {
            return;
          }

          items.forEach((other) => {
            if (other !== item) {
              other.open = false;
            }
          });
        });
      });
    };

    roots.forEach((root) => {
      bindSnapRows(root);
      bindRoutineVideos(root);
      bindReviewWidget(root);
      bindFaq(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-proof-stack-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pdp-proof-v3]');
    if (!roots.length) {
      return;
    }

    const getCartUrl = () => {
      if (window.routes && window.routes.cart_url) {
        return window.routes.cart_url;
      }

      return '/cart';
    };

    const navigateToCheckout = (detail) => {
      const variantId = String(detail?.variantId || '').trim();
      const quantity = String(detail?.qty || '1').trim();

      if (!variantId) {
        return false;
      }

      const checkoutUrl = `${getCartUrl()}/${encodeURIComponent(variantId)}:${encodeURIComponent(quantity)}?checkout`;
      window.location.assign(checkoutUrl);
      return true;
    };

    const bindSliders = (root) => {
      root.querySelectorAll('[data-pdp-v3-slider]').forEach((shell) => {
        const track = shell.querySelector('[data-pdp-v3-track]');
        const controls = shell.querySelector('[data-pdp-v3-controls]');
        const prev = shell.querySelector('[data-pdp-v3-prev]');
        const next = shell.querySelector('[data-pdp-v3-next]');

        if (!track || !controls || !prev || !next) {
          return;
        }

        const items = Array.from(track.children);
        if (items.length < 2) {
          return;
        }

        controls.hidden = false;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let activeIndex = 0;

        const sync = () => {
          const center = track.scrollLeft + track.clientWidth * 0.5;
          let nextIndex = 0;

          items.forEach((item, index) => {
            if (item.offsetLeft <= center) {
              nextIndex = index;
            }
          });

          activeIndex = nextIndex;
          prev.disabled = activeIndex <= 0;
          next.disabled = activeIndex >= items.length - 1;
        };

        const scrollToItem = (index) => {
          const boundedIndex = Math.max(0, Math.min(items.length - 1, index));
          track.scrollTo({
            left: items[boundedIndex].offsetLeft,
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
          });
        };

        prev.addEventListener('click', () => scrollToItem(activeIndex - 1));
        next.addEventListener('click', () => scrollToItem(activeIndex + 1));
        track.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
      });
    };

    const bindVideos = (root) => {
      const shells = Array.from(root.querySelectorAll('[data-pdp-v3-video-shell]'));
      if (!shells.length) {
        return;
      }

      const pauseOthers = (activeVideo) => {
        shells.forEach((shell) => {
          const video = shell.querySelector('[data-pdp-v3-video]');
          if (!video || video === activeVideo) {
            return;
          }

          video.pause();
          shell.classList.remove('is-playing');
        });
      };

      shells.forEach((shell) => {
        if (shell.dataset.videoBound === 'true') {
          return;
        }

        shell.dataset.videoBound = 'true';
        const video = shell.querySelector('[data-pdp-v3-video]');
        const button = shell.querySelector('[data-pdp-v3-video-toggle]');
        if (!video || !button) {
          return;
        }

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          shell.classList.toggle('is-playing', isPlaying);
          button.setAttribute('aria-label', isPlaying ? 'Pause customer routine video' : 'Play customer routine video');
        };

        const togglePlayback = () => {
          if (!video.paused && !video.ended) {
            video.pause();
            return;
          }

          pauseOthers(video);
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        };

        button.addEventListener('click', togglePlayback);
        video.addEventListener('click', togglePlayback);
        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', syncState);
        syncState();
      });
    };

    const bindBundleSync = (root) => {
      const selectors = Array.from(root.querySelectorAll('[data-v3-bundle-selector]'));
      const buyBars = Array.from(root.querySelectorAll('[data-v3-bundle-buybar]'));
      if (!selectors.length) {
        return;
      }

      const firstSelector = selectors[0];
      const canonicalOptions = Array.from(firstSelector.querySelectorAll('[data-v3-selector-option]'));
      if (!canonicalOptions.length) {
        return;
      }

      const getOptionDetail = (option) => ({
        source: 'proof',
        variantId: option.getAttribute('data-bundle-variant-id') || '',
        qty: option.getAttribute('data-bundle-qty') || '1',
        label: option.getAttribute('data-bundle-label') || '',
        price: option.getAttribute('data-bundle-price') || '',
        note: option.getAttribute('data-bundle-note') || '',
        shipping: option.getAttribute('data-bundle-shipping') || '',
        packCount: option.getAttribute('data-bundle-pack-count') || ''
      });

      const findOptionForDetail = (options, detail) => {
        const detailVariantId = String(detail?.variantId || '').trim();
        const detailPackCount = String(detail?.packCount || '').trim();

        return options.find((option) => {
          const optionVariantId = (option.getAttribute('data-bundle-variant-id') || '').trim();
          const optionPackCount = (option.getAttribute('data-bundle-pack-count') || '').trim();

          if (detailVariantId && optionVariantId && detailVariantId === optionVariantId) {
            return true;
          }

          return detailPackCount && optionPackCount === detailPackCount;
        });
      };

      let activeDetail = getOptionDetail(canonicalOptions.find((option) => option.classList.contains('is-active')) || canonicalOptions[1] || canonicalOptions[0]);

      const updateBuyBars = (detail) => {
        buyBars.forEach((buyBar) => {
          const label = buyBar.querySelector('[data-v3-buybar-label]');
          const price = buyBar.querySelector('[data-v3-buybar-price]');
          const submit = buyBar.querySelector('[data-v3-buybar-submit]');

          if (label) {
            label.textContent = detail.label;
          }

          if (price) {
            price.textContent = detail.price;
          }

          if (submit) {
            const baseLabel = submit.getAttribute('data-button-base-label') || 'ADD TO CART';
            submit.textContent = detail.price ? `${baseLabel} - ${detail.price}` : baseLabel;
          }
        });
      };

      const applySelectionToSelector = (selector, detail) => {
        const options = Array.from(selector.querySelectorAll('[data-v3-selector-option]'));
        const matchedOption = findOptionForDetail(options, detail) || options[0];
        if (!matchedOption) {
          return;
        }

        const matchedDetail = getOptionDetail(matchedOption);
        options.forEach((option) => {
          const isActive = option === matchedOption;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const label = selector.querySelector('[data-v3-selector-label]');
        const price = selector.querySelector('[data-v3-selector-price]');
        const note = selector.querySelector('[data-v3-selector-note]');
        const submit = selector.querySelector('[data-v3-selector-submit]');

        if (label) {
          label.textContent = matchedDetail.label;
        }

        if (price) {
          price.textContent = matchedDetail.price;
        }

        if (note) {
          note.textContent = matchedDetail.shipping || matchedDetail.note;
        }

        if (submit) {
          submit.dataset.variantId = matchedDetail.variantId;
          submit.dataset.qty = matchedDetail.qty;
          submit.dataset.packCount = matchedDetail.packCount;
          const baseLabel = submit.getAttribute('data-button-base-label') || 'ADD TO CART';
          submit.textContent = matchedDetail.price ? `${baseLabel} - ${matchedDetail.price}` : baseLabel;
        }
      };

      const applySelectionEverywhere = (detail) => {
        const canonicalMatch = findOptionForDetail(canonicalOptions, detail) || canonicalOptions[0];
        if (!canonicalMatch) {
          return;
        }

        activeDetail = getOptionDetail(canonicalMatch);
        selectors.forEach((selector) => applySelectionToSelector(selector, activeDetail));
        updateBuyBars(activeDetail);
      };

      selectors.forEach((selector) => {
        selector.querySelectorAll('[data-v3-selector-option]').forEach((option) => {
          option.addEventListener('click', () => {
            const detail = getOptionDetail(option);
            applySelectionEverywhere(detail);

            if (typeof window.CustomEvent === 'function') {
              window.dispatchEvent(new window.CustomEvent('glarise:v3-bundle-select', { detail }));
            }
          });
        });

        const submit = selector.querySelector('[data-v3-selector-submit]');
        if (submit) {
          submit.addEventListener('click', (event) => {
            event.preventDefault();
            navigateToCheckout({
              variantId: submit.dataset.variantId || activeDetail.variantId,
              qty: submit.dataset.qty || activeDetail.qty
            });
          });
        }
      });

      buyBars.forEach((buyBar) => {
        const submit = buyBar.querySelector('[data-v3-buybar-submit]');
        if (!submit) {
          return;
        }

        submit.addEventListener('click', (event) => {
          event.preventDefault();
          navigateToCheckout(activeDetail);
        });
      });

      window.addEventListener('glarise:v3-bundle-change', (event) => {
        applySelectionEverywhere(event.detail || {});
      });

      applySelectionEverywhere(activeDetail);
    };

    roots.forEach((root) => {
      bindSliders(root);
      bindVideos(root);
      bindBundleSync(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-proof-stack-v5-price-test"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pdp-proof]');
    if (!roots.length) {
      return;
    }

    const parseRatingText = (text) => {
      if (!text) {
        return null;
      }

      const normalized = text.replace(',', '.');
      const patterns = [/([0-5](?:\.\d+)?)\s*(?:\/|out of)\s*5/i, /rated\s*([0-5](?:\.\d+)?)/i];

      for (const pattern of patterns) {
        const match = normalized.match(pattern);
        if (!match) {
          continue;
        }

        const value = Number.parseFloat(match[1]);
        if (!Number.isNaN(value)) {
          return value;
        }
      }

      return null;
    };

    const getRating = (item) => {
      const dataRating = Number.parseFloat(item.getAttribute('data-rating'));
      if (!Number.isNaN(dataRating)) {
        return dataRating;
      }

      const scoreEls = item.querySelectorAll('[data-score]');
      for (const scoreEl of scoreEls) {
        const value = Number.parseFloat(scoreEl.getAttribute('data-score'));
        if (!Number.isNaN(value)) {
          return value;
        }
      }

      const ariaEls = item.querySelectorAll('[aria-label]');
      for (const ariaEl of ariaEls) {
        const value = parseRatingText(ariaEl.getAttribute('aria-label'));
        if (value !== null) {
          return value;
        }
      }

      const filledStars = item.querySelectorAll('.jdgm-star.jdgm--on, .jdgm-star.jdgm-star--on, .jdgm-star.jdgm-star--full').length;
      if (filledStars > 0) {
        return filledStars;
      }

      return parseRatingText(item.textContent);
    };

    const getHighestRatingSortOption = (sortSelect) => {
      if (!sortSelect || !sortSelect.options) {
        return null;
      }

      const options = Array.from(sortSelect.options);
      if (!options.length) {
        return null;
      }

      const sortMatchers = [
        /highest/i,
        /rating.*(?:high|desc)/i,
        /(?:high|desc).*rating/i,
        /top.*rated/i
      ];

      for (const option of options) {
        const haystack = `${option.value || ''} ${option.textContent || ''}`.trim();
        if (sortMatchers.some((matcher) => matcher.test(haystack))) {
          return option;
        }
      }

      return null;
    };

    const enforceHighestRatingSort = (reviewWidget) => {
      if (reviewWidget.dataset.sortPrimed === 'true') {
        return false;
      }

      const sortSelect = reviewWidget.querySelector('.jdgm-sort-dropdown');
      if (!sortSelect) {
        reviewWidget.dataset.sortPrimed = 'true';
        return false;
      }

      const highestOption = getHighestRatingSortOption(sortSelect);
      if (!highestOption) {
        reviewWidget.dataset.sortPrimed = 'true';
        return false;
      }

      const shouldChange = sortSelect.value !== highestOption.value;
      if (shouldChange) {
        sortSelect.value = highestOption.value;
        sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      reviewWidget.dataset.sortPrimed = 'true';
      return shouldChange;
    };

    const asFiveStarList = (reviewWidget, pager) => {
      const reviewsTrack = reviewWidget.querySelector('.jdgm-rev-widg__reviews');
      if (reviewsTrack) {
        reviewsTrack.classList.add('pdp-proof__reviews-list-ready');
      }

      const items = Array.from(reviewWidget.querySelectorAll('.jdgm-rev, .jdgm-carousel-item'));
      if (!items.length) {
        return { hasItems: false, didReorder: false };
      }

      const fiveStarItems = items.filter((item) => getRating(item) >= 5);
      const nonFiveStarItems = items.filter((item) => !fiveStarItems.includes(item));
      const orderedItems = fiveStarItems.length ? fiveStarItems.concat(nonFiveStarItems) : items;
      let didReorder = false;

      if (reviewsTrack) {
        const isAlreadyOrdered = orderedItems.every((item, index) => item === items[index]);
        if (!isAlreadyOrdered) {
          const fragment = document.createDocumentFragment();
          orderedItems.forEach((item) => {
            fragment.appendChild(item);
          });
          reviewsTrack.appendChild(fragment);
          didReorder = true;
        }
      }

      items.forEach((item) => {
        item.hidden = false;
        item.classList.add('pdp-proof__review-card');
      });

      if (pager) {
        pager.hidden = true;
        pager.innerHTML = '';
      }

      return { hasItems: items.length > 0, didReorder };
    };

    const bindReviewWidget = (root) => {
      const reviewWidget = root.querySelector('[data-pdp-proof-reviews]');
      if (!reviewWidget) {
        return;
      }
      const pager = root.querySelector('[data-pdp-proof-pagination]');
      let isInitializing = false;

      const initialize = () => {
        if (isInitializing) {
          return;
        }

        isInitializing = true;
        const didSortChange = enforceHighestRatingSort(reviewWidget);
        const result = asFiveStarList(reviewWidget, pager);
        isInitializing = false;

        if (didSortChange || result.didReorder) {
          window.setTimeout(initialize, 450);
        }
      };

      if (reviewWidget.dataset.observerBound !== 'true') {
        reviewWidget.dataset.observerBound = 'true';
        const observer = new MutationObserver(initialize);
        observer.observe(reviewWidget, { childList: true, subtree: true });
      }

      initialize();
      window.setTimeout(initialize, 700);
      window.setTimeout(initialize, 1500);
      window.setTimeout(initialize, 2800);
    };

    const bindSnapRows = (root) => {
      const desktopQuery = window.matchMedia('(min-width: 960px)');
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      root.querySelectorAll('[data-proof-slider]').forEach((slider) => {
        if (slider.dataset.sliderBound === 'true') {
          return;
        }
        slider.dataset.sliderBound = 'true';

        const track = slider.querySelector('[data-proof-track]');
        const controls = slider.querySelector('[data-proof-controls]');
        const prevButton = slider.querySelector('[data-proof-prev]');
        const nextButton = slider.querySelector('[data-proof-next]');
        if (!track || !controls || !prevButton || !nextButton) {
          return;
        }

        const cards = Array.from(track.querySelectorAll('[role="listitem"]'));
        if (cards.length < 2) {
          controls.hidden = true;
          return;
        }

        let activeIndex = 0;
        const scrollBehavior = prefersReducedMotion.matches ? 'auto' : 'smooth';

        const scrollToCard = (index) => {
          const boundedIndex = Math.max(0, Math.min(cards.length - 1, index));
          track.scrollTo({ left: cards[boundedIndex].offsetLeft, behavior: scrollBehavior });
        };

        const syncControls = () => {
          const center = track.scrollLeft + track.clientWidth * 0.5;
          let nextActiveIndex = 0;

          cards.forEach((card, index) => {
            if (card.offsetLeft <= center) {
              nextActiveIndex = index;
            }
          });

          activeIndex = nextActiveIndex;
          controls.hidden = desktopQuery.matches;
          prevButton.disabled = activeIndex <= 0;
          nextButton.disabled = activeIndex >= cards.length - 1;
        };

        prevButton.addEventListener('click', () => {
          scrollToCard(activeIndex - 1);
        });

        nextButton.addEventListener('click', () => {
          scrollToCard(activeIndex + 1);
        });

        track.addEventListener('scroll', syncControls, { passive: true });
        window.addEventListener('resize', syncControls);
        if (typeof desktopQuery.addEventListener === 'function') {
          desktopQuery.addEventListener('change', syncControls);
        } else if (typeof desktopQuery.addListener === 'function') {
          desktopQuery.addListener(syncControls);
        }

        syncControls();
      });
    };

    const bindRoutineVideos = (root) => {
      const pauseOtherVideos = (activeVideo) => {
        root.querySelectorAll('[data-proof-video]').forEach((video) => {
          if (video === activeVideo) {
            return;
          }

          video.pause();
        });
      };

      root.querySelectorAll('[data-proof-video-shell]').forEach((shell) => {
        if (shell.dataset.videoBound === 'true') {
          return;
        }
        shell.dataset.videoBound = 'true';

        const video = shell.querySelector('[data-proof-video]');
        const toggle = shell.querySelector('[data-proof-video-toggle]');
        if (!video || !toggle) {
          return;
        }

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          shell.classList.toggle('is-playing', isPlaying);
          toggle.setAttribute('aria-label', isPlaying ? 'Pause customer routine video' : 'Play customer routine video');
        };

        toggle.addEventListener('click', () => {
          if (!video.paused && !video.ended) {
            video.pause();
            return;
          }

          pauseOtherVideos(video);
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });

        video.addEventListener('click', () => {
          if (!video.paused && !video.ended) {
            video.pause();
          }
        });

        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', () => {
          video.currentTime = 0;
          syncState();
        });

        syncState();
      });
    };

    const bindFaq = (root) => {
      const faqRoot = root.querySelector('[data-faq-root]');
      if (!faqRoot) {
        return;
      }

      const items = Array.from(faqRoot.querySelectorAll('.pdp-proof__faq-item'));
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) {
            return;
          }

          items.forEach((other) => {
            if (other !== item) {
              other.open = false;
            }
          });
        });
      });
    };

    const formatMoney = (cents) => {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    };

    const updateProofPricing = (root) => {
      const costValue = root.querySelector('[data-proof-cost-value]');
      const heroRoot = document.querySelector('[data-product-hero-section][data-product-hero-version="v5-price-test"]');
      if (!costValue || !heroRoot) {
        return;
      }

      const bundleSupplyDays = Number(heroRoot.getAttribute('data-bundle-supply-days') || 45) || 45;
      const singlePackShippingCents = Number(heroRoot.getAttribute('data-active-single-pack-shipping-cents') || 0) || 0;
      const bundlePrices = [
        Number(heroRoot.getAttribute('data-active-bundle-1-price-cents') || 0) + singlePackShippingCents,
        Number(heroRoot.getAttribute('data-active-bundle-2-price-cents') || 0),
        Number(heroRoot.getAttribute('data-active-bundle-3-price-cents') || 0)
      ];

      let bestPerDayCents = Number(heroRoot.getAttribute('data-active-best-per-day-cents') || 0) || 0;
      if (!(bestPerDayCents > 0)) {
        bundlePrices.forEach((bundlePriceCents, index) => {
          if (!(bundlePriceCents > 0)) {
            return;
          }

          const packCount = index + 1;
          const perDayCents = Math.round(bundlePriceCents / Math.max(1, bundleSupplyDays * packCount));
          if (!(bestPerDayCents > 0) || perDayCents < bestPerDayCents) {
            bestPerDayCents = perDayCents;
          }
        });
      }

      if (bestPerDayCents > 0) {
        costValue.textContent = `${formatMoney(bestPerDayCents)}/day`;
      }
    };

    roots.forEach((root) => {
      bindSnapRows(root);
      bindRoutineVideos(root);
      bindReviewWidget(root);
      bindFaq(root);
      updateProofPricing(root);

      const heroRoot = document.querySelector('[data-product-hero-section][data-product-hero-version="v5-price-test"]');
      if (heroRoot && 'MutationObserver' in window) {
        const observer = new MutationObserver(() => {
          updateProofPricing(root);
        });
        observer.observe(heroRoot, { attributes: true });
      }

      window.addEventListener('glarise:v5-pricing-change', () => {
        updateProofPricing(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-proof-stack-v6-benefit-framing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pdp-proof-v6]');
    if (!roots.length) {
      return;
    }

    const getCartUrl = () => {
      if (window.routes && window.routes.cart_url) {
        return window.routes.cart_url;
      }

      return '/cart';
    };

    const navigateToCheckout = (detail) => {
      const variantId = String(detail?.variantId || '').trim();
      const quantity = String(detail?.qty || '1').trim();

      if (!variantId) {
        return false;
      }

      const checkoutUrl = `${getCartUrl()}/${encodeURIComponent(variantId)}:${encodeURIComponent(quantity)}?checkout`;
      window.location.assign(checkoutUrl);
      return true;
    };

    const bindSliders = (root) => {
      root.querySelectorAll('[data-pdp-v3-slider]').forEach((shell) => {
        const track = shell.querySelector('[data-pdp-v3-track]');
        const controls = shell.querySelector('[data-pdp-v3-controls]');
        const prev = shell.querySelector('[data-pdp-v3-prev]');
        const next = shell.querySelector('[data-pdp-v3-next]');

        if (!track || !controls || !prev || !next) {
          return;
        }

        const items = Array.from(track.children);
        if (items.length < 2) {
          return;
        }

        controls.hidden = false;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let activeIndex = 0;

        const sync = () => {
          const center = track.scrollLeft + track.clientWidth * 0.5;
          let nextIndex = 0;

          items.forEach((item, index) => {
            if (item.offsetLeft <= center) {
              nextIndex = index;
            }
          });

          activeIndex = nextIndex;
          prev.disabled = activeIndex <= 0;
          next.disabled = activeIndex >= items.length - 1;
        };

        const scrollToItem = (index) => {
          const boundedIndex = Math.max(0, Math.min(items.length - 1, index));
          track.scrollTo({
            left: items[boundedIndex].offsetLeft,
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
          });
        };

        prev.addEventListener('click', () => scrollToItem(activeIndex - 1));
        next.addEventListener('click', () => scrollToItem(activeIndex + 1));
        track.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
      });
    };

    const bindVideos = (root) => {
      const shells = Array.from(root.querySelectorAll('[data-pdp-v3-video-shell]'));
      if (!shells.length) {
        return;
      }

      const pauseOthers = (activeVideo) => {
        shells.forEach((shell) => {
          const video = shell.querySelector('[data-pdp-v3-video]');
          if (!video || video === activeVideo) {
            return;
          }

          video.pause();
          shell.classList.remove('is-playing');
        });
      };

      shells.forEach((shell) => {
        if (shell.dataset.videoBound === 'true') {
          return;
        }

        shell.dataset.videoBound = 'true';
        const video = shell.querySelector('[data-pdp-v3-video]');
        const button = shell.querySelector('[data-pdp-v3-video-toggle]');
        if (!video || !button) {
          return;
        }

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          shell.classList.toggle('is-playing', isPlaying);
          button.setAttribute('aria-label', isPlaying ? 'Pause customer routine video' : 'Play customer routine video');
        };

        const togglePlayback = () => {
          if (!video.paused && !video.ended) {
            video.pause();
            return;
          }

          pauseOthers(video);
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        };

        button.addEventListener('click', togglePlayback);
        video.addEventListener('click', togglePlayback);
        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', syncState);
        syncState();
      });
    };

    const bindBundleSync = (root) => {
      const selectors = Array.from(root.querySelectorAll('[data-v3-bundle-selector]'));
      const buyBars = Array.from(root.querySelectorAll('[data-v3-bundle-buybar]'));
      if (!selectors.length) {
        return;
      }

      const firstSelector = selectors[0];
      const canonicalOptions = Array.from(firstSelector.querySelectorAll('[data-v3-selector-option]'));
      if (!canonicalOptions.length) {
        return;
      }

      const getOptionDetail = (option) => ({
        source: 'proof',
        variantId: option.getAttribute('data-bundle-variant-id') || '',
        qty: option.getAttribute('data-bundle-qty') || '1',
        label: option.getAttribute('data-bundle-label') || '',
        price: option.getAttribute('data-bundle-price') || '',
        note: option.getAttribute('data-bundle-note') || '',
        shipping: option.getAttribute('data-bundle-shipping') || '',
        packCount: option.getAttribute('data-bundle-pack-count') || ''
      });

      const findOptionForDetail = (options, detail) => {
        const detailVariantId = String(detail?.variantId || '').trim();
        const detailPackCount = String(detail?.packCount || '').trim();

        return options.find((option) => {
          const optionVariantId = (option.getAttribute('data-bundle-variant-id') || '').trim();
          const optionPackCount = (option.getAttribute('data-bundle-pack-count') || '').trim();

          if (detailVariantId && optionVariantId && detailVariantId === optionVariantId) {
            return true;
          }

          return detailPackCount && optionPackCount === detailPackCount;
        });
      };

      let activeDetail = getOptionDetail(canonicalOptions.find((option) => option.classList.contains('is-active')) || canonicalOptions[1] || canonicalOptions[0]);

      const updateBuyBars = (detail) => {
        buyBars.forEach((buyBar) => {
          const label = buyBar.querySelector('[data-v3-buybar-label]');
          const price = buyBar.querySelector('[data-v3-buybar-price]');
          const submit = buyBar.querySelector('[data-v3-buybar-submit]');

          if (label) {
            label.textContent = detail.label;
          }

          if (price) {
            price.textContent = detail.price;
          }

          if (submit) {
            const baseLabel = submit.getAttribute('data-button-base-label') || 'ADD TO CART';
            submit.textContent = detail.price ? `${baseLabel} - ${detail.price}` : baseLabel;
          }
        });
      };

      const applySelectionToSelector = (selector, detail) => {
        const options = Array.from(selector.querySelectorAll('[data-v3-selector-option]'));
        const matchedOption = findOptionForDetail(options, detail) || options[0];
        if (!matchedOption) {
          return;
        }

        const matchedDetail = getOptionDetail(matchedOption);
        options.forEach((option) => {
          const isActive = option === matchedOption;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const label = selector.querySelector('[data-v3-selector-label]');
        const price = selector.querySelector('[data-v3-selector-price]');
        const note = selector.querySelector('[data-v3-selector-note]');
        const submit = selector.querySelector('[data-v3-selector-submit]');

        if (label) {
          label.textContent = matchedDetail.label;
        }

        if (price) {
          price.textContent = matchedDetail.price;
        }

        if (note) {
          note.textContent = matchedDetail.shipping || matchedDetail.note;
        }

        if (submit) {
          submit.dataset.variantId = matchedDetail.variantId;
          submit.dataset.qty = matchedDetail.qty;
          submit.dataset.packCount = matchedDetail.packCount;
          const baseLabel = submit.getAttribute('data-button-base-label') || 'ADD TO CART';
          submit.textContent = matchedDetail.price ? `${baseLabel} - ${matchedDetail.price}` : baseLabel;
        }
      };

      const applySelectionEverywhere = (detail) => {
        const canonicalMatch = findOptionForDetail(canonicalOptions, detail) || canonicalOptions[0];
        if (!canonicalMatch) {
          return;
        }

        activeDetail = getOptionDetail(canonicalMatch);
        selectors.forEach((selector) => applySelectionToSelector(selector, activeDetail));
        updateBuyBars(activeDetail);
      };

      selectors.forEach((selector) => {
        selector.querySelectorAll('[data-v3-selector-option]').forEach((option) => {
          option.addEventListener('click', () => {
            const detail = getOptionDetail(option);
            applySelectionEverywhere(detail);

            if (typeof window.CustomEvent === 'function') {
              window.dispatchEvent(new window.CustomEvent('glarise:v3-bundle-select', { detail }));
            }
          });
        });

        const submit = selector.querySelector('[data-v3-selector-submit]');
        if (submit) {
          submit.addEventListener('click', (event) => {
            event.preventDefault();
            navigateToCheckout({
              variantId: submit.dataset.variantId || activeDetail.variantId,
              qty: submit.dataset.qty || activeDetail.qty
            });
          });
        }
      });

      buyBars.forEach((buyBar) => {
        const submit = buyBar.querySelector('[data-v3-buybar-submit]');
        if (!submit) {
          return;
        }

        submit.addEventListener('click', (event) => {
          event.preventDefault();
          navigateToCheckout(activeDetail);
        });
      });

      window.addEventListener('glarise:v3-bundle-change', (event) => {
        applySelectionEverywhere(event.detail || {});
      });

      applySelectionEverywhere(activeDetail);
    };

    roots.forEach((root) => {
      bindSliders(root);
      bindVideos(root);
      bindBundleSync(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-proof-stack"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pdp-proof]');
    if (!roots.length) {
      return;
    }

    const parseRatingText = (text) => {
      if (!text) {
        return null;
      }

      const normalized = text.replace(',', '.');
      const patterns = [/([0-5](?:\.\d+)?)\s*(?:\/|out of)\s*5/i, /rated\s*([0-5](?:\.\d+)?)/i];

      for (const pattern of patterns) {
        const match = normalized.match(pattern);
        if (!match) {
          continue;
        }

        const value = Number.parseFloat(match[1]);
        if (!Number.isNaN(value)) {
          return value;
        }
      }

      return null;
    };

    const getRating = (item) => {
      const dataRating = Number.parseFloat(item.getAttribute('data-rating'));
      if (!Number.isNaN(dataRating)) {
        return dataRating;
      }

      const scoreEls = item.querySelectorAll('[data-score]');
      for (const scoreEl of scoreEls) {
        const value = Number.parseFloat(scoreEl.getAttribute('data-score'));
        if (!Number.isNaN(value)) {
          return value;
        }
      }

      const ariaEls = item.querySelectorAll('[aria-label]');
      for (const ariaEl of ariaEls) {
        const value = parseRatingText(ariaEl.getAttribute('aria-label'));
        if (value !== null) {
          return value;
        }
      }

      const filledStars = item.querySelectorAll('.jdgm-star.jdgm--on, .jdgm-star.jdgm-star--on, .jdgm-star.jdgm-star--full').length;
      if (filledStars > 0) {
        return filledStars;
      }

      return parseRatingText(item.textContent);
    };

    const getHighestRatingSortOption = (sortSelect) => {
      if (!sortSelect || !sortSelect.options) {
        return null;
      }

      const options = Array.from(sortSelect.options);
      if (!options.length) {
        return null;
      }

      const sortMatchers = [
        /highest/i,
        /rating.*(?:high|desc)/i,
        /(?:high|desc).*rating/i,
        /top.*rated/i
      ];

      for (const option of options) {
        const haystack = `${option.value || ''} ${option.textContent || ''}`.trim();
        if (sortMatchers.some((matcher) => matcher.test(haystack))) {
          return option;
        }
      }

      return null;
    };

    const enforceHighestRatingSort = (reviewWidget) => {
      if (reviewWidget.dataset.sortPrimed === 'true') {
        return false;
      }

      const sortSelect = reviewWidget.querySelector('.jdgm-sort-dropdown');
      if (!sortSelect) {
        reviewWidget.dataset.sortPrimed = 'true';
        return false;
      }

      const highestOption = getHighestRatingSortOption(sortSelect);
      if (!highestOption) {
        reviewWidget.dataset.sortPrimed = 'true';
        return false;
      }

      const shouldChange = sortSelect.value !== highestOption.value;
      if (shouldChange) {
        sortSelect.value = highestOption.value;
        sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      reviewWidget.dataset.sortPrimed = 'true';
      return shouldChange;
    };

    const asFiveStarList = (reviewWidget, pager) => {
      const reviewsTrack = reviewWidget.querySelector('.jdgm-rev-widg__reviews');
      if (reviewsTrack) {
        reviewsTrack.classList.add('pdp-proof__reviews-list-ready');
      }

      const items = Array.from(reviewWidget.querySelectorAll('.jdgm-rev, .jdgm-carousel-item'));
      if (!items.length) {
        return { hasItems: false, didReorder: false };
      }

      const fiveStarItems = items.filter((item) => getRating(item) >= 5);
      const nonFiveStarItems = items.filter((item) => !fiveStarItems.includes(item));
      const orderedItems = fiveStarItems.length ? fiveStarItems.concat(nonFiveStarItems) : items;
      let didReorder = false;

      if (reviewsTrack) {
        const isAlreadyOrdered = orderedItems.every((item, index) => item === items[index]);
        if (!isAlreadyOrdered) {
          const fragment = document.createDocumentFragment();
          orderedItems.forEach((item) => {
            fragment.appendChild(item);
          });
          reviewsTrack.appendChild(fragment);
          didReorder = true;
        }
      }

      items.forEach((item) => {
        item.hidden = false;
        item.classList.add('pdp-proof__review-card');
      });

      if (pager) {
        pager.hidden = true;
        pager.innerHTML = '';
      }

      return { hasItems: items.length > 0, didReorder };
    };

    const bindDesktopIncluded = (root) => {
      const slot = root.querySelector('[data-apply-included-slot]');
      const source = document.querySelector('[data-included-desktop-source]');
      if (!slot || !source) {
        return;
      }

      const desktopQuery = window.matchMedia('(min-width: 960px)');
      const syncIncluded = () => {
        if (!desktopQuery.matches) {
          slot.innerHTML = '';
          slot.setAttribute('hidden', 'hidden');
          source.classList.remove('product-hero__included--relocated');
          return;
        }

        if (!slot.firstElementChild) {
          const clone = source.cloneNode(true);
          clone.removeAttribute('data-included-desktop-source');
          clone.classList.add('product-hero__included--desktop-clone');
          slot.replaceChildren(clone);
        }

        slot.removeAttribute('hidden');
        source.classList.add('product-hero__included--relocated');
      };

      if (slot.dataset.syncBound !== 'true') {
        slot.dataset.syncBound = 'true';
        if (typeof desktopQuery.addEventListener === 'function') {
          desktopQuery.addEventListener('change', syncIncluded);
        } else if (typeof desktopQuery.addListener === 'function') {
          desktopQuery.addListener(syncIncluded);
        }
      }

      syncIncluded();
    };

    const bindRoutineVideos = (root) => {
      const pauseOtherVideos = (activeVideo) => {
        root.querySelectorAll('[data-proof-video]').forEach((video) => {
          if (video === activeVideo) {
            return;
          }

          video.pause();
        });
      };

      root.querySelectorAll('[data-proof-video-shell]').forEach((shell) => {
        if (shell.dataset.videoBound === 'true') {
          return;
        }
        shell.dataset.videoBound = 'true';

        const video = shell.querySelector('[data-proof-video]');
        const toggle = shell.querySelector('[data-proof-video-toggle]');
        if (!video || !toggle) {
          return;
        }

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          shell.classList.toggle('is-playing', isPlaying);
          toggle.setAttribute('aria-label', isPlaying ? 'Pause customer routine video' : 'Play customer routine video');
        };

        toggle.addEventListener('click', () => {
          if (!video.paused && !video.ended) {
            video.pause();
            return;
          }

          pauseOtherVideos(video);
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });

        video.addEventListener('click', () => {
          if (!video.paused && !video.ended) {
            video.pause();
          }
        });

        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', () => {
          video.currentTime = 0;
          syncState();
        });

        syncState();
      });
    };

    const bindReviewWidget = (root) => {
      const reviewWidget = root.querySelector('[data-pdp-proof-reviews]');
      if (!reviewWidget) {
        return;
      }
      const pager = root.querySelector('[data-pdp-proof-pagination]');
      let isInitializing = false;

      const initialize = () => {
        if (isInitializing) {
          return;
        }

        isInitializing = true;
        const didSortChange = enforceHighestRatingSort(reviewWidget);
        const result = asFiveStarList(reviewWidget, pager);
        isInitializing = false;

        if (didSortChange || result.didReorder) {
          window.setTimeout(initialize, 450);
        }
      };

      if (reviewWidget.dataset.observerBound !== 'true') {
        reviewWidget.dataset.observerBound = 'true';
        const observer = new MutationObserver(initialize);
        observer.observe(reviewWidget, { childList: true, subtree: true });
      }

      initialize();
      window.setTimeout(initialize, 700);
      window.setTimeout(initialize, 1500);
      window.setTimeout(initialize, 2800);
    };

    const bindFaq = (root) => {
      const faqRoot = root.querySelector('[data-faq-root]');
      if (!faqRoot) {
        return;
      }

      const items = Array.from(faqRoot.querySelectorAll('.pdp-proof__faq-item'));
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) {
            return;
          }

          items.forEach((other) => {
            if (other !== item) {
              other.open = false;
            }
          });
        });
      });
    };

    roots.forEach((root) => {
      bindDesktopIncluded(root);
      bindRoutineVideos(root);
      bindReviewWidget(root);
      bindFaq(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prelander-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const updateStickyCta = () => {
      const stickyCta = document.querySelector('[data-prelander-sticky-cta]');
      if (!stickyCta) {
        return;
      }

      if (!mobileQuery.matches) {
        stickyCta.classList.remove('is-visible');
        return;
      }

      const ctas = Array.from(document.querySelectorAll('[data-prelander-page-cta]'));
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const hasVisibleCta = ctas.some((cta) => {
        const rect = cta.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < viewportHeight;
      });

      stickyCta.classList.toggle('is-visible', !hasVisibleCta);
    };

    document.addEventListener('DOMContentLoaded', () => {
      const heroRoot = document.querySelector('[data-best-ad-lp-hero]');
      if (!heroRoot) {
        return;
      }

      if (window.location.pathname === '/pages/best-ad-lp' && mobileQuery.matches && !window.location.hash && window.scrollY < 8) {
        window.requestAnimationFrame(() => {
          const header = document.querySelector('[data-header]');
          const announcement = document.querySelector('.announcement-bar');
          const headerOffset = (header ? header.offsetHeight : 0) + (announcement ? announcement.offsetHeight : 0);
          const scrollTarget = Math.min(headerOffset + 8, 110);
          window.scrollTo({ top: scrollTarget, left: 0, behavior: 'auto' });
          updateStickyCta();
        });
      }

      updateStickyCta();
      window.addEventListener('scroll', updateStickyCta, { passive: true });
      window.addEventListener('resize', updateStickyCta, { passive: true });

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', updateStickyCta);
      } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(updateStickyCta);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
